{
  "en": {
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/add-insurance",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/edit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/edit-insurance/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/edit",
    ":patientId/popisy-navstev": ":clientId/appointment-descriptions",
    ":serviceGroupId/upravit": ":serviceGroupId/edit",
    ":serviceId/upravit": ":serviceId/edit",
    ":stockItemId/upravit": ":stockItemId/edit",
    ":supplierId/upravit": ":supplierId/edit",
    ":userId/ordinacni-hodiny": ":userId/office-hours",
    ":userId/upravit": ":userId/edit",
    "(Přišli poprvé)": "(They came for the first time)",
    "/akce": "/actions",
    "/cekajici-pacienti": "/waiting-clients",
    "/cviky": "/exercises",
    "/domu": "/home",
    "/historie-akci": "/history-events",
    "/historie-zprav": "/messages-history",
    "/kalendar": "/calendar",
    "/moje-navstevy": "/my-appointments",
    "/moje-profily": "/my-profiles",
    "/moje-udaje": "/my-details",
    "/nastaveni": "/settings",
    "/novinky": "/news",
    "/ordinace": "/office",
    "/pacienti": "/clients",
    "/pacienti/novy": "/clients/new",
    "/platba": "/payment",
    "/pojistovny": "/insurances",
    "/profil": "/profile",
    "/pruvodce/": "/guide/",
    "/rozcestnik-pruvodce/": "/guide-index/",
    "/rozsireni-kartoteky-zdarma": "/expand-registry-free",
    "/sklad": "/storage",
    "/skupinove-navstevy/": "/group-appointments/",
    "/statistiky": "/statistics",
    "/tisk": "/print",
    "%": "%",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Good day,</div><br/>attached we are sending schedule of therapies sessions.",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Good day,</div><br/>attached we are sending the medical report from the performed therapy.",
    "1. čvrtletí": "1. quarter",
    "2. čtvrtletí": "2nd quarter",
    "3 - Úraz způsobený jinou osobou": "3 - Injury caused by another person",
    "3. čtvrtletí": "3rd quarter",
    "4 - Alkohol a omamné látky": "4 - Alcohol and drugs",
    "4. čvrtletí": "4th quarter",
    "5 - Pracovní úraz": "5 - Occupational injury",
    "6 - Sociální důvody hospitalizace": "6 - Social reasons for hospitalization",
    "60 pacientů": "60 clients",
    "7 - Porušení léčebného režimu": "7 - Violation of treatment regimen",
    "8 - Výměna komponent systému ASR_TM": "8 - Replacement of ASR_TM system components",
    "9 - Nemoc z povolání": "9 - Occupational disease",
    "A ROZŠIŘTE SI KARTOTÉKU": "EXPAND YOUR CARD_INDEX",
    "a zaplatit": "Pay",
    "a získejte neomezenou kapacitu kartotéky.": "and get unlimited client list capacity.",
    "absolvoval tyto návštěvy": "I have completed these appointments",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin has unlimited access to all features within the selected plan",
    "Adresa": "Address",
    "Adresa sídla": "Headquarters address",
    "Adresa:": "Address:",
    "Adresát": "Recipient",
    "Akce": "Action",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Enabling this makes the client portal available. When a visit for a new client or a reservation is scheduled, the client automatically receives an invitation to the client portal.",
    "Aktivní tarif": "Active plan",
    "aktualizujte": "Update",
    "anamneza": "anamnesis",
    "Anamnéza": "Anamnesis",
    "Anamnéza zatím nebyla vyplněna.": "Medical history has not been filled in yet.",
    "Anamnéza:": "Anamnesis:",
    "Anamnézu se nepodařilo načíst": "The medical history could not be loaded.",
    "Anamnézu se nepodařilo uložit": "The medical history could not be saved.",
    "Anamnézy": "Anamneses",
    "Ano": "Yes",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "Use CortexApp on social networks or anywhere on the web.",
    "Aplikovat změny na toto a všechna budoucí volna": "Apply changes to this and all future availability",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Apply changes to this and all future appointments",
    "Aplikovat změny pouze na toto volno": "Apply changes only for this availability",
    "Aplikovat změny pouze na tuto návštěvu": "Apply changes only for this appointment",
    "Archivace": "Archiving",
    "Archivovat": "Archive",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automatically sends the client information about the creation, change, or cancellation of the visit.",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Free package is limited to a maximum of 20 clients in the database by default. If you reach this limit, you have the option to increase this limit up to",
    "Bankovní údaje": "Bank details",
    "Barva": "Color",
    "Barva místnosti v kalendáři": "Room color in calendar",
    "Barva v kalendáři": "Color in the calendar",
    "Beru na vědomí": "I acknowledge",
    "bezchybně a rychle": "Flawlessly and quickly",
    "bezhotovostně": "cashless",
    "Bezplatná registrace": "Free registration",
    "Bezplatná verze aplikace umožňuje evidovat až %{count} pacientů. Pokud chcete přidávat další pacienty, aktivujte si": "The free version of the application allows you to keep records for up to %{count} clients. If you want to add more clients, activate",
    "Bodů": "Points",
    "Body": "Points",
    "Budoucí návštěvy": "Future appointments",
    "Bylo to užitečné?": "Was this helpful?",
    "Čas": "Time",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Time was successfully selected. Please select another",
    "Čas do je povinný": "Time to is mandatory",
    "Čas od je povinný": "Time from is required",
    "Čas:": "Time:",
    "Částka": "Amount",
    "Částka bude vypočítána jako celková cena všech položek.": "The amount will be calculated as the total price of all items.",
    "Částka k úhradě": "Amount to pay",
    "Částka nesmí být vyšší než cena návštěvy": "Amount cannot be higher than the visit price",
    "Čeká na autorizaci": "Awaiting authorisation",
    "Čeká na platbu": "Awaiting payment",
    "Čeká na zaplacení": "Waiting for payment",
    "Čekající": "Pending clients",
    "Čekající pacienti": "Pending clients",
    "Čekající:": "Waiting:",
    "Celkem k úhradě": "Total to pay",
    "Celkem návštěv:": "Total appointments:",
    "Celý den": "All day",
    "Cena": "Price",
    "Cena nemůže být nižší než 0": "Price cannot be lower than 0",
    "Cena nesmí být záporná": "Price cannot be negative",
    "Cena permanentky": "Season ticket price",
    "Cena s DPH": "Price with VAT",
    "Cena za MJ": "Price per unit",
    "Cena:": "Price:",
    "Certifikát": "Certificate",
    "Červená": "Red",
    "Cestovní zdravotní pojištění": "Travel health insurance",
    "Četl/a jsem a souhlasím se": "I have read and agree",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "We understand that now may not be the right time; you can return to the guide anytime, or use the tips and help.",
    "Charakter": "Character",
    "Charakter dávky": "Batch nature",
    "Chcete pokračovat v zadání návštěvy:": "Do you want to continue with scheduling the appointment:",
    "Chci naplánovat": "I want to plan",
    "chyba": "error",
    "Čísla dokladů v dávce od": "Document numbers in batch from",
    "Čísla faktur": "Invoice numbers",
    "Číslo": "Number",
    "Číslo dávky": "Batch number",
    "Číslo dokladu": "Document number",
    "Číslo pojištěnce": "Insured person number",
    "Číslo pojištěnce nemusí být správné": "The policyholder number does not have to be correct",
    "Číslo pojištěnce:": "Insured person number:",
    "Číslo pojišťenec": "Insured person number",
    "Číslo účtu": "Account number",
    "Číslovat dávky od": "Number doses from",
    "Číslovat faktury od": "Number invoices from",
    "Co je nového?": "What's new?",
    "Čtvrtek": "Thursday",
    "Čtvrtletí": "Quarters",
    "Čtvrtletní": "Quarterly",
    "cvik": "exercise",
    "Cvik": "Exercise",
    "cviků": "exercises",
    "cviky": "exercises",
    "Cviky": "Exercises",
    "Cviky na vybraný den": "Exercises for the selected day",
    "Další akce": "Another action",
    "Další krok postupu": "The next step of the procedure",
    "Další položka": "Another item",
    "Další výkon": "Another performance",
    "Data se načítají...": "Loading data...",
    "Datum": "Date",
    "Datum a čas": "Date and time",
    "Datum inventury": "Inventory date",
    "Datum je povinné": "Date is required",
    "Datum narození": "Date of birth",
    "Datum narození:": "Date of birth:",
    "Datum naskladnění": "Loading date",
    "Datum návštěvy": "Appointment date",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "The future price valid-from date cannot be in the past.",
    "Datum splatnosti:": "Due date:",
    "Datum transakce": "Transaction date",
    "Datum vystavení": "Issue date",
    "Datum začátku cvičení": "Exercise start date",
    "Datum zaplacení": "Payment date",
    "Datum zdanitelného plnění": "Taxable supply date",
    "Datum změny pojištění:": "Insurance change date:",
    "Datum změny pojišťovny": "Insurer's date of change",
    "Datum:": "Date:",
    "Dávek na stránku": "Page views",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "You sign the batch electronically in the CortexApp Signer app and CortexApp then sends it to the health insurance company.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "The batch can be sent electronically straight to the health insurance company, signed with a certificate or authorised with an SMS code.",
    "Dávku se nepodařilo vytvořit": "Reservation could not be cancelled",
    "davky": "benefits",
    "Dávky": "Benefits",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "We have queued the batches for sending to the insurance company. We will notify you of the result by e-mail.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "We cannot create benefits because we have not found any performances. Change the selection of period, insurance companies or workplace.",
    "Dávky vytvořeny": "Batches created",
    "DD.MM.RRRR": "DD.MM.YYYY",
    "Deaktivovat": "Deactivate",
    "Deaktivovat terapeuta": "Deactivate user",
    "dekujeme": "thankyou",
    "Děkujeme za vaší recenzi!": "Thank you for your review!",
    "Děkujeme za zpětnou vazbu": "Thanks for the feedback",
    "Děkujeme!": "Thank you!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Thank you! GDPR consent has been successfully confirmed.",
    "Délka (min.)": "Duration (min.)",
    "den": "day(s)",
    "Den": "Day",
    "Denně": "Daily",
    "detail": "detail",
    "Detail následující návštěvy": "Detail of the following appointment",
    "Detail návštěvy": "Appointment detail",
    "Detail poslední návštěvy": "Last appointment detail",
    "Detail rezervace": "Reservation detail",
    "Detail vybraného profilu": "Selected profile detail",
    "Diagnóza": "Diagnosis",
    "DIČ": "VAT Number/Tax ID",
    "dne": "on",
    "Dne": "On",
    "Dnes": "Today",
    "dní": "days",
    "dnů": "days",
    "dny": "days",
    "Dny": "Days",
    "Do": "To",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "No documents have been uploaded to the client's record yet.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "No photos have been uploaded to the client's record yet.",
    "Do průvodce": "To the guide",
    "Doba splatnosti": "Due date",
    "Doba trvání": "Duration",
    "Doba trvání pro pacienty": "Duration for clients",
    "Doba trvání:": "Duration:",
    "Dobrý den": "All day",
    "Dodavatel": "Supplier",
    "Dodavatel byl úspěšně smazán": "Supplier was successfully deleted",
    "Dodavatel byl úspěšně upraven": "The reservation has been successfully created.",
    "Dodavatel byl úspěšně vytvořen": "The reservation has been successfully created.",
    "dodavatele": "Suppliers",
    "Dodavatelé": "Suppliers",
    "Dodavatele se nepodařilo smazat": "Reservation could not be cancelled",
    "Dodavatele se nepodařilo upravit": "Reservation could not be cancelled",
    "Doklady": "Documents",
    "Dokončeno": "Completed",
    "Dokončit odeslání": "Finish sending",
    "Dokončit odeslání dávky": "Finish sending the batch",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Finish sending batch no. %{number} for insurance company %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "The document was successfully uploaded and sent",
    "Dokumenty": "Documents",
    "Doplňková služba": "Additional service",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "You have reached the maximum number of clients in the record.",
    "Dosažení maximálního počtu pacientů": "Achieving maximum number of clients",
    "Dotazník": "Questionnaire",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Client questionnaire (the client will see the questionnaire in the client section, where they can fill it in)",
    "Dotazník pro pacienta": "Client questionnaire",
    "DPH": "VAT",
    "DPH%": "VAT%",
    "Druh péče": "Care type",
    "Druh péče:": "Type of care:",
    "Druh úhrady": "Payment type",
    "Druh úhrady:": "Payment type:",
    "Duplikovat": "Duplicate",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "Reservation could not be cancelled",
    "E-mail úspěšně odeslán": "E-mail successfully sent",
    "E-mailová adresa": "Email address",
    "E-mailová adresa:": "Email address:",
    "Editace údajů pacienta": "Editing client data",
    "Email": "E-mail",
    "Email byl úspěšně poslán": "E-mail successfully sent",
    "Email odeslán": "E-mail sent",
    "Export bude vygenerován a zaslán na e-mail": "Export will be generated and sent to email",
    "Exportovat": "Export",
    "Exportovat data": "Export data",
    "Exportovat PDF": "Export PDF",
    "Exportovat platby": "Export payments",
    "Exportovat výkony": "Export",
    "Faktura": "Invoice",
    "Faktura bude vygenerována a zaslána na e-mail": "Invoice will be generated and sent to email",
    "Faktura byla označena jako zaplacená": "Invoice was marked as paid",
    "Fakturace": "Invoicing",
    "Fakturace byla označena jako zaplacená": "Invoice was marked as paid",
    "Fakturace úspěšně přidána": "Invoice successfully added",
    "Fakturace úspěšně upravena": "Invoice successfully updated",
    "Fakturace za období": "Invoicing for period",
    "Fakturace za období:": "Invoicing for period:",
    "Fakturační údaje": "Billing details",
    "fakturacni-udaje": "billing-information",
    "fakturu č.": "invoice no.",
    "faktury": "invoices",
    "Faktury": "Invoices",
    "Filtrovat": "Filter",
    "Filtrovat pacienty": "Filter clients",
    "Filtrujte cviky podle jména": "Filter exercises by name",
    "finance": "finance",
    "Finance": "Finance",
    "Formulář úspěšně nahrán": "Form successfully uploaded",
    "Formuláře se nepodařilo načíst": "The forms could not be loaded",
    "Fotka FT poukazu": "FT photo voucher",
    "Fotka FT poukazu byla úspěšně nahrána": "FT voucher photo has been successfully uploaded",
    "Fotku obrazovky s Vaším sdílením": "Screenshot with your sharing",
    "Fotogalerie": "Photo Gallery",
    "fotografie": "photos",
    "Fotografie se nepodařilo načíst.": "The photograph failed to load.",
    "Fotografie smazána": "Photo deleted",
    "Fotografie úspěšně nahrána": "Photo successfully uploaded",
    "Fotografie ze dne": "Photos from day",
    "Fotografie:": "Photos:",
    "FT poukaz": "FT voucher",
    "FT poukaz byl úspěšně vytvořen": "FT voucher was successfully created",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT voucher cannot be created. Please check if everything is filled in correctly on the client card.",
    "FT poukaz úspěšně smazán": "FT voucher successfully deleted",
    "FT poukaz úspěšně upraven": "FT voucher successfully updated",
    "Fyzion funguje": "Physion works",
    "Fyzion premium function": "CortexApp premium function",
    "fyzion-faktura.pdf": "cortexapp-invoice.pdf",
    "fyzion-zalohova-faktura.pdf": "cortexapp-backup-invoice.pdf",
    "Fyzioterapeut": "Therapist",
    "Fyzioterapeut a místnost": "Therapist and room",
    "Fyzioterapeut je povinný": "Therapist is mandatory",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Therapist has no office hours filled",
    "Fyzioterapeut:": "Therapist:",
    "fyzioterapeuti": "Therapists",
    "Fyzioterapeuti": "Therapists",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Therapists successfully reset according to diagnosis",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR consent",
    "GDPR úspěšně potvrzeno.": "GDPR successfully confirmed.",
    "GDPR:": "GDPR:",
    "Google kalendář": "Google calendar",
    "Hesla se neshodují": "Passwords do not match",
    "Heslo": "Password",
    "Heslo bylo úspěšně změněno": "The password has been successfully changed",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "The password must contain at least 8 characters and at least 1 digit.",
    "Historie akcí": "Action history",
    "Historie cvičení": "Exercise history",
    "Historie emailů a SMS": "History of emails and SMS",
    "Historie návštěv": "Appointment history",
    "Historie rezervací": "Booking history",
    "Hledanému výrazu neodpovídá žádná diagnóza": "No diagnosis found for the searched term",
    "Hledanému výrazu neodpovídá žádné pracoviště": "No location matches the search term",
    "Hledanému výrazu neodpovídá žádný pacient": "No client matches the given expression",
    "Hledanému výrazu neodpovídá žádný výkon": "No results found for the given query",
    "Hodnota bodu": "Point value",
    "Hodnota bodu:": "Point value:",
    "Hotově": "Cash",
    "Hotovo": "Done",
    "Hromadné odeslání dávek pojišťovně selhalo": "Bulk sending of batches to the insurance company failed",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://www.cortexapp.eu/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://www.cortexapp.eu/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://www.cortexapp.eu/en/share-us-and-expand-your-database-for-free/",
    "https://fyzion.cz/cs/webinar/": "https://www.cortexapp.eu/en/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://www.cortexapp.eu/insurance-guide",
    "https://www.fyzion.cz/cs/navod-fyzion": "https:/www.cortexapp.eu/en/video-tutorials",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IČ": "ID/Company number",
    "IČO": "ID/Company number",
    "IČP": "IČP",
    "IČP žadatele": "Applicant's PID",
    "IČZ": "IČZ",
    "Identifikační údaje pacienta:": "Client identification data:",
    "Identifikační údaje poskytovatele:": "Provider identification data:",
    "Ignorovat automatické přepsání": "Ignore automatic overwrite",
    "info@fyzion.cz": "info@cortexapp.eu",
    "Informace o návštěvách": "Appointment information",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Information about your reservation has been sent to your e-mail",
    "inventura": "inventory",
    "Inventura": "Inventory",
    "Inventura zboží": "Inventory goods",
    "Inventura zboží úspěšně provedena": "Inventory of goods successfully done",
    "Inventuru zboží se nepodařilo uložit": "Reservation could not be cancelled",
    "Jak chcete pokračovat?": "How do you want to proceed?",
    "Jak chcete provedené změny aplikovat?": "How do you want to apply the changes?",
    "Jak navýšit limit kartotéky pacientů?": "How to increase the client database limit?",
    "Jak si přejete aplikovat tuto šablonu?": "Do you really want to overwrite the template text?",
    "Jaké služby poskytuje?": "Offered services",
    "Jakýkoliv": "Any",
    "Jde o duplicitní kartu?": "Is it a duplicate card?",
    "Jdeme na to teď!": "Let's do it now!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "If the function is enabled and the client does not have confirmed GDPR yet, the system automatically sends it to the client for confirmation one day before their future appointment.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "If this feature is turned off, the therapist can see appointments of other therapists, but cannot navigate to their detail",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "If you complete these three tasks before time runs out, you will receive a Standard plan for three months as a reward from us",
    "Jméno": "First name",
    "Jméno pojištěnce": "Insured person's name",
    "Jméno:": "Name:",
    "Jméno/název": "Name/title",
    "Jméno/Název": "Name/Title",
    "Jsou předepsané výkony": "Agreed performances",
    "K návštěvě existuje více než jedna platba": "There is more than one payment for a appointment",
    "K platbě": "To pay",
    "K poukazu zatím není zapsaný žádný výkon": "The voucher does not have any performance recorded yet",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "There are no pictures or videos available for this exercise item.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "No additional information is available for this exercise position.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "No description has been added to this appointment yet.",
    "K této recenzi nebyl přidán žádný text.": "No text has been added to this review.",
    "K vytvoření stvrzenky je potřeba návštěva": "Creating a receipt requires an appointment",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "Creating an invoice requires a client and an appointment",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Remove",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Remove batch and invoice?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Remove batch?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Do you really want to remove batch no. %{batchNumber} and invoice no. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Do you really want to remove batch no. %{batchNumber}?",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Batch could not be removed",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Corrective batch created",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Create corrective batch",
    "k_batches.k_batch.delete_failed.notification": "Batch could not be removed",
    "k_batches.k_batch.delete_k_batch_btn.label": "Remove batch",
    "k_batches.k_batch.delete_successful.notification": "Batch removed successfully",
    "Kalendář": "Calendar",
    "Kalendář byl úspěšně synchronizován": "Calendar was successfully synchronized",
    "Kalendář je již synchronizovaný": "Calendar is already synchronized",
    "Kapacita": "Capacity",
    "Karta klienta": "Client card",
    "Karta pacienta": "Client card",
    "karta-pacienta": "client-card",
    "karta/:patientId": "client/:patientId",
    "Kartou": "Card Payment",
    "Kartou online": "By card online",
    "Karty byly sloučeny": "Cards were merged",
    "Karty se nepodařilo sloučit": "Cards could not be merged",
    "kategorie": "category",
    "Kategorie": "Category",
    "Kdokoliv dostupný": "Anyone available",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "The client section is turned off. You can turn it on in",
    "Kód": "Code",
    "Kód ": "Code",
    "Kód a název pojišťovny": "Code and name of insurance company",
    "Kód a název zboží": "Code and name of the product",
    "Kód a název zboží, počet": "Code and name of product, quantity",
    "kód banky": "Bank code",
    "Kód banky": "Bank code",
    "Kód náhrady": "Reimbursement code",
    "Kód pojišťovny": "Insurance code",
    "Kód zboží": "Product code",
    "Konec": "The end",
    "Kontakt na pacienta": "Contact with client",
    "Kontaktní osoba": "Contact person",
    "Kontaktní údaje": "Contact details",
    "kontaktni-udaje": "contact-details",
    "Kontaktovat": "Contact",
    "Kontaktujte nás": "Contact us",
    "Kontaktujte naši podporu": "Contact our support",
    "Kredit": "Credit",
    "krok cviku": "exercise step",
    "ks": "pcs",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Subscription limit will be exceeded.",
    "Limit dlužné částky": "Limit of the amount due",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "You can increase the client limit if you help us share the app with your colleagues,",
    "Logo firmy": "Company logo",
    "mailto:info@fyzion.cz": "mailto:info@cortexapp.eu",
    "Mají tel.": "They have phone.",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "you have a scheduled appointment at the therapy office",
    "Máte objednány tyto návštěvy": "You have booked these appointments",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "You have unsaved changes, do you want to save them before leaving?",
    "Max. 9 výkonů": "performances",
    "Maximální úhrada": "Maximum payment",
    "měsíc": "month",
    "Měsíc": "Month",
    "měsíce": "months",
    "Měsíce": "Months",
    "Měsíčně": "Monthly",
    "Měsíční": "Monthly",
    "měsíců": "month(s)",
    "Město": "City",
    "mezi vaše kolegy nebo přechodem na ": "Among your colleagues or switching to",
    "mezi Vaše kolegy, nebo přechodem na ": "Among your colleagues, or transition to",
    "min": "min",
    "Min. 1 výkon": "Min. 1 action",
    "min/terapie": "min/therapy",
    "Minulý měsíc": "Last month",
    "Minulý rok": "Last year",
    "Minulý týden": "Last week",
    "minut": "minutes",
    "Místnost": "Room",
    "Místnost byla úspěšně upravena": "Room was successfully adjusted",
    "Místnost byla úspěšně vytvořena": "Room was successfully created",
    "mistnosti": "rooms",
    "Místnosti": "Rooms",
    "MJ": "Units",
    "Množství": "Quantity",
    "Modrá": "Blue",
    "Moje profily": "My profiles",
    "Moje údaje": "My details",
    "Momentálně využívá": "Currently using",
    "Možnost dluhu": "Debt option",
    "Mřížka": "Grid",
    "Musí být alespoň 1": "Must be at least 1",
    "Musí být menší než 1000.": "It must be greater than 0.",
    "Musí být větší než 0.": "It must be greater than 0.",
    "Muž": "Male",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "You can insert an image with your stamp or signature, which will then be inserted on the generated documents for clients.",
    "Muži": "Men",
    "Muži (budoucí)": "Men (scheduled)",
    "na info@fyzion.cz.": "at info@cortexapp.eu.",
    "Nabízené permanentky": "Offered memberships",
    "Nabízené služby": "Offered services",
    "Načíst další": "Load more",
    "Načíst údaje z ARES": "Load data from ARES",
    "Nadcházející návštěva": "Next appointment",
    "Nadpis bloku": "Block heading",
    "Nahrané dokumenty zde není možné vidět.": "Uploaded documents cannot be viewed here.",
    "Nahrání obrázku se nezdařilo": "Image upload failed.",
    "Nahrát dávku do Purobota": "Upload batch to Purobot",
    "Nahrát fotku": "Upload photo",
    "Nahrát soubor": "Upload file",
    "Nahrát soubor typu jpeg nebo png": "Upload file of type jpeg or png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Uploading files, please do not close the page...",
    "Nákupní (s DPH)": "Shopping (VAT included)",
    "Nákupní cena a počet": "Purchase price and quantity",
    "Nákupní cena s DPH": "Purchase price with VAT",
    "Nákupní hodnota (s DPH)": "Purchase value (VAT included)",
    "Napište nám na email:": "Write to us at email:",
    "Napište poznámku…": "Write a note…",
    "Naplánovat změnu ceny od zvoleného data": "Schedule a price change from the selected date",
    "např. číslo dávky, dokladu, pojištěnce": "For example batch number, document, insured person",
    "Např. kód, název zboží": "For example, code, item name",
    "např. název, IČP, telefonní číslo": "e.g. name, IC, phone number",
    "např. název, instituce, IČO": "e.g. client",
    "např. RČ pacienta, e-mail": "e.g. name, email",
    "Např. RČ pacienta, e-mailová adresa": "E.g. client's ID, email address",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "Share our application or Facebook group Cortex online. For each such share, we will extend your client list by another five clients for free. As a confirmation of your share, please send us a screenshot of the shared post to info@cortexapp.eu and specify which therapist it concerns.",
    "naskladneni": "stocking",
    "Naskladnění": "Stocking",
    "Naskladnění zboží": "Goods receipt",
    "Následující návštěva:": "Next appointment:",
    "Nasmlouvané výkony": "Agreed performances",
    "nastaveni": "settings",
    "Nastavení": "Settings",
    "Nastavení - Fakturační údaje": "Settings - Invoicing details",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "SETTINGS - CONTACT DETAILS.",
    "Nastavení nového hesla": "Setting a new password",
    "Nastavení předplatného": "Subscription settings",
    "Nastavení uloženo": "Settings saved",
    "Nastavit": "Set up",
    "Návod": "Guide",
    "Návrat do aplikace": "Return to application",
    "Návštěv na stránku": "Appointment to page",
    "návštěva": "appointment",
    "Návštěva": "Appointment",
    "Návštěva byla označena jako zaplacená": "Appointment was marked as paid",
    "Návštěva byla úspěšně zaplacena": "Appointment was successfully paid",
    "Návštěva je zamknuta": "Appointment is locked",
    "Návštěva nenalezena": "Appointment not found",
    "Návštěva obsahuje nahrané formuláře": "Appointment contains uploaded forms",
    "Návštěva obsahuje nahrané fotografie": "Appointment contains uploaded photos",
    "Návštěva odemknuta": "Appointment unlocked",
    "Návštěva pacienta": "Client appointment",
    "Návštěva smazána": "Appointment deleted",
    "Návštěva úspěšně přidána": "Appointment successfully added",
    "Návštěva zamknuta": "Appointment locked",
    "navsteva/:patientId/:visitId": "appointment/:patientId/:visitId",
    "Návštěvu se nepodařilo uložit": "Reservation could not be cancelled",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Reservation could not be cancelled",
    "navstevy": "appointments",
    "Návštěvy": "Appointments",
    "návštěvy pacientů": "client appointments",
    "Návštěvy pacientů": "Client appointments",
    "Návštěvy podle fyzioterapeutů": "Appointments by therapists",
    "návštěvy vloží do správné karty.": "Insert appointments into the correct tab.",
    "navstevy-pacienta": "client-appointments",
    "Návštěvy:": "Appointments:",
    "Název": "Title",
    "Název cviku": "Exercise name",
    "Název firmy": "Company name",
    "Název instituce": "Customer/Client name",
    "Název kategorie": "Category title",
    "Název kliniky": "Company name",
    "Název místnosti": "Room name",
    "Název permanentky": "Membership title",
    "Název podkategorie": "Subcategory title",
    "Název pojišťovny": "Insurance company name",
    "Název pracoviště": "Location name",
    "Název předplatného": "Subscription title",
    "Název šablony": "Template name",
    "Název služby": "Service name",
    "Název zboží": "Product title",
    "Ne": "No",
    "nebo": "or",
    "nebo přechodem na pokročilý tarif. ": "Or by switching to advanced tariff.",
    "Nebyly nalezeny žádné recenze.": "No reviews found",
    "Neděle": "Sunday",
    "Nedorazil:": "Client did not arrive:",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "At least 8 characters and at least 1 lowercase letter",
    "Nejsou dostupné žádné místnosti": "No rooms available",
    "Nejsou dostupné žádné předplatné": "No subscription available",
    "Nejsou dostupné žádné transakce": "No transactions available",
    "Nejsou dostupní žádní uživatelé": "No users available",
    "Nejsou dostupní žádní žadatelé": "No applicants available",
    "Nejsou k dispozici žádná data": "No data available",
    "Některé funkce aplikace Fyzion vám": "Some functions of CortexApp",
    "Některé z povinných údajů chybí": "Some of the required information is missing",
    "Nelze odebrat zamčený výkon": "No document found",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "It is not possible to reschedule the availability to another therapist.",
    "Nelze smazat - zboží je na skladě.": "Cannot delete - product is in stock.",
    "Nemají tel.": "They don't have phone.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "You do not have sufficient permission to perform this action.",
    "Nemáte oprávnění na smazání cizí návštěvy": "You are not authorized to delete someone else's appointment",
    "Nemáte oprávnění na smazání návštěvy": "You are not authorized to delete a appointment",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "You do not have permission to edit another therapist",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "You do not have permission to edit other appointment slots",
    "Nemáte oprávnění na úpravu permanentky": "You do not have permission to edit the season pass",
    "Nemáte oprávnění na úpravu služby": "You do not have permission to modify service",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "You are not authorized to pay for someone else's appointment",
    "Nemáte oprávnění na zrušení cizí návštěvy": "You are not authorized to cancel someone else's appointment",
    "Nemáte oprávnění pro odemknutí výkonu": "You do not have permission to unlock performance",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "You do not have permission to see medical history",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "You do not have a contract created with this insurance company. A claim will not be created for this insurance company.",
    "Nemáte žádné objednané návštěvy.": "You have no booked appointments.",
    "nemusí správně fungovat.": "It does not have to work correctly.",
    "Nemůže být záporné": "It can't be negative",
    "Nenalezen žádný dodavatel": "No supplier found",
    "Nenalezen žádný doklad": "No document found",
    "Nenalezen žádný pacient": "No client found",
    "Nenalezen žádný výkon": "No document found",
    "Nenalezena shoda se jménem žádného cviku.": "No match found for any exercise name.",
    "Nenalezena žádná akce": "No action found",
    "Nenalezena žádná dávka": "No batch found",
    "Nenalezena žádná návštěva": "No appointment found",
    "Nenalezena žádná pracoviště": "No locations found",
    "Nenalezena žádná šablona": "No template found",
    "Nenalezena žádná stvrzenka": "No receipt found",
    "Nenalezena žádná zpráva": "No message found",
    "Nenalezeno žádné další zboží": "No more items found",
    "Nenalezeny žádné další služby": "No additional services found",
    "Nenalezeny žádné položky": "No items found",
    "Nenalezeny žádné zásoby": "No resources found",
    "Není dostupný žádný platný FT poukaz": "No subscription available",
    "Není dostupný žádný výkon": "Power is not available",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "It is not possible to change the tariff because you have multiple clients in the database,",
    "Není nahrána žádná fotka": "No photo uploaded",
    "Není naplánována další návštěva": "No further appointment scheduled",
    "Neočekávaná chyba": "Unexpected error",
    "Neomezený počet pacientů": "Unlimited number of clients",
    "Neopakuje se": "Non-recurring",
    "Neplátce DPH": "Non-VAT payer",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Failed to update exercises in appointment",
    "Nepodařilo se aktualizovat den se cvičením": "Failed to update exercise day",
    "Nepodařilo se aktualizovat šablonu": "Failed to update the template.",
    "Nepodařilo se načíst budoucí návštěvy.": "Failed to load upcoming appointments.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Failed to load total values of stocked items",
    "Nepodařilo se načíst cviky": "Failed to load exercises",
    "Nepodařilo se načíst data": "Failed to load data",
    "Nepodařilo se načíst data ze systému": "Failed to load data",
    "Nepodařilo se načíst dávku": "Failed to load data",
    "Nepodařilo se načíst dávky": "Failed to load data",
    "Nepodařilo se načíst diagnózy": "Failed to load diagnoses",
    "Nepodařilo se načíst dodavatele": "Failed to load data",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Unable to load available therapists",
    "Nepodařilo se načíst FT poukazy": "Failed to load services",
    "Nepodařilo se načíst hromadnou návštěvu": "Failed to load data",
    "Nepodařilo se načíst kategorie cviků": "Failed to load exercise categories",
    "Nepodařilo se načíst kategorii cviků": "Failed to load exercise category",
    "Nepodařilo se načíst místnost": "Failed to load room",
    "Nepodařilo se načíst místnosti": "Failed to load rooms",
    "Nepodařilo se načíst návštěvu pacienta": "Failed to load client appointment",
    "Nepodařilo se načíst návštěvy pacienta": "Failed to load client appointments",
    "Nepodařilo se načíst novinku": "Failed to load the news item",
    "Nepodařilo se načíst novinky": "Failed to load the news items",
    "Nepodařilo se načíst odbornosti": "Failed to load data",
    "Nepodařilo se načíst ordinaci na této adrese": "Unable to load office at this address",
    "Nepodařilo se načíst pacienty": "Failed to load clients",
    "Nepodařilo se načíst permanentku": "Failed to load data",
    "Nepodařilo se načíst permanentky pacienta": "Failed to load client's subscriptions",
    "Nepodařilo se načíst platbu": "Failed to load payment",
    "Nepodařilo se načíst platby": "Failed to load payments",
    "Nepodařilo se načíst platební údaje": "Failed to load payment data",
    "Nepodařilo se načíst pojišťovnu": "Failed to load data",
    "Nepodařilo se načíst pojišťovny": "Failed to load services",
    "Nepodařilo se načíst položku": "Failed to load services",
    "Nepodařilo se načíst pracoviště": "Failed to load data",
    "Nepodařilo se načíst předplatné": "Failed to load subscription",
    "Nepodařilo se načíst recenze": "Failed to load reviews",
    "Nepodařilo se načíst šablonu": "Failed to load template",
    "Nepodařilo se načíst šablony": "Failed to load templates",
    "Nepodařilo se načíst seznam diagnóz": "Failed to load diagnoses",
    "Nepodařilo se načíst seznam návštěv.": "Failed to load upcoming appointments.",
    "Nepodařilo se načíst seznam uživatelů": "Failed to load list of users",
    "Nepodařilo se načíst skupiny služeb": "Failed to load services",
    "Nepodařilo se načíst služby": "Failed to load services",
    "Nepodařilo se načíst transakce": "Failed to load transactions",
    "Nepodařilo se načíst transakci": "Failed to load transaction",
    "Nepodařilo se načíst volné termíny": "Failed to load available dates",
    "Nepodařilo se načíst výkony": "Failed to load performances",
    "Nepodařilo se načíst žadatele": "Failed to load applicant",
    "Nepodařilo se načíst zásoby": "Failed to load services",
    "Nepodařilo se načíst zemi": "Failed to load country",
    "Nepodařilo se nahrát dávku do Purobota": "Failed to upload batch to Purobot",
    "Nepodařilo se nahrát fotku FT poukazu": "Failed to upload FT voucher photo",
    "Nepodařilo se nahrát soubor": "Failed to upload the file",
    "Nepodařilo se odemknout výkon": "Failed to unlock the performance",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Failed to save note. Please try again.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Failed to load data",
    "Nepodařilo se přidat fakturaci": "Failed to add billing",
    "Nepodařilo se přidat předplatné": "Failed to add subscription",
    "Nepodařilo se smazat cvik": "Failed to delete exercise",
    "Nepodařilo se smazat platbu": "Failed to load data",
    "Nepodařilo se smazat pojišťovnu": "Failed to delete insurance",
    "Nepodařilo se smazat pracoviště": "Failed to load data",
    "Nepodařilo se smazat předplatné": "Failed to delete subscription",
    "Nepodařilo se smazat recenzi": "Failed to load data",
    "Nepodařilo se smazat šablonu": "Failed to delete the template",
    "Nepodařilo se uložit pracoviště žadatele": "Failed to save the applicant's workplace.",
    "Nepodařilo se upravit cvik.": "Failed to modify the exercise.",
    "Nepodařilo se upravit dostupnost": "Failed to update availability.",
    "Nepodařilo se upravit fakturaci": "Failed to update billing",
    "Nepodařilo se upravit místnost": "Failed to update the room",
    "Nepodařilo se upravit platbu": "Failed to update payment",
    "Nepodařilo se upravit předplatné": "Failed to update subscription",
    "Nepodařilo se vygenerovat export": "Failed to generate export",
    "Nepodařilo se vygenerovat fakturu": "Failed to load data",
    "Nepodařilo se vygenerovat platební odkaz": "Failed to generate payment link",
    "Nepodařilo se vygenerovat zprávu": "Failed to generate report",
    "Nepodařilo se vytvořit cvik.": "Failed to create an exercise.",
    "Nepodařilo se vytvořit dodavatele": "Failed to load data",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Failed to load data",
    "Nepodařilo se vytvořit kategorii.": "Failed to create a category.",
    "Nepodařilo se vytvořit místnost": "Failed to create the room",
    "Nepodařilo se vytvořit platbu": "Failed to create the payment",
    "Nepodařilo se vytvořit pracoviště žadatele": "Failed to create the applicant's workplace",
    "Nepodařilo se vytvořit šablonu": "Failed to create the template.",
    "Nepodařilo se vytvořit uživatele": "Failed to create user",
    "Nepodařilo se zaplatit návštěvu": "Failed to pay for the appointment",
    "Nepodařilo se získat cviky pacienta": "Unable to obtain the client's exercises",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Failed to change the client's reservation settings.",
    "Nepodařilo se zrušit platbu": "Failed to cancel payment",
    "Nepodařilo se zrušit platbu za návštěvu": "Failed to cancel the payment for the appointment",
    "Nepodporovaný typ prohlížeče": "Unsupported browser type",
    "nepodporovaný typ prohlížeče.": "Unsupported browser type.",
    "Nepovinné": "Optional",
    "Nepravidelné ordinační hodiny": "Irregular office hours",
    "Nepřišel": "He did not come",
    "Nesouhlasili": "Did not agree",
    "Neuhrazeno": "Unpaid",
    "Neukládat": "Do not save",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Do not you know how to do it? Check out our guide, sign up for a webinar or contact support.",
    "Nevystaveno": "Not issued",
    "Nezaplaceno": "Unpaid",
    "nova": "new",
    "Nová cena": "New price",
    "Nová cena s DPH": "New price with VAT",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "The new price applies to visits from the selected date. Until then, the current service price applies. Turning this off cancels the scheduled change.",
    "Nová fakturace": "New invoicing",
    "Nová místnost": "New room",
    "Nová návštěva": "New appointment",
    "Nová operace": "New operation",
    "Nová šablona": "New template",
    "Nová skupinová návštěva": "New group appointment",
    "Nová událost": "New event",
    "nova-navsteva": "new-appointment",
    "nova-opravna": "new-repair",
    "nova-skupinova-navsteva": "new-group-appointment",
    "nove": "new",
    "Nové heslo": "New password",
    "Nové pracoviště žadatele": "Applicant's new workplace",
    "Nové předplatné": "New subscription",
    "Novinky": "News",
    "novy": "new",
    "Nový pacient": "New client",
    "Nový žadatel": "New applicant",
    "novy-ft-poukaz": "new-ft-voucher",
    "O nás": "About us",
    "Období": "Period",
    "obecne": "currently",
    "Obecné": "General",
    "obecném nastavení": "general settings",
    "Objednat návštěvu": "Book an appointment",
    "Objednat se na": "Book an appointment",
    "Objekt": "Service",
    "Obměna": "Variation",
    "obnova-hesla": "password-reset",
    "Obrázek byl smazán": "Image was deleted",
    "Obrázky": "Pictures",
    "Obsah": "Content",
    "Ochrana osobních údajů": "Personal data protection",
    "Od": "From",
    "Odběratel/klient": "Customer/client",
    "Odběratel/Klient": "Customer/Client",
    "Odbornost": "Expertise",
    "Odcvičeno a přejít na další cvik": "Completed and proceed to the next exercise",
    "Odebrat": "Remove",
    "Odebrat pacienta": "Remove client",
    "Odebrat položku": "Remove item",
    "Odebrat výkon": "Remove power",
    "Odemknout": "Unlock",
    "Odemknout výkon": "Unlock power",
    "Odesílat email": "Send email",
    "Odesílat připomínku e-mailem": "Send e-mail reminder",
    "Odesílat SMS": "Send SMS",
    "Odesílat SMS předem": "Send SMS in advance",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Send e-mail notification about visit creation, change, or cancellation",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "We have sent you an email with instructions to reset your password.",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Sending batches with SMS code login is not supported at the moment.",
    "Odeslání dávky pojišťovně selhalo": "Sending the batch to the insurance company failed",
    "Odeslání emailu": "Sending email",
    "Odeslání emailu 1 pacientovi": "Sending email 1 to client",
    "Odeslání emailu pacientovi": "Sending email to client",
    "Odeslání SMS": "Sending SMS",
    "Odeslání SMS 1 pacientovi": "Sending SMS 1 to client",
    "Odeslání SMS pacientovi": "Sending SMS to client",
    "Odeslání zůstalo nedokončené": "Sending was left unfinished",
    "Odesláno": "Sent",
    "Odesláno na ": "Sent to",
    "Odeslat": "Send",
    "Odeslat 1 stvrzenku": "Send 1 receipt",
    "Odeslat email": "Send email",
    "Odeslat GDPR mailem": "Send GDPR by email",
    "Odeslat klientovi": "Send to client",
    "Odeslat pacientovi": "Send to client",
    "Odeslat potvrzení o platbě": "Send payment confirmation",
    "Odeslat SMS": "Send SMS",
    "Odeslat znovu emailem": "Send email again",
    "odešlete": "Send",
    "Odhlásit": "Sign out",
    "Odkaz na rezervaci byl zkopírován do schránky": "The reservation link has been copied to the clipboard.",
    "Odkud jste se o nás dozvěděli?": "Where did you hear about us?",
    "Odstranit časový interval": "Remove time interval",
    "Ohodnoťte kvalitu naší služby": "Rate the quality of our service",
    "Online platba": "Online Payment",
    "Opakování": "Recurrence",
    "Opakovat heslo": "Repeat password",
    "Opakovat jednou za": "Repeat once after",
    "Opravdu si přejete archivovat pacienta?": "Do you really want to archive the client?",
    "Opravdu si přejete formulář smazat?": "Do you really want to delete the form?",
    "Opravdu si přejete fotografii smazat?": "Do you really want to delete the photograph?",
    "Opravdu si přejete FT poukaz smazat?": "Do you really want to delete FT voucher?",
    "Opravdu si přejete obrázek smazat?": "Are you sure you want to delete the image?",
    "Opravdu si přejete pacienta odebrat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete permanentku smazat?": "Do you really want to delete the season pass?",
    "Opravdu si přejete platbu zrušit?": "Do you really want to cancel the payment?",
    "Opravdu si přejete pojišťovnu smazat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete pracoviště smazat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete recenzi smazat?": "Do you really want to delete the vacation?",
    "Opravdu si přejete rezervaci zrušit?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete šablonu smazat?": "Do you really want to delete the template?",
    "Opravdu si přejete smazat cvik": "Do you really want to delete the exercise",
    "Opravdu si přejete smazat kategorii cviků?": "Do you really wish to delete the exercise category?",
    "Opravdu si přejete smazat kategorii služeb": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete smazat platbu č.": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete smazat předplatné": "Are you sure you want to delete subscription",
    "Opravdu si přejete smazat službu": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete stornovat stvrzenku?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete synchronizaci odebrat?": "Do you really want to remove the synchronization?",
    "Opravdu si přejete terapeuta deaktivovat?": "Are you sure you want to deactivate user?",
    "Opravdu si přejete video smazat?": "Do you really want to delete the video?",
    "Opravdu si přejete volno smazat?": "Do you really want to delete the vacation?",
    "Opravná": "Correction",
    "Opravná dávka": "Correction batch",
    "Opustit průvodce": "Exit the guide",
    "Ordinace": "Practice",
    "ordinační hodiny": "Working hours",
    "Osobní údaje": "Personal data",
    "Ostatní diagnózy": "Other diagnoses",
    "Ostatní služby": "Other services",
    "Otevírací doba": "Opening hours",
    "Otevřeno": "Open",
    "Otevřít návštěvu": "Open the visit",
    "Otevřít v novém okně": "Open in new window",
    "Ověření": "Authorisation",
    "Označit jako zaplacené": "Mark as paid",
    "Pacient": "Client",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Client has been archived. If you want to restore his card, please contact support",
    "Pacient byl úspěšně přidán": "Client was successfully added",
    "Pacient ještě nepotvrdil GDPR": "Client has not confirmed GDPR yet",
    "Pacient již GDPR potvrdil": "Client has already confirmed GDPR",
    "Pacient má platný FT poukaz do %{date}.": "Client has valid FT voucher until %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Client has no upcoming appointment",
    "Pacient odebrán": "Client taken",
    "Pacient odhlášen z odběru novinek": "Client unsubscribed from newsletter",
    "Pacient přídán": "Client added",
    "Pacient přihlášen k odběru novinek": "Client subscribed to newsletter",
    "Pacient úspěšně archivován": "Client successfully archived",
    "Pacient úspěšně odebrán z čekajících pacientů": "Client successfully removed from waiting clients",
    "Pacient úspěšně přidán do čekajících pacientů": "Client successfully added to waiting clients",
    "Pacient úspěšně upraven": "Client successfully adjusted",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "The client does not have any appointment or related descriptions here yet.",
    "Pacienta se nepodařilo archivovat": "Failed to archive client",
    "Pacienta se nepodařilo odebrat": "Reservation could not be cancelled",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "The client could not be added to the waiting list. Please try again.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "The client could not be signed up for newsletter. Please try again.",
    "Pacienti": "Clients",
    "Pacienti, kteří přišli poprvé": "New clients",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "We will send the client a payment confirmation to their email",
    "Pacientů na stránku": "Clients to page",
    "pacientům": "clients",
    "Paragon": "Receipt",
    "paragon č.": "receipt no.",
    "Paragony": "Receipts",
    "Parametry příští návštěvy upraveny": "Next appointment parameters updated",
    "Pátek": "Friday",
    "Patička faktury": "Invoice footer",
    "Paušální": "Flat",
    "PDF": "PDF",
    "Permanentka aktualizována": "Subscription updated",
    "Permanentka byla označena jako zaplacená": "Subscription was marked as paid",
    "Permanentka úspěšně odebrána pacientovi.": "Subscription successfully removed for the client.",
    "Permanentka úspěšně přidána pacientovi.": "Pass successfully added to the client.",
    "Permanentka úspěšně vytvořena": "Subscription successfully created",
    "Permanentkou": "Membership",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Failed to collect the subscription from the client. Please try again.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Failed to add subscription to the client. Please try again.",
    "Permanentku se nepodařilo upravit.": "Reservation could not be cancelled",
    "Permanentku se nepodařilo vytvořit": "Failed to create the membership",
    "Permanentky": "Memberships",
    "placený tarif": "a paid plan",
    "planovani": "planning",
    "Plánování": "Planning",
    "planovani-mistnosti": "room-planning",
    "Platba": "Payment",
    "Platba byla smazána": "Payment was deleted",
    "Platba byla zrušena": "Payment was canceled",
    "Platba předplatným": "Subscription",
    "Platba za návštěvu byla úspěšně zrušena": "Payment for the appointment was successfully canceled",
    "platby": "payments",
    "Platby": "Payments",
    "Platby za pronájem aplikace": "CortexApp payments",
    "Plátce DPH": "VAT payer",
    "Plateb na stránku": "Payment for page",
    "Platební informace": "Payment information",
    "Platná do:": "Expiry date:",
    "Platnost (v měsících)": "Validity (in months)",
    "Platnost do": "Expiry date",
    "Platnost musí být větší nebo rovna 1.": "Validity must be greater than or equal to 1.",
    "Platnost nové ceny od": "New price valid from",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Your link has expired. Please request a new password setup",
    "Po": "After",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "After the reservation, you will be redirected to the payment gateway to pay for the therapy.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "After the visit ends, a feedback request is automatically sent to the client.",
    "Po sloučení se všechny minulé i budoucí": "After merging all past and future",
    "Po třech dnech": "After three days",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "After inserting the code into your website, a reservation window will appear",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "After inserting the code into your website, a reservation button will be displayed",
    "pobočka": "branch",
    "Pobočka": "Branch",
    "pobocky": "branches",
    "Pobočky": "Branches",
    "Počet": "Quantity",
    "Počet dní do konce:": "Number of days left:",
    "Počet návštěv": "Number of appointments",
    "Počet návštěv musí být větší nebo rovno 1.": "The number of appointments must be greater than or equal to 1.",
    "Počet výkonů": "Number of performances",
    "Počet zbývajících vstupů:": "Remaining inputs:",
    "Počty návštěv": "Number of appointments",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "The submission has not been sent to the insurance company. Once it is deleted, you can edit the batch and send it again.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Signing of this submission was left unfinished. You sign the batch in the CortexApp Signer app and CortexApp then sends it to the health insurance company.",
    "Podepsat a odeslat": "Sign and send",
    "Podívám se později": "I'll look later",
    "Podkategorie": "Subcategory",
    "Podmínky užití": "Terms of use",
    "Podpis/razítko firmy": "Signature/Company stamp",
    "Podpora": "Support",
    "podpora@fyzion.cz": "info@cortexapp.eu",
    "Podrobnosti": "Details",
    "Pohlaví": "Sex",
    "Pohlaví:": "Sex:",
    "Pojištění EU a mezinárodní smlouvy": "EU insurance and international agreements",
    "Pojišťovna": "Insurance",
    "Pojišťovna byla smazána": "Insurance was deleted",
    "Pojišťovna přidána": "Insurer added",
    "Pojišťovna upravena": "Insurer adjusted",
    "Pojišťovna:": "Insurance:",
    "Pojišťovnou": "By the insurance company",
    "Pojišťovny": "Insurances",
    "Pokladna": "Cash register",
    "Pokračovat": "Continue",
    "Pokročilá funkce": "Advanced feature",
    "pokročilý tarif.": "Advanced tariff.",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "If you would like to set up a different template for this message, please contact us at",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "If the client has a permanent address in the Czech Republic, enter their birth number without a slash.",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "If you work as a FO, we will include your identification details in the medical documentation. If not, company details will be included in the medical documentation.",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "If you ever need help in the future, you can return to theapp's guide.",
    "Pole je povinné": "The field is required",
    "Položka byla úspěšně smazána": "Item was successfully deleted",
    "Položka byla úspěšně upravena": "The reservation has been successfully created.",
    "Položka byla úspěšně vytvořena": "The reservation has been successfully created.",
    "Položku se nepodařilo smazat": "Item could not be deleted",
    "polozky": "items",
    "Položky": "Items",
    "Pondělí": "Monday",
    "Popis": "Description",
    "Popis cviku": "Exercise description",
    "Popisy návštěv": "Appointment descriptions",
    "Porovnat fotky": "Compare photos",
    "Porovnat fotografie": "Compare photos",
    "Porovnat můžete maximálně 2 fotografie.": "You can compare up to 2 photos.",
    "Porovnat vybrané fotografie": "Compare selected photos",
    "porovnavac": "comparator",
    "Porovnávač": "Comparer",
    "Poslední fakturace": "Last invoicing",
    "Poslední návštěva": "Last appointment",
    "Poslední návštěva:": "Last appointment:",
    "Potvrdit": "Confirm",
    "Potvrdit nové heslo": "Confirm new password",
    "Potvrďte nové heslo": "Confirm new password",
    "Potvrzení GDPR před návštěvou fyzioterapie": "GDPR confirmation before attending therapy",
    "Potvrzení o podstoupené péči": "Confirmation of care received",
    "Potvrzení zrušení platby": "Payment cancellation confirmation",
    "potvrzeni-pece/:patientId": "appointments-confirmation/:patientId",
    "Potvrzeno": "Confirmed",
    "Potvrzuji": "I confirm",
    "Potvrzuji, že pacient": "I confirm that the client",
    "Používáte": "You use",
    "Povolit online rezervace": "Enable online bookings",
    "Povolit rezervace": "Allow bookings",
    "Povolit rezervace na státní svátky": "Allow bookings on public holidays",
    "Povolit zobrazení detailu cizí návštěvy": "Permission to view Client Cards of other users",
    "Povolit zrušení rezervace": "Allow booking cancellation",
    "Poznámka": "Note",
    "Poznámka k návštěvě": "Appointment note",
    "Poznámka úspěšně smazána": "Note successfully deleted",
    "Poznámka úspěšně uložena": "Note successfully saved",
    "Poznámka:": "Note:",
    "Poznámku se nepodařilo uložit": "The note could not be saved",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Failed to save note. Please try again.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Beware, you are approaching the maximum number of clients.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Beware, you are approaching the maximum number of clients.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Beware, you are about to pay for an appointment that has not happened yet.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Beware! You are trying to create an appointment that violates the settings for Therapist, Service or Room or there is a calendar conflict.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Warning! You are editing a global exercise created by the CortexApp. Saving this modification will create a duplicate exercise in the database. The original exercise will remain unchanged.",
    "pracoviste": "workplace",
    "Pracoviště": "Location",
    "Pracoviště bylo smazáno": "Location was deleted",
    "Pracoviště pro pojišťovny": "Reservation successfully created",
    "Pracoviště upraveno": "Location adjusted",
    "Pracoviště vytvořeno": "Reservation successfully created",
    "Pracoviště žadatele bylo úspěšně uloženo": "Applicant's workplace was saved successfully",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Applicant's workplace was created successfully",
    "Pracovní dny": "Working days",
    "Pracovní doba": "Working hours",
    "Pracovníci": "Workers",
    "Pracuji jako fyzická osoba": "I work as a natural person",
    "Pravidelné terapie": "Regular therapies",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Before visiting the clinic, please review the GDPR policy. To view the full text and confirm, click",
    "Před pokračováním vyplňte formulář": "Fill in the form before proceeding",
    "Před pokračováním zadejte rodné číslo": "Enter your birth number before proceeding.",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Before registration, you must confirm your consent to the General Terms and Conditions",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Thank you in advance and I look forward to your appointment.",
    "Předmět": "Subject",
    "Předmět emailu": "Email subject",
    "předplacené (permice)": "Prepaid (Membership)",
    "predplatne": "subscription",
    "Předplatné": "Subscription",
    "Předplatné smazáno": "Subscription deleted",
    "Předplatné úspěšně přidáno": "Subscription successfully added",
    "Předplatné úspěšně upraveno": "Subscription successfully updated",
    "Předplatných na stránku": "Subscriptions on page",
    "Předplatným": "Subscription",
    "Předvolba": "Dialcode",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Code entered at %{time} is prefilled. It is usually valid for 30 minutes.",
    "Preferovaná místnost": "Preferred room",
    "Přehled cviků": "Exercise overview",
    "Přehled dávek": "Benefits overview",
    "Přehled položek": "Items overview",
    "Přehled pracovišť": "Locations overview",
    "Přehled transakcí": "Transaction overview",
    "Přejete si vystavit doklad?": "Do you want to issue a document?",
    "Přejete si vystavit fakturu na storno poplatek?": "Do you want to issue an invoice for the cancellation fee?",
    "Přejete si vystavit storno doklad?": "Do you want to issue a refund receipt?",
    "Přejít do aplikace": "Go to the app",
    "Přejít do profilu": "Go to profile",
    "Přejít na tarif": "Switch to plan",
    "Premium registrace": "Premium registration",
    "Přeskočit": "Skip",
    "Přesunout rezervaci": "Reschedule reservation",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Move some clients to archive and then reorder the tariff again.",
    "Převodem": "Bank transfer",
    "Převodem (QR kód)": "Bank transfer (QR code)",
    "Přidán na seznam": "Added to the list",
    "Přidáním dalšího fyzioterapeuta bude do konce aktuálního účtovacího období účtován poměrný poplatek za nového uživatele dle platného ceníku. Od následujícího fakturačního období bude tento uživatel automaticky zahrnut do standardní fakturace.": "Adding another therapist will incur a pro-rata fee for the new user according to the current price list until the end of the current billing period. From the next billing period, this user will be automatically included in standard billing.",
    "Přidat": "Add",
    "Přidat 3 pacienty": "Add 3 clients",
    "Přidat časový interval": "Add time interval",
    "Přidat čekajícího": "Add pending client",
    "Přidat cvik": "Add exercise",
    "Přidat dodavatele": "Add supplier",
    "Přidat dokument": "Add document",
    "Přidat doplňkový text do e-mailů klientům": "Add additional text to client emails",
    "Přidat fotku": "Add photo",
    "Přidat FT poukaz": "Add FT voucher",
    "Přidat fyzioterapeuta": "Add therapist",
    "Přidat k návštěvě": "Add to appointment",
    "Přidat kategorii": "Add category",
    "Přidat místnost": "Add room",
    "Přidat návštěvu": "Add appointment",
    "Přidat nového čekajícího": "Add new pending client",
    "Přidat nového pacienta": "Add new client",
    "Přidat pacientovi permanentku": "Add subscription to the client",
    "Přidat peníze": "Add money",
    "Přidat permanentku": "Add membership",
    "Přidat platbu": "Add payment",
    "Přidat podkategorii": "Add subcategory",
    "Přidat pojišťovnu": "Add insurance",
    "Přidat položku": "Add item",
    "Přidat poznámku": "Add note",
    "Přidat pracoviště": "Add workplace",
    "Přidat předplatné": "Add subscription",
    "Přidat skupinovou návštěvu": "Add group appointment",
    "Přidat službu": "Add service",
    "Přidat soubor": "Add file",
    "Přidat výkon": "Add power",
    "pridat-permanentku": "add-subscription",
    "pridat-volno": "add-leave",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Add your own information that clients need to know before their visit – for example where to find the entrance, what to bring, or what the cancellation terms are. The information is shown below the booking details in the visit confirmation email and in its reminder.",
    "Přihlášení jako nesprávný typ uživatele": "Logging as incorrect user type",
    "Přihlásit se": "Sign in",
    "Přihlašovací jméno": "Login",
    "Přihlašovací údaje": "Login details",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Login details for the insurance company portals could not be loaded",
    "Přihlašovací údaje se nepodařilo smazat": "Login details could not be deleted",
    "Přihlašovací údaje se nepodařilo uložit": "Login details could not be saved",
    "Příjemce": "Recipient",
    "Příjemce:": "Recipient:",
    "Přijmení": "Surname",
    "Příjmení": "Last name",
    "Příjmy": "Revenue",
    "Příjmy (budoucí)": "Upcoming revenue",
    "Příjmy fyzioterapeutů": "Therapist income",
    "Příjmy z nabízených služeb": "Revenue from offered services",
    "Přiložený soubor se nepodařilo nahrát": "Failed to upload the attached file.",
    "Případně kontaktujte naši podporu na ": "Alternatively, contact our support at",
    "Připojištění": "Insurance",
    "Připravujeme": "Upon request",
    "Přiřazené služby": "Assigned services",
    "Přišel/Přijde": "He/She came/Will come",
    "Příští návštěva": "Next appointment",
    "Příští objednání": "Next order",
    "Příští služba": "Next service",
    "Přítomen": "Present",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "To complete the reservation, you must agree to the personal data processing policy.",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "For individual email text customization for your clients, please contact our technical support at",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "For setting the time slot when this service can be booked online, please contact our support at",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "For room opening hours setup please contact our support at",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "To send payment confirmation please enter client's email",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "To authorise with an SMS code, first save your login details for the %{portal} portal in your profile.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "To authorise with an SMS code, first save your login details for the insurance company portal in your profile.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "For the app to function properly, basic settings are required. Don't worry, setting up the basics and going through the features will only take a few minutes!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "For this client, you have not created any PT referral yet",
    "Pro zobrazení platebního QR kódu vyplňte v": "Please fill in to display the payment QR code",
    "Proběhlé návštěvy": "Past appointments",
    "Probíhá synchronizace Vašeho kalendáře": "Calendar synchronization in progress",
    "Prodané permanentky": "Sold season tickets",
    "Prodejní cena (s DPH)": "Sale price (VAT included)",
    "Prodejní cena s DPH": "Sale price with VAT",
    "Prodejní cena zboží za ks (s DPH)": "Unit selling price of goods (VAT included)",
    "Prodejní hodnota (s DPH)": "Sales value (VAT included)",
    "Profil": "Profile",
    "Profilový obrázek byl úspěšně nahrán": "Profile picture has been successfully uploaded",
    "Profily": "Profiles",
    "Proklik na skupinovou návštěvu": "Click to schedule group appointment",
    "Propojené aplikace": "Connected applications",
    "Propojeno": "Connected",
    "Propojit": "Connect",
    "Prosím": "Please",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "We'll guide you, set up basic parameters, and add your first clients.",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Average purchase price of goods in stock per piece (VAT included)",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "You can visit the guide and help through the link in the top menu. Here, you'll find everything you're interested in, clearly organized in one place.",
    "PSČ": "ZIP code",
    "Purobot API klíč": "Purobot API key",
    "Původní": "Original",
    "Původní dávka": "Original dose",
    "RČ": "NCA",
    "RČ / Datum narození": "NID / Date of birth",
    "Recenze": "Review",
    "Recenze byla smazána": "Payment was deleted",
    "Recenze návštěv": "Client reviews",
    "recenzí": "reviews",
    "Recepční": "Receptionist",
    "Registrace": "Registration",
    "Registrace proběhla úspěšně": "Registration was successful",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Registration was successful. Please confirm your email address by clicking on link in your email!",
    "Registrace se nepovedla": "Registration failed",
    "registrace-zdarma": "signup-free",
    "Registrace/Přihlášení": "Registration/Login",
    "Registrovat se": "Sign up",
    "Řekněte nám více (nepovinné)…": "Tell us more (optional)…",
    "Resetování hesla": "Reset password",
    "Resetovat": "Reset",
    "Resetovat fyzioterapeuty dle diagnózy": "Reset therapists according to the diagnosis",
    "Resetovat heslo": "Reset password",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Řešíte jiný problém?": "Are you dealing with another issue?",
    "Rezarvace byla úspěšně změněna na": "The reservation was successfully changed to",
    "rezervace": "booking",
    "Rezervace": "Booking",
    "Rezervace byla úspěšně vytvořena.": "The reservation has been successfully created.",
    "Rezervace byla zrušena": "The reservation has been cancelled",
    "Rezervace nemohla být vytvořena": "Reservation could not be created",
    "Rezervace pacienta jsou povoleny": "Client reservations are allowed.",
    "Rezervace pacienta jsou zablokovány": "Client reservations are blocked.",
    "Rezervace úspěšně vytvořena": "Reservation successfully created",
    "Rezervaci již nelze zrušit online": "Reservations can no longer be cancelled online",
    "Rezervaci můžete zrušit do": "You can cancel your reservation until",
    "Rezervaci nelze zrušit online": "Reservation cannot be cancelled online",
    "Rezervaci se nepodařilo zrušit": "Reservation could not be cancelled",
    "Rezervovat": "Book",
    "Rezervujte si termín": "Book your appointment",
    "Rezervujte si termín u": "Book your appointment with",
    "Režim zobrazení": "Display mode",
    "Roční": "Year",
    "Rodné číslo": "Personal identification number",
    "Rodné číslo pacienta": "Client's birth number",
    "Rodné číslo:": "Personal identification number:",
    "Rok": "Year",
    "Roky": "Years",
    "Role": "Role",
    "Rozpis termínů fyzioterapie": "Schedule of therapy appointments",
    "Rozpracovaná návštěva uložena": "Ongoing appointment saved",
    "Rozpracované podání bylo smazáno": "The unfinished submission has been deleted",
    "Rozpracované podání se nepodařilo smazat": "The unfinished submission could not be deleted",
    "Rozvrh místností": "Room schedule",
    "S jakým problémem k nám přicházíte?": "What issue are you coming to us with?",
    "S nezaplacenými návštěvami": "With unpaid appointments",
    "Šablon na stránku": "Page template",
    "Šablona byla úspěšně aktualizována": "Template was successfully updated",
    "Šablona byla úspěšně smazána": "Template was successfully deleted",
    "Šablona byla úspěšně vytvořena": "Template was created successfully",
    "sablony": "templates",
    "Šablony": "Templates",
    "Sada cviků byla odeslána klientovi": "The set of exercises has been sent to the client",
    "Sazba DPH": "VAT rate",
    "Sdílejte": "Share",
    "SDÍLEJTE NÁS": "SHARE US",
    "sdílet": "Share",
    "sdílet aplikaci": "Share application",
    "Sklad": "Warehouse",
    "Skupinová návštěva": "Group appointment",
    "Skupinovka": "Group",
    "Skutečně si přejete změnit tarif?": "Do you really want to change the tariff?",
    "Sloučení karet": "Card merging",
    "Sloučit karty": "Merge cards",
    "Služba": "Service",
    "Služba nenalezena": "Reservation not found",
    "Služba:": "Service:",
    "sluzby": "services",
    "Služby": "Services",
    "Služby dle kategorií celkem za rok": "Services by Categories - Annual Total",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Services will not be deleted, only their category will be removed.",
    "Služby:": "Services:",
    "Smazání": "Deletion",
    "Smazání obrázku se nezdařilo": "Image deletion failed",
    "Smazáno": "Deleted",
    "Smazat": "Delete",
    "Smazat cvik": "Delete exercise",
    "Smazat dodavatele": "Delete supplier",
    "Smazat formulář": "Delete form",
    "Smazat fotku": "Delete photo",
    "Smazat fotografii": "Delete photo",
    "Smazat kategorii cviků": "Delete exercises category",
    "Smazat kategorii služeb": "Delete service category",
    "Smazat návštěvu": "Delete appointment",
    "Smazat obrázek": "Delete image",
    "Smazat permanentku": "Delete season ticket",
    "Smazat podání": "Delete submission",
    "Smazat pojišťovnu": "Delete insurance",
    "Smazat položku": "Delete item",
    "Smazat pouze toto volno": "Delete only this availability",
    "Smazat pouze tuto návštěvu": "Delete only this appointment",
    "Smazat pracoviště": "Delete workplace",
    "Smazat předplatné": "Delete subscription",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Delete the login details for the %{portal} portal?",
    "Smazat recenzi": "Delete review",
    "Smazat rozpracované podání": "Delete unfinished submission",
    "Smazat rozpracované podání?": "Delete the unfinished submission?",
    "Smazat šablonu": "Delete template",
    "Smazat službu": "Delete service",
    "Smazat soubor": "Delete file",
    "Smazat stávající zápis": "Delete existing entry",
    "Smazat toto a všechna budoucí volna": "Delete this and all future availability",
    "Smazat tuto a všechny budoucí návštěvy": "Delete this and all future appointments",
    "Smazat video": "Delete video",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Deletes the unfinished submission, e.g. so you can edit the batch and send it again",
    "Smluvní pojištění": "Contract insurance",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS was sent successfully",
    "SMS byly úspěšně odeslána": "The reservation has been successfully created.",
    "SMS čekajícímu": "SMS to be sent",
    "SMS kód": "SMS code",
    "SMS kód se nepodařilo vyžádat": "The SMS code could not be requested",
    "SMS se nepodařilo odeslat": "Failed to send SMS",
    "Sobota": "Saturday",
    "Soubor se nepodařilo stáhnout": "The file could not be downloaded",
    "Soubory úspěšně nahrány": "Files successfully uploaded",
    "Současné heslo": "Current password",
    "Souhlas s GDPR": "Consent with GDPR",
    "Souhlas s novinkami:": "Consent to receiving newsletters:",
    "Souhlas udělen": "Consent granted",
    "Souhlasil s novinkami": "Agreed with the newsletter",
    "Souhlasili": "Agreed",
    "Souhlasím s vytvořením karty pacienta v souladu s": "I agree to the creation of a client record in accordance with",
    "Souhlasím se": "I agree to",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "I agree to receive news and interesting offers",
    "Splatnost": "Due date",
    "Splatnost faktury": "Invoice due",
    "Stačí": "Just",
    "Stáhnout": "Download",
    "Stáhnout fakturu": "Download invoice",
    "Stáhnout soubory": "Download files",
    "Stáhnout zálohovou fakturu": "Download backup invoice",
    "Statistiky": "Statistics",
    "Status": "Status",
    "Stav": "Status",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "The status changes either way. Choosing “Yes” issues the document together with the status change.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "The status changes either way. Choosing “Yes” issues the invoice together with the status change.",
    "Stav návštěvy byl změněn": "Visit status changed",
    "Stav platby": "Payment status",
    "Storno": "Cancel",
    "stornovanou fakturu č.": "invoice no.",
    "stornovaný paragon č.": "receipt no.",
    "Stornovat": "Continue",
    "stránka někam utekla...": "Page somewhere escaped...",
    "Středa": "Wednesday",
    "Stvrzenek na stránku": "Toggle to page",
    "svůj prohlížeč nebo si nainstalujte jiný.": "Enable your browser or install another.",
    "Synchronizace kalendáře byla zrušena": "Calendar synchronization has been canceled",
    "Synchronizace s Google kalendářem": "Sync with Google calendar",
    "Synchronizace se nezdařila": "Synchronization failed",
    "synchronizace-kalendare": "calendar-sync",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Sync your CortexApp calendar with Google calendar",
    "Tarif": "Pricing plan",
    "Tarify": "Pricing plans",
    "Tato funkce je dostupná pouze v placeném tarifu.": "This function is only available in paid subscription.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "This function is available only in advanced subscription. Advanced subscriptions unlock many advanced features to make your work easier.",
    "Tato karta se smaže.": "This card will be erased.",
    "Telefon": "Phone number",
    "Telefonní číslo": "Phone number",
    "Telefonní číslo:": "Phone number:",
    "Tento měsíc": "This month",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "This client has an unpaid appointment that was not excused.",
    "Tento rok": "This year",
    "Tento týden": "This week",
    "Termín můžete přesunout do": "You can reschedule the appointment untill",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Appointment added. You can now proceed to confirm the reservations.",
    "Text": "Text",
    "Těžší varianta": "Harder version",
    "theme_company": "Cortexapp",
    "Tisk": "Print",
    "Tisk GDPR": "Print GDPR",
    "Tisk karty pacienta": "Print client card",
    "Tisk návštěv": "Appointments print",
    "Tisk návštěvy": "Appointment print",
    "Tisk rozpisu termínů návštěv": "Print schedule of appointment dates",
    "Toto okno můžete zavřít.": "You can close this window.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "This submission is no longer awaiting authorisation, it has been completed in the meantime.",
    "Toto pole je povinné": "This field is required",
    "Trvání služby v minutách": "Duration of service in minutes",
    "týden": "week",
    "Týdně": "Weekly",
    "týdnů": "weeks",
    "týdny": "weeks",
    "Týdny": "Weeks",
    "Typ dokladu": "Document type",
    "Typ permanentky": "Season ticket",
    "Typ platby": "Payment type",
    "Typ připojištění": "Insurance type",
    "Typ připojištění:": "Type of insurance:",
    "Typ šablony": "Template type",
    "Typ transakce": "Transaction type",
    "Typ výkonu": "Power type",
    "Typ vyšetření": "Service",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "These are your private contact details. To change the public contact details visible to clients, go to ",
    "Tyto údaje vyplňte pouze v případě, že chcete dávky pojišťovnám odesílat s ověřením přihlašovacími údaji a SMS kódem. Pokud dávky podepisujete certifikátem ve Fyzion Signeru, vyplňovat je nemusíte. Účet na portálu musí mít zapnuté přihlášení pomocí SMS.": "Fill in these details only if you want to send batches to insurance companies authorised with your login details and an SMS code. If you sign batches with a certificate in CortexApp Signer, you do not need to fill them in. The portal account must have SMS login enabled.",
    "Účast pacienta": "Client's participation",
    "Údaje instituce": "Billing information",
    "Údaje o pojištění": "Insurance details",
    "Údaje pro platbu převodem": "Data for bank transfer",
    "Údaje úspěšně změněny": "Data successfully changed",
    "Úhloměr": "Protractor",
    "Uhrazeno": "Paid",
    "Ukázat cvik": "Show exercise",
    "Ulice a č. p.": "Street and house number",
    "Ulice a č.p.": "Street and house number",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "We will never show you the saved password. Leave the field empty if you do not want to change it.",
    "Uložené šablony": "Saved templates",
    "Uloženo": "Saved",
    "uložit": "save",
    "Uložit": "Save",
    "Uložit a zamknout": "Save and lock",
    "Uložit jako PDF do karty pacienta": "Save as PDF to the client’s record",
    "Uložit rozpracované": "Save in progress",
    "Uložit změny": "Save changes",
    "Úprava": "Editing",
    "Úprava příští návštěvy": "Edit next appointment",
    "upravit": "edit",
    "Upravit": "Edit",
    "Upravit cvik": "Edit exercise",
    "Upravit dodavatele": "Edit supplier",
    "Upravit dostupnost": "Edit availability",
    "Upravit fakturaci": "Edit billing",
    "Upravit FT poukaz": "Edit FT voucher",
    "Upravit fyzioterapeuta": "Edit therapist",
    "Upravit kategorii": "Edit category",
    "Upravit kategorii cviků": "Edit exercises category",
    "Upravit kategorii služeb": "Edit service categories",
    "Upravit místnost": "Edit room",
    "Upravit ordinační hodiny": "Edit office hours",
    "Upravit pacientovu permanentku": "Edit client's season ticket",
    "Upravit permanentku": "Edit season ticket",
    "Upravit platbu č.": "Edit payment n.",
    "Upravit podkategorii": "Edit subcategory",
    "Upravit pojišťovnu": "Edit insurance",
    "Upravit položku": "Edit item",
    "Upravit pracoviště": "Edit workplace",
    "Upravit pracoviště žadatele": "Edit applicant's workplace",
    "Upravit šablonu": "Edit template",
    "Upravit službu": "Edit service",
    "Upravit uživatele": "Edit user",
    "Upravit žadatele": "Edit requester",
    "upravit-ft-poukaz/:ticketId": "edit-ft-voucher/:ticketId",
    "upravit-permanentku/:ticketId": "edit-subscription/:ticketId",
    "upravit-volno": "edit-leave",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Specifies the maximum number of clients for group appointment. Value 0 equals unlimited number of clients.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "It determines the basic state of sending receipts. You can still adjust this setting individually before the actual payment for the appointment.",
    "user.form.role.worker.tooltip": "The user has access to clients and the calendar, but not to the application settings.",
    "Úspěšně nahrána dávka do Purobota": "Batch successfully uploaded to Purobot",
    "Úterý": "Tuesday",
    "Už mám odcvičeno:": "I have already completed my exercise:",
    "Územní pracoviště VZP": "VZP territorial workplace",
    "Uživatel": "User",
    "Uživatel byl deaktivován": "The user has been deactivated",
    "Uživatel byl úspěšně přidán": "User was successfully added",
    "V historii cvičení nejsou žádné záznamy.": "There are no records in the exercise history.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "There are no completed appointments in the reservation history yet.",
    "V měsících, ode dne zakoupení": "In months, from day of purchase",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "In the latest version of Google Chrome, which you can download for free at",
    "V ordinaci hotově/kartou": "In the office by cash/card",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "If this option is enabled, receipts for purchased passes are automatically sent to clients as well.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "If you switch to any of the advanced cooperation tariffs, the limit on the number of clients in the application is automatically removed.",
    "V případě, že se nemůžete dostavit, volejte na": "If you are unable to attend, please call",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "During this period, the number of appointments to each of the therapists is zero",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "At this moment it is not possible to confirm GDPR. Please try again later.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "We will increase the client record limit in the Freemium package for you.",
    "Variabilní symbol": "Variable symbol",
    "Variabilní symbol:": "Variable symbol:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Your browser does not support the data format of this video.",
    "vaše číslo účtu nebo IBAN.": "Your account number.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Your password has been successfully changed. You can now log in.",
    "Vaše kategorie služeb byla smazána": "Your service category has been deleted",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Your payment has been successful. Thank you for using CortexApp.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Your payment was unsuccessful. Please try the payment again. If the payment fails again, you can try to pay by bank transfer.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "We need your birth number to create your client record or to verify that you already have a record with us. We handle birth numbers in accordance with the medical documentation regulations.",
    "Vaše služba byla smazána": "Your service has been deleted",
    "Vaše zpráva": "Your message",
    "Vaši rezervaci už nelze zrušit online!": "Your reservation can no longer be cancelled online!",
    "Včera": "Yesterday",
    "včetně prodeje zboží": "including the sale of goods",
    "Veřejné zdravotní pojištění": "Public health insurance",
    "Více informací": "More information",
    "Video": "Video",
    "Video a obrázky cviku": "Exercise video and images ",
    "Vítáme vás v aplikaci Fyzion": "Welcome to the CortexApp",
    "Vložit pod stávající zápis": "Insert under existing entry",
    "Volno (Dovolená)": "Vacation (Holiday)",
    "Volno odstraněno": "Leave removed",
    "Vrátit do průvodce?": "Return to the guide?",
    "Vše": "All",
    "Všechny": "All",
    "Všechny doklady": "All documents",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "All of the client's appointments will remain in your calendar, but it will no longer be possible to create new appointments for the client or see them listed in your client list.",
    "Všechny pracoviště": "All locations",
    "Všechny typy služeb": "All types",
    "Všeobecné obchodní podmínky": "General terms and conditions",
    "všeobecnými obchodními podmínkami": "general terms and conditions",
    "Všeobecnými obchodními podmínkami": "By general terms and conditions",
    "Všichni": "All",
    "Všichni pacienti": "All clients",
    "Vyberte": "Select",
    "Vyberte alespoň jednu službu": "Please select at least one service",
    "Vyberte obrázky": "Select images",
    "Vyberte pacienta": "Select client",
    "Vyberte předplatné": "Choose subscription",
    "Vyberte prosím alespoň 1 fotografii.": "Please select at least 1 photo.",
    "Vyberte šablonu": "Choose a template",
    "Vyberte soubor": "Choose a file",
    "Vyberte termín": "Select a date",
    "Vyberte video": "Select video",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "You sign the selected batches electronically in the CortexApp Signer app, with one signature in which you review the batches first. CortexApp then sends them to the health insurance company and notifies you of the result by e-mail.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Send the selected batches authorised with one SMS code. Only batches of insurance companies of one portal can be sent in bulk. We will notify you of the result by e-mail.",
    "Vybrané termíny": "Selected dates",
    "Vybráno cviků": "Selected exercises",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "The selected therapist does not perform the selected service. Please select another service or therapist.",
    "Vybrat": "Select",
    "Vybrat barvu": "Select color",
    "Vybrat diagnózu": "Select diagnosis",
    "Vybrat dodavatele": "Select supplier",
    "Vybrat druh péče": "Select type of care",
    "Vybrat druh úhrady": "Select type of payment",
    "Vybrat IČP": "Select IČP",
    "Vybrat kategorii": "Select category",
    "Vybrat kód": "Select code",
    "Vybrat období": "Select",
    "Vybrat odbornost": "Select expertise",
    "Vybrat ostatní diagnózy": "Select other diagnoses",
    "Vybrat pacienta": "Select client",
    "Vybrat podkategorii": "Select subcategory",
    "Vybrat pracoviště": "Select workplace",
    "Vybrat pracovníky": "Select workers",
    "Vybrat správnou kartu": "Choose the right card",
    "Vybrat vše": "Select all",
    "Vybrat výkon": "Select power",
    "Výchozí": "Default",
    "Výchozí šablona": "Default template",
    "Vyčistit filtr": "Clean filter",
    "Vygenerovat fakturu": "Generate invoice",
    "Vyhledat": "Search",
    "Výkon": "Power",
    "Výkon je odemknutý": "Power is unlocked",
    "Výkon je zamknutý": "Power is locked",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "The performance cannot be modified as it is already assigned to an appointment.",
    "Výkonová": "Power",
    "výkonů": "performances",
    "Výkonů na stránku": "Documents per page",
    "vykony": "performances",
    "Výkony": "Performances",
    "Výkony nezapsané na návštěvě budou smazány.": "Performances not entered on the appointment will be deleted.",
    "Vyplňte ve formátu +420 123 456 789": "Please fill in the format +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Please fill in the format DD.MM.YYYY",
    "Vyplňte ve formátu HH:mm": "Please fill in as HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Please fill in if the client has changed insurance company so that we can create the prescription correctly.",
    "Výše max. úhrady": "Maximum reimbursement",
    "Výše max. úhrady:": "Maximum reimbursement amount:",
    "Výše paušálu:": "Amount of flat rate:",
    "Vyšetřil:": "Examined by:",
    "výskytech": "outbreaks",
    "výskytu": "occurrence",
    "vytisknout": "print",
    "Vytvoření": "Creation",
    "Vytvořeno": "Create a reservation",
    "Vytvořit": "Create a reservation",
    "Vytvořit 3 návštěvy": "Create 3 appointments",
    "Vytvořit dávku": "Create a reservation",
    "Vytvořit dávky": "Create a reservation",
    "Vytvořit faktury": "Create a reservation",
    "Vytvořit novou kategorii": "Create a new reservation",
    "Vytvořit novou podkategorii": "Create a new subcategory",
    "Vytvořit novou rezervaci": "Create a new reservation",
    "Vytvořit novou službu": "Create a new service",
    "Vytvořit nový cvik": "Create new exercise",
    "Vytvořit opravnou dávku": "Create a reservation",
    "Vytvořit platbu": "Create payment",
    "Vytvořit rezervaci": "Create a reservation",
    "Vytvořit zprávu": "Create a report",
    "Využívat klientský portál": "Use client portal",
    "Vyžádat SMS kód": "Request SMS code",
    "Vyzkoušejte Fyzion Zdarma!": "Try CortexApp for Free!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Try CortexApp for free and see for yourself why more than 1000 physiotherapists in the country use it. Just fill in a few details in the form below and you can get started. You can easily upgrade to a higher plan later.",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Always state the client's name (even in the case of a child)",
    "Webinář": "Webinar",
    "z": "from",
    "z ceny aplikace": "from the application price",
    "z toho v hotovosti": "from that in cash",
    "Začínáme": "Let's get started",
    "Zadané telefonní číslo je neplatné.": "The phone number entered is invalid.",
    "zadatele": "requester",
    "Žadatelé": "Applicants",
    "Žadatelé na stránku": "Applicants to page",
    "Zadejte nové heslo": "Enter new password",
    "Zadejte platnou e-mailovou adresu": "Please enter a valid email address",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Please enter your email to receive information for password reset.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Enter the SMS code from the insurance company portal. You can reuse a valid code you already have, request a new one only if you do not have any.",
    "Zadejte validní tel. číslo": "Enter valid phone number",
    "Žádná služba není k dispozici": "No service available",
    "Žádné akce k zobrazení": "No actions to display",
    "Žádné dávky k zobrazení": "No doses to display",
    "Žádné doklady k zobrazení": "No documents to show",
    "Žádné návštěvy k zobrazení": "No appointments to display",
    "Žádné stvrzenky k zobrazení": "No receipts to display",
    "Žádné výkony k zobrazení": "No doses to display",
    "Žádné zpráva k zobrazení": "No message to display",
    "Žádný fyzioterapeut není dostupný": "No therapist is available",
    "Zahrnuté služby": "Included services",
    "Základní diagnóza": "Basic diagnosis",
    "Zákonný zástupce": "Legal representative",
    "Zákonný zástupce:": "Legal representative:",
    "Zákres": "Scope",
    "Zaměstnanci": "Employees",
    "Zaměstnanec": "User",
    "Zamezit online rezervace:": "Disable online booking",
    "Zamknutou návštěvu nelze měnit.": "A locked visit cannot be changed.",
    "Zaplaceno": "Paid",
    "zaplatit": "Pay",
    "Zaplatit": "Pay",
    "Zaplatit pomocí QR kódu": "Pay using QR code",
    "Zaplatit QR kódem": "Pay with QR code",
    "Zaplaťte pomocí QR kódu": "Pay using QR code",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Pay the subscription if it is provided by any institution",
    "Zapomněli jste heslo?": "Have you forgotten the password?",
    "Zapsáno": "Written",
    "Zapsat výkon": "Write performance",
    "zásadami zpracování osobních údajů": "the personal data processing policy",
    "Zásob na stránku": "Page stock",
    "zasoby": "resources",
    "Zásoby": "Assets",
    "Zásoby na skladě": "Stock on warehouse",
    "Zatím nebyla nahrána žádná videa.": "No videos have been uploaded yet.",
    "Zatím nebyly nahrány žádné obrázky.": "No images have been uploaded yet.",
    "Zatím nebyly vytvořeny žádné permanentky": "No memberships have been created yet",
    "Zatím nejsou nahrána žádná videa.": "No videos have been uploaded yet.",
    "Zatím nejsou naplánovány žádné cviky.": "No exercises are scheduled yet.",
    "Zatím nejsou žádné recenze.": "There are no reviews yet.",
    "Zatím nemáte naplánované žádné pacienty": "You don't have any clients scheduled yet",
    "Zatím zde nejsou žádné cviky": "There are no exercises here yet",
    "Zatím zde nejsou žádné položky": "No items here yet",
    "Zatím zde nejsou žádné předplatné": "No payments have been made yet",
    "Zatím zde nejsou žádné proběhlé návštěvy": "No appointments have occurred yet",
    "Zatím zde nejsou žádné šablony": "No templates available yet",
    "Zatím zde nejsou žádné služby": "No services available yet",
    "Zatím zde nejsou žádné zásoby": "No stocks available yet",
    "Zatím zde nejsou žádní dodavatelé": "No suppliers available yet",
    "Zatím zde nejsou žádní pacienti": "No clients here yet",
    "Zavolat do ordinace": "Call the office",
    "Zavolejte nám na telefon:": "Call us at:",
    "Zavřeno": "Closed",
    "Zavřít": "Close",
    "Zavřít menu": "Close menu",
    "Zavřít platbu": "Close payment",
    "Zboží": "Goods",
    "Zboží bylo úspěšně naskladněno": "Product was successfully stocked",
    "Zboží se nepodařilo naskladnit": "Product failed to stock",
    "Zbývající počet znaků": "Remaining characters",
    "Zbývajících vstupů": "Remaining inputs",
    "Zdá se, že nám hledaná": "It seems that we",
    "Zdarma": "Free",
    "ZDARMA": "FREE",
    "ZDE": "HERE",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Here you can upload documents related to the selected profile.",
    "Zdravotní pojišťovna": "Health insurance",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "The health insurance company rejected the submission because the certificate the batch was signed with is not registered on your account on its portal. Sign the submission with a certificate registered on the health insurance company portal and send the batch again.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "The health insurance company rejected the submission because the SMS code was invalid or has expired. Request a new code and send the batch again.",
    "Zelená": "Green",
    "Žena": "Female",
    "Ženy": "Women",
    "Ženy (budoucí)": "Women (scheduled)",
    "Zjistit více": "Find out more",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Please check the entered address in the browser.",
    "Zkopírováno": "Copied",
    "Zkopírovat": "Copy",
    "Zkopírovat odkaz do schránky": "Copy link to clipboard",
    "Zkopírovat odkaz na rezervaci této služby": "Copy the reservation link for this service",
    "Žlutá": "Yellow",
    "Změna hesla": "Change password",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "The change failed. Please check the information in the form.",
    "Změna tarifu není možná": "Tariff change is not possible",
    "Změnit": "Change",
    "Změnit heslo": "Change password",
    "Změnit stav na „%{status}“?": "Change the status to \"%{status}\"?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "You can change the payment type or amount in the payment editor.",
    "Zobrazit": "Show",
    "Zobrazit méně": "Show less",
    "zpět": "back",
    "Zpět": "Back",
    "Zpět do aplikace": "Back to application",
    "Zpět na cviky": "Back to the list of doses",
    "Zpět na přihlášení": "Back to sign in",
    "Zpět na seznam dávek": "Back to the list of doses",
    "Zpráva od terapeuta": "Therapy report",
    "Způsob platby": "Payment method",
    "Zrušená fakturace": "Cancelled invoice",
    "Zrušená návštěva klienta": "Cancelled client visit",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "By canceling the payment, you will cancel the created receipt, return an entry to a season ticket, or refund credits to a subscription. It depends on the previous payment method.",
    "Zrušeno": "Cancel",
    "Zrušeno terapeutem": "Cancelled by the therapist",
    "Zrušit": "Cancel",
    "ZRUŠIT FILTR": "CANCEL FILTER",
    "Zrušit návštěvu": "Cancel appointment",
    "Zrušit platbu": "Cancel payment",
    "Zrušit rezervaci": "Cancel reservation",
    "Zůstat na stránce": "Stay on the page",
    "Zvolit": "Choose",
    "Zvolit fyzioterapeuta": "Choose a therapist",
    "Zvolit službu": "Choose a service",
    "Zvolit typ služby": "Choose a service type",
    "Zvolte alespoň jeden výkon": "Choose at least one power",
    "Zvolte alespoň jednu pojišťovnu": "Please select at least one insurance company",
    "Zvolte čas": "Choose the time",
    "Zvolte datum": "Select the date"
  },
  "sk": {
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/pridat-poistovnu",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/upravit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/upravit-poistovnu/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/upravit",
    ":patientId/popisy-navstev": ":patientId/popisy-navstev",
    ":serviceGroupId/upravit": ":serviceGroupId/upravit",
    ":serviceId/upravit": ":serviceId/upravit",
    ":stockItemId/upravit": ":stockItemId/upravit",
    ":supplierId/upravit": ":supplierId/upravit",
    ":userId/ordinacni-hodiny": ":userId/ordinacne-hodiny",
    ":userId/upravit": ":userId/upravit",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": ". Pred návštevou si prečítajte zásady GDPR. Pre zobrazenie textu GDPR a potvrdenie kliknite",
    "(Přišli poprvé)": "(Prišli prvýkrát)",
    "/akce": "/akcia",
    "/cekajici-pacienti": "/cakajuci-klienti",
    "/cviky": "/cviky",
    "/domu": "/domov",
    "/historie-akci": "/historia-akcii",
    "/historie-zprav": "/historia-zprav",
    "/kalendar": "/kalendar",
    "/moje-navstevy": "/moje-navstevy",
    "/moje-profily": "/moje-profily",
    "/moje-udaje": "/moje-udaje",
    "/nastaveni": "/nastavenie",
    "/novinky": "/novinky",
    "/ordinace": "/ordinacia",
    "/pacienti": "/klienti",
    "/pacienti/novy": "/klienti/novy",
    "/platba": "/platba",
    "/pojistovny": "/poistovne",
    "/profil": "/profil",
    "/pruvodce/": "/sprievodca/",
    "/rozcestnik-pruvodce/": "/rozcestník-sprievodca/",
    "/rozsireni-kartoteky-zdarma": "/rozsirenie-kartoteky-zdarma",
    "/sklad": "/sklad",
    "/skupinove-navstevy/": "/skupinove-navstevy/",
    "/statistiky": "/statistiky",
    "/tisk": "/tlac",
    "%": "%",
    "1. čvrtletí": "1. štvrťrok",
    "2. čtvrtletí": "2. štvrťrok",
    "3 - Úraz způsobený jinou osobou": "3 - Úraz spôsobený inou osobou",
    "3. čtvrtletí": "3. štvrťročie",
    "4 - Alkohol a omamné látky": "4 - Alkohol a omamné látky",
    "4. čvrtletí": "4. štvrťrok",
    "5 - Pracovní úraz": "5 - Pracovný úraz",
    "6 - Sociální důvody hospitalizace": "6 - Sociálne dôvody hospitalizácie",
    "60 pacientů": "60 klientov",
    "7 - Porušení léčebného režimu": "7 - Porušenie liečebneho režimu",
    "8 - Výměna komponent systému ASR_TM": "8 - Výmena komponentov systému ASR_TM",
    "9 - Nemoc z povolání": "9 - Nemoc z povolania",
    "A ROZŠIŘTE SI KARTOTÉKU": "A ROZŠÍRTE SI KARTOTÉKU",
    "a zaplatit": "Zaplatiť",
    "a získejte neomezenou kapacitu kartotéky.": "a získajte neobmedzenú kapacitu kartotéky.",
    "absolvoval tyto návštěvy": "absolvovala tieto návštevy",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin má neobmedzený prístup ku všetkým funkciám v rámci zvoleného tarifu",
    "Adresa": "Adresa",
    "Adresa sídla": "Adresa sídla",
    "Adresa:": "Adresa:",
    "Adresát": "Adresát",
    "Akce": "Akcia",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktiváciou sprístupníte klientský portál. Po naplánovaní návštevy nového klienta alebo rezervácie klient automaticky dostane pozvánku do klientského portálu.",
    "Aktivní tarif": "Aktívny tarif",
    "aktualizujte": "aktualizujte",
    "anamneza": "anamneza",
    "Anamnéza": "Anamnéza",
    "Anamnéza zatím nebyla vyplněna.": "Anamnéza zatiaľ nebola vyplnená.",
    "Anamnéza:": "Anamnéza:",
    "Anamnézu se nepodařilo načíst": "Anamnézu sa nepodarilo načítať",
    "Anamnézu se nepodařilo uložit": "Anamnézu sa nepodarilo uložiť",
    "Anamnézy": "Anamnézy",
    "Ano": "Ano",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "aplikaciu CortexApp na sociálnych sieťach alebo kdekoľvek na webe.",
    "Aplikovat změny na toto a všechna budoucí volna": "Aplikovať zmeny na túto a všetky budúce návštevy",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Aplikovať zmeny na túto a všetky budúce návštevy",
    "Aplikovat změny pouze na toto volno": "Aplikovať zmeny len na túto návštevu",
    "Aplikovat změny pouze na tuto návštěvu": "Aplikovať zmeny len na túto návštevu",
    "Archivace": "Archivacia",
    "Archivovat": "Archivovať",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automaticky odošle klientovi informáciu o vytvorení, zmene alebo zrušení návštevy.",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Balík zdarma je v základnom nastavení limitovaný počtom klientov, ktoré je možné mať v kartotéke, na 20. V prípade, že ste dosiahli limit, máte možnosť tento limit navýšiť až na",
    "Bankovní údaje": "Bankovné údaje",
    "Barva": "Farba",
    "Barva místnosti v kalendáři": "Farba miestnosti v kalendári",
    "Barva v kalendáři": "Farba v kalendári",
    "Beru na vědomí": "Beriem na vedomie",
    "bezchybně a rychle": "bezchybne a rýchlo",
    "bezhotovostně": "bezhotovostne",
    "Bezplatná registrace": "Bezplatná registracia",
    "Bezplatná verze aplikace umožňuje evidovat až %{count} pacientů. Pokud chcete přidávat další pacienty, aktivujte si": "Bezplatná verzia aplikácie umožňuje evidovať až %{count} klientov. Ak chcete pridávať ďalších klientov, aktivujte si",
    "Bodů": "Bodov",
    "Body": "Body",
    "Budoucí návštěvy": "Budúce návštevy",
    "Bylo to užitečné?": "Bolo to užitočné?",
    "Čas": "Čas",
    "Čas do je povinný": "Čas do je povinný",
    "Čas od je povinný": "Čas od je povinný",
    "Čas:": "Čas:",
    "Částka": "Čiastka",
    "Částka bude vypočítána jako celková cena všech položek.": "Čiastka bude vypočítaná ako celková cena všetkých položiek.",
    "Částka k úhradě": "Čiastka k úhrade",
    "Částka nesmí být vyšší než cena návštěvy": "Suma nesmie byť vyššia ako cena návštevy",
    "Čeká na autorizaci": "Čaká na autorizáciu",
    "Čeká na platbu": "Čaká na platbu",
    "Čeká na zaplacení": "Čaká na zaplatenie",
    "Čekající": "Čakajúci",
    "Čekající pacienti": "Čakajúci klienti",
    "Čekající:": "Čakajúci:",
    "Celkem k úhradě": "Celkom k úhrade",
    "Celkem návštěv:": "Celkom návštev:",
    "Celý den": "Celý deň",
    "Cena": "Cena",
    "Cena nemůže být nižší než 0": "Cena nemôže byť nižšia než 0",
    "Cena nesmí být záporná": "Cena nesmie byť záporná",
    "Cena permanentky": "Cena permanentky",
    "Cena s DPH": "Cena s DPH",
    "Cena za MJ": "Cena za MJ",
    "Cena:": "Cena:",
    "Certifikát": "Certifikát",
    "Cestovní zdravotní pojištění": "Cestovné zdravotné poistenie",
    "Četl/a jsem a souhlasím se": "Prečítal som si a súhlasím so",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "Chápeme, že teraz nie je vhodný čas, k sprievodcovi sa môžete kedykoľvek vrátiť, prípadne využiť tipy a nápovedu.",
    "Charakter": "Charakter",
    "Charakter dávky": "Charakter dávky",
    "Chcete pokračovat v zadání návštěvy:": "Chcete pokračovať v zadaní návštevy:",
    "Chci naplánovat": "Chcem naplánovať",
    "chyba": "chyba",
    "Čísla dokladů v dávce od": "Čísla dokladov v dávke od",
    "Čísla faktur": "Čísla faktúr",
    "Číslo": "Číslo",
    "Číslo dávky": "Číslo dávky",
    "Číslo dokladu": "Číslo dokladu",
    "Číslo pojištěnce": "Číslo poistenca",
    "Číslo pojištěnce nemusí být správné": "Číslo poistenca nemusí byť správne",
    "Číslo pojištěnce:": "Číslo poistenca:",
    "Číslo pojišťenec": "Číslo poistenca",
    "Číslo účtu": "Číslo účtu",
    "Číslovat dávky od": "Číslovať dávky od",
    "Číslovat faktury od": "Číslovať faktúry od",
    "Co je nového?": "Čo je nové?",
    "Čtvrtek": "Štvrtok",
    "Čtvrtletí": "Štvrťroky",
    "Čtvrtletní": "Štvrťroční",
    "cvik": "cvik",
    "Cvik": "Cvik",
    "cviků": "cvikov",
    "cviky": "cviky",
    "Cviky": "Cviky",
    "Cviky na vybraný den": "Cviky na vybraný deň",
    "Další akce": "Dalšia akcia",
    "Další položka": "Další položka",
    "Další výkon": "Další výkon",
    "Datum": "Dátum",
    "Datum a čas": "Dátum a čas",
    "Datum inventury": "Dátum inventúry",
    "Datum je povinné": "Dátum je povinné",
    "Datum narození": "Dátum narodenia",
    "Datum narození:": "Dátum narodenia:",
    "Datum naskladnění": "Dátum naskladnenia",
    "Datum návštěvy": "Dátum návštevy",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Dátum platnosti budúcej ceny nemôže byť v minulosti.",
    "Datum splatnosti:": "Dátum splatnosti:",
    "Datum transakce": "Dátum transakcie",
    "Datum vystavení": "Dátum vystavenia",
    "Datum začátku cvičení": "Dátum začiatku cvičenia",
    "Datum zaplacení": "Dátum zaplatenia",
    "Datum zdanitelného plnění": "Dátum zdaniteľného plnenia",
    "Datum změny pojištění:": "Dátum zmeny poistenia:",
    "Datum změny pojišťovny": "Dátum zmeny poisťovne",
    "Datum:": "Dátum:",
    "Dávek na stránku": "Dávok na stránku",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Dávku elektronicky podpíšete v aplikácii CortexApp Signer a CortexApp ju odošle zdravotnej poisťovni.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Dávku možno elektronicky odoslať priamo zdravotnej poisťovni, s podpisom certifikátom alebo s overením SMS kódom.",
    "Dávku se nepodařilo vytvořit": "Dávku sa nepodarilo vytvoriť",
    "davky": "davky",
    "Dávky": "Dávky",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Dávky sme zaradili na odoslanie poisťovni. O výsledku vás budeme informovať e-mailom.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "Dávky nemôžeme vytvoriť, pretože sme nenašli žiadne výkony. Zmeňte výber obdobia, poisťovní alebo pracoviska.",
    "Dávky vytvořeny": "Dávky vytvorené",
    "DD.MM.RRRR": "DD.MM.RRRR",
    "Deaktivovat": "Deaktivovať",
    "Deaktivovat terapeuta": "Deaktivovať terapeuta",
    "dekujeme": "dakujeme",
    "Děkujeme za vaší recenzi!": "Ďakujeme vám za vašu recenziu!",
    "Děkujeme za zpětnou vazbu": "Ďakujeme za spätnú väzbu",
    "Děkujeme!": "Ďakujeme!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Ďakujeme! Súhlas s GDPR bol úspešne potvrdený.",
    "Délka (min.)": "Dĺžka (min.)",
    "den": "den",
    "Den": "Den",
    "Denně": "Denne",
    "detail": "detail",
    "Detail následující návštěvy": "Detail nasledujúcej návštevy",
    "Detail návštěvy": "Detail návštevy",
    "Detail poslední návštěvy": "Detail poslednej návštevy",
    "Detail rezervace": "Detail rezervácie",
    "Diagnóza": "Diagnóza",
    "DIČ": "DIČ",
    "dne": "dňa",
    "Dne": "Dňa",
    "Dnes": "Dnes",
    "dní": "dní",
    "dnů": "dní",
    "dny": "dni",
    "Dny": "Dni",
    "Do": "Do",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "Do karty klienta zatiaľ neboli nahrané žiadne formuláre.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "Do karty klienta zatiaľ neboli nahrané žiadne fotografie.",
    "Do průvodce": "Do sprievodcu",
    "Doba splatnosti": "Doba splatnosti",
    "Doba trvání": "Doba trvania",
    "Doba trvání pro pacienty": "Doba trvania pre klientov",
    "Doba trvání:": "Doba trvania:",
    "Dobrý den": "Dobrý deň",
    "Dodavatel": "Dodavateľ",
    "Dodavatel byl úspěšně smazán": "Dodávateľ bol úspešne zmazaný",
    "Dodavatel byl úspěšně upraven": "Dodávateľ bol úspešne upravený",
    "Dodavatel byl úspěšně vytvořen": "Dodávateľ bol úspešne vytvorený",
    "dodavatele": "dodavatele",
    "Dodavatelé": "Dodávatelia",
    "Dodavatele se nepodařilo smazat": "Dodávateľa sa nepodarilo zmazať",
    "Dodavatele se nepodařilo upravit": "Dodávateľa sa nepodarilo upraviť",
    "Doklady": "Doklady",
    "Dokončeno": "Dokončené",
    "Dokončit odeslání": "Dokončiť odoslanie",
    "Dokončit odeslání dávky": "Dokončiť odoslanie dávky",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokončiť odoslanie dávky č. %{number} pre poisťovňu %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "Dokument bol úspešne nahraný a odoslaný",
    "Dokumenty": "Dokumenty",
    "Doplňková služba": "Doplnková služba",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "Dosiahli ste maximálny počet klientov v kartotéke. ",
    "Dosažení maximálního počtu pacientů": "Dosiahnutie maximálneho počtu klientov",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Dotazník pre klienta (dotazník uvidí klient v klientskej sekcii, kde ho môže vyplniť)",
    "Dotazník pro pacienta": "Doba trvania pre klientov",
    "DPH": "DPH",
    "DPH%": "DPH%",
    "Druh péče": "Druh starostlivosti",
    "Druh péče:": "Druh starostlivosti:",
    "Druh úhrady": "Druh úhrady",
    "Druh úhrady:": "Druh úhrady:",
    "Duplikovat": "Duplikovať",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "E-mail sa nepodarilo odoslať.",
    "E-mail úspěšně odeslán": "E-mail úspešne odoslaný",
    "E-mailová adresa": "E-mailová adresa",
    "E-mailová adresa:": "E-mailová adresa:",
    "Editace údajů pacienta": "Editácia údajov klienta",
    "Email": "Email",
    "Email byl úspěšně poslán": "E-mail úspešne odoslaný",
    "Email odeslán": "E-mail odoslaný",
    "Export bude vygenerován a zaslán na e-mail": "Export bude vygenerovaný a zaslaný na e-mail",
    "Exportovat": "Exportovať",
    "Exportovat data": "Exportovať data",
    "Exportovat PDF": "Exportovať PDF",
    "Exportovat platby": "Exportovať platby",
    "Exportovat výkony": "Exportovať",
    "Faktura": "Faktura",
    "Faktura bude vygenerována a zaslána na e-mail": "Faktúra bude vygenerovaná a zaslaná na e-mail",
    "Faktura byla označena jako zaplacená": "Faktúra bola označená ako zaplatená",
    "Fakturace": "Fakturacia",
    "Fakturace byla označena jako zaplacená": "Fakturácia bola označená ako zaplatená",
    "Fakturace úspěšně přidána": "Fakturácia úspešne pridaná",
    "Fakturace úspěšně upravena": "Fakturacia úspešne upravená",
    "Fakturace za období": "Fakturácia za obdobie",
    "Fakturace za období:": "Fakturácia za obdobie:",
    "Fakturační údaje": "Fakturačné údaje",
    "fakturacni-udaje": "fakturacne-udaje",
    "fakturu č.": "faktúru č.",
    "faktury": "faktury",
    "Faktury": "Faktúry",
    "Filtrovat": "Filtrovať",
    "Filtrovat pacienty": "Filtrovať klientov",
    "finance": "financie",
    "Finance": "Financie",
    "Formulář úspěšně nahrán": "Formulár úspešne nahraný",
    "Formuláře se nepodařilo načíst": "Formuláre sa nepodarilo načítať",
    "Fotka FT poukazu": "Fotka FT poukaz",
    "Fotka FT poukazu byla úspěšně nahrána": "Fotka FT poukazu bola úspešne nahraná",
    "Fotku obrazovky s Vaším sdílením": "Fotku obrazovky s Vašim zdieľaním",
    "Fotogalerie": "Fotogaléria",
    "fotografie": "fotografia",
    "Fotografie se nepodařilo načíst.": "Fotografia sa nepodarilo načítať.",
    "Fotografie smazána": "Fotografia zmazaná",
    "Fotografie úspěšně nahrána": "Fotografia úspešne nahraná",
    "Fotografie ze dne": "Fotografia z dna",
    "Fotografie:": "Fotografia:",
    "FT poukaz": "FT poukaz",
    "FT poukaz byl úspěšně vytvořen": "FT poukaz bol úspešne vytvorený",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT poukaz nie je možné vytvoriť. Skontrolujte, či je všetko správne vyplnené na karte klienta.",
    "FT poukaz úspěšně smazán": "FT poukaz úspešne zmazaný",
    "FT poukaz úspěšně upraven": "FT poukaz úspešne upravený",
    "Fyzion funguje": "CortexApp funguje",
    "Fyzion premium function": "CortexApp premium function",
    "fyzion-faktura.pdf": "cortexapp-faktura.pdf",
    "fyzion-zalohova-faktura.pdf": "cortexapp-zalohova-faktura.pdf",
    "Fyzioterapeut": "Terapeut",
    "Fyzioterapeut a místnost": "Terapeut a miestnosť",
    "Fyzioterapeut je povinný": "Terapeut je povinný",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Terapeut nemá vyplnenú pracovnú dobu.",
    "Fyzioterapeut:": "Terapeut:",
    "fyzioterapeuti": "terapeuti",
    "Fyzioterapeuti": "Terapeuti",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR súhlas",
    "GDPR úspěšně potvrzeno.": "GDPR úspešne potvrdené.",
    "GDPR:": "GDPR:",
    "Google kalendář": "Google kalendár",
    "Hesla se neshodují": "Heslá sa nezhodujú",
    "Heslo": "Heslo",
    "Heslo bylo úspěšně změněno": "Heslo bolo úspešne zmenené",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "Heslo musí obsahovať minimálne 8 znakov a aspoň 1 číslicu.",
    "Historie akcí": "Záznam aktivít",
    "Historie cvičení": "História cvičenia",
    "Historie emailů a SMS": "História e-mailov a SMS",
    "Historie návštěv": "Historia návštev",
    "Historie rezervací": "História rezervácií",
    "Hledanému výrazu neodpovídá žádná diagnóza": "Hľadanému výrazu nezodpovedá žiadna diagnóza",
    "Hledanému výrazu neodpovídá žádné pracoviště": "Hľadanému výrazu nezodpovedá žiadne pracovisko",
    "Hledanému výrazu neodpovídá žádný pacient": "Hľadanému výrazu nezodpovedá žiadny klient",
    "Hledanému výrazu neodpovídá žádný výkon": "Hľadanému výrazu nezodpovedá žiadny výkon",
    "Hodnota bodu": "Hodnota bodu",
    "Hodnota bodu:": "Hodnota bodu:",
    "Hotově": "V hotovosti",
    "Hotovo": "Hotovo",
    "Hromadné odeslání dávek pojišťovně selhalo": "Hromadné odoslanie dávok poisťovni zlyhalo",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://www.cortexapp.eu/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://www.cortexapp.eu/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://cortexapp.eu/",
    "https://fyzion.cz/cs/webinar/": "https://cortexapp.eu/sk/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://cortexapp.eu/sk/navody",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://www.cortexapp.eu/sk/navody",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IČ": "IČ",
    "IČO": "IČO",
    "IČP": "IČP",
    "IČP žadatele": "IČP žiadateľa",
    "IČZ": "IČZ",
    "Identifikační údaje pacienta:": "Identifikačné údaje klienta:",
    "Identifikační údaje poskytovatele:": "Identifikačné údaje poskytovateľa:",
    "info@fyzion.cz": "info@cortexapp.eu",
    "Informace o návštěvách": "Informacie o návštevách",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Informacie o Vašej rezervácii sme Vám poslali na e-mail",
    "inventura": "inventura",
    "Inventura": "Inventúra",
    "Inventura zboží": "Inventúra tovaru",
    "Inventura zboží úspěšně provedena": "Inventúra tovaru úspešne prevedená",
    "Inventuru zboží se nepodařilo uložit": "Inventúru tovaru sa nepodarilo uložiť",
    "Jak chcete pokračovat?": "Jak chcete pokračovať?",
    "Jak chcete provedené změny aplikovat?": "Ako chcete vykonané zmeny aplikovať?",
    "Jak navýšit limit kartotéky pacientů?": "Ako navýšiť limit kartotéky klientov?",
    "Jak si přejete aplikovat tuto šablonu?": "Naozaj si prepísať text šablónou?",
    "Jaké služby poskytuje?": "Aké služby poskytuje?",
    "Jakýkoliv": "Akýkoľvek",
    "Jde o duplicitní kartu?": "Jde o duplicitnú kartu?",
    "Jdeme na to teď!": "Ideme na to teraz!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "Je-li funkcia zapnutá a klient ešte nemá potvrdené GDPR, systém mu ho automaticky odosiela k potvrdeniu deň pred budúcou návštevou.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "Je-li táto funkcia vypnutá, terapeut vidí návštevy ostatných terapeutov, ale nemôže sa prekliknúť do ich detailu",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "Ak splníte tieto tri úlohy skôr, než uplynie čas, ako odmenu od nás dostanete tarif Standard na tri mesiace",
    "Jméno": "Meno",
    "Jméno pojištěnce": "Meno poistencov",
    "Jméno:": "Meno:",
    "Jméno/název": "Meno/názov",
    "Jméno/Název": "Meno/Názov",
    "Jsou předepsané výkony": "Nasľúbené výkony",
    "K platbě": "K platbe",
    "K této návštěvě nebyl zatím přidán žádný popis.": "K tejto návšteve nebol zatiaľ pridaný žiaden popis.",
    "K této recenzi nebyl přidán žádný text.": "K tejto recenzii nebol pridaný žiadny text.",
    "K vytvoření stvrzenky je potřeba návštěva": "K vytvorenie potvrdenky je potrebná návšteva",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "K vytvorenie potvrdenky je potrebný klient a návšteva",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Zmazať",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Zmazať dávku a faktúru?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Zmazať dávku?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Naozaj si prajete zmazať dávku č. %{batchNumber} a faktúru č. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Naozaj si prajete zmazať dávku č. %{batchNumber}?",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Dávku sa nepodarilo zmazať",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Opravná dávka vytvorená",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Vytvoriť opravnú dávku",
    "k_batches.k_batch.delete_failed.notification": "Dávku sa nepodarilo zmazať",
    "k_batches.k_batch.delete_k_batch_btn.label": "Zmazať dávku",
    "k_batches.k_batch.delete_successful.notification": "Dávka zmazaná",
    "Kalendář": "Kalendár",
    "Kalendář byl úspěšně synchronizován": "Kalendár bol úspešne synchronizovaný",
    "Kalendář je již synchronizovaný": "Kalendár je už synchronizovaný",
    "Kapacita": "Kapacita",
    "Karta klienta": "Karta klienta",
    "Karta pacienta": "Karta klienta",
    "karta-pacienta": "karta-klienta",
    "karta/:patientId": "karta/:patientId",
    "Kartou": "Kartou",
    "Kartou online": "Kartou online",
    "Karty byly sloučeny": "Karty boli zlúčené",
    "Karty se nepodařilo sloučit": "Karty sa nepodarilo zlúčiť",
    "kategorie": "kategória",
    "Kategorie": "Kategória",
    "Kdokoliv dostupný": "Kdokolvek dostupný",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Klientská sekcia je vypnutá. Zapnúť ju môžete vo",
    "Kód": "Kód",
    "Kód ": "Kód ",
    "Kód a název pojišťovny": "Kód a názov poisťovne",
    "Kód a název zboží": "Kód a názov tovaru",
    "Kód a název zboží, počet": "Kód a názov tovaru, počet",
    "kód banky": "kód banky",
    "Kód banky": "Kód banky",
    "Kód náhrady": "Kód náhrady",
    "Kód pojišťovny": "Kód poisťovne",
    "Kód zboží": "Kód tovaru",
    "Konec": "Konec",
    "Kontakt na pacienta": "Kontakt na klienta",
    "Kontaktní osoba": "Kontaktná osoba",
    "Kontaktní údaje": "Kontaktné údaje",
    "kontaktni-udaje": "kontaktne-udaje",
    "Kontaktovat": "Kontaktovať",
    "Kontaktujte nás": "Kontaktujte nás",
    "Kontaktujte naši podporu": "Kontaktujte našu podporu",
    "Kredit": "Kredit",
    "ks": "ks",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Limit dlhu predplatného bude prekročený.",
    "Limit dlužné částky": "Limit dlžnej sumy",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "Limit klientov môžete zvýšiť, keď nám pomôžete zdieľať aplikáciu medzi Vašich kolegov, ",
    "Logo aplikace Fyzion": "Logo aplikácie CortexApp",
    "Logo firmy": "Logo firmy",
    "mailto:info@fyzion.cz": "mailto:info@cortexapp.eu",
    "Mají tel.": "Majú tel.",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "máte naplánované stretnutie v pracovisku fyzioterapie",
    "Máte objednány tyto návštěvy": "Máte objednané tieto návštevy",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "Máte tu neuložené zmeny, chcete ich pred odchodom uložiť?",
    "Max. 9 výkonů": "výkonov",
    "Maximální úhrada": "Maximálna úhrada",
    "měsíc": "mesiac",
    "Měsíc": "Mesiac",
    "měsíce": "mesiace",
    "Měsíce": "Mesiace",
    "Měsíčně": "Mesacne",
    "Měsíční": "Mesačný",
    "měsíců": "mesiacov",
    "Město": "Mesto",
    "mezi vaše kolegy nebo přechodem na ": "medzi vašimi kolegami alebo prechodom na ",
    "mezi Vaše kolegy, nebo přechodem na ": "medzi vašimi kolegami alebo prechodom na",
    "min": "min",
    "min.": "min.",
    "Minulý měsíc": "Minulý mesiac",
    "Minulý rok": "Minulý rok",
    "Minulý týden": "Minulý týždeň",
    "minut": "minút",
    "Místnost": "Miestnosť",
    "Místnost byla úspěšně upravena": "Miestnosť bola úspešne upravená",
    "Místnost byla úspěšně vytvořena": "Miestnosť bola úspešne vytvorená",
    "mistnosti": "miestnosti",
    "Místnosti": "Miestnosti",
    "MJ": "MJ",
    "Množství": "Množstvo",
    "Moje profily": "Moje profily",
    "Moje údaje": "Moje údaje",
    "Momentálně využívá": "Momentálne využíva",
    "Možnost dluhu": "Možnosť dlhu",
    "Mřížka": "Mrížka",
    "Musí být alespoň 1": "Musí byť aspoň 1",
    "Musí být menší než 1000.": "Musí byť väčší než 0.",
    "Musí být větší než 0.": "Musí byť väčší než 0.",
    "Muž": "Muž",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "Môžete vložiť obrázok s vašou pečiatkou alebo podpisom, ktorý sa následne vloží na generované doklady pre klientov.",
    "Muži": "Muži",
    "Muži (budoucí)": "Muži (muži objednaní)",
    "na info@fyzion.cz.": "na info@cortexapp.eu.",
    "Nabízené permanentky": "Ponúkané permanentky",
    "Nabízené služby": "Ponúkané služby",
    "Načíst další": "Načítať ďalší",
    "Načíst údaje z ARES": "Načítať údaje z ORSR",
    "Nadcházející návštěva": "Nasledujúca návšteva",
    "Nadpis bloku": "Nadpis bloku",
    "Nahrané dokumenty zde není možné vidět.": "Nahrané dokumenty tu nie je možné vidieť.",
    "Nahrání obrázku se nezdařilo": "Nahranie obrázka sa nepodarilo.",
    "Nahrát dávku do Purobota": "Odoslanie dávky do aplikácie Purobot",
    "Nahrát fotku": "Nahrať fotku",
    "Nahrát soubor": "Nahrať súbor",
    "Nahrát soubor typu jpeg nebo png": "Nahrať súbor typu jpeg alebo png",
    "Nákupní (s DPH)": "Nákupný (s DPH)",
    "Nákupní cena a počet": "Nákupná cena a počet",
    "Nákupní cena s DPH": "Nákupná cena s DPH",
    "Nákupní hodnota (s DPH)": "Nákupná hodnota (s DPH)",
    "Napište nám na email:": "Napíšte nám na e-mail",
    "Napište poznámku…": "Napíšte poznámku…",
    "Naplánovat změnu ceny od zvoleného data": "Naplánovať zmenu ceny od zvoleného dátumu",
    "např. číslo dávky, dokladu, pojištěnce": "napr. číslo dávky, dokladu, poistencov",
    "Např. kód, název zboží": "Napr. kód, názov tovaru",
    "např. název, IČP, telefonní číslo": "napr. názov, IČP, telefónne číslo",
    "např. název, instituce, IČO": "napr. názov, inštitúcia, IČO",
    "např. RČ pacienta, e-mail": "napr. RČ klienta, e-mail",
    "Např. RČ pacienta, e-mailová adresa": "Napr. RČ klienta, e-mailová adresa",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "našu aplikáciu alebo facebookovú skupinu CortexApp na internete. Za každé takéto zdieľanie vám bezplatne rozšírime kartotéku o ďalších päť klientov. Ako potvrdenie, že ste zdieľanie vykonali, nám prosím pošlite screenshot (fotku obrazovky) zdieľaného príspevku na info@cortexapp.eu a uveďte, o akého terapeuta ide.",
    "naskladneni": "naskladnenie",
    "Naskladnění": "Naskladnenie",
    "Naskladnění zboží": "Naskladnenie tovaru",
    "Následující návštěva:": "Nasledujúca návšteva:",
    "Nasmlouvané výkony": "Nasľúbené výkony",
    "nastaveni": "nastavenie",
    "Nastavení": "Nastavenie",
    "Nastavení - Fakturační údaje": "Nastavenie - Fakturačné údaje",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "NASTAVENIE - KONTAKTNÉ ÚDAJE.",
    "Nastavení nového hesla": "Nastavenie nového hesla",
    "Nastavení předplatného": "Nastavenie predplatného",
    "Nastavení uloženo": "Nastavenie uložené",
    "Nastavit": "Nastaviť",
    "Návod": "Návod",
    "Návrat do aplikace": "Návrat do aplikácie",
    "Návštěv na stránku": "Návštev na stránku",
    "návštěva": "návšteva",
    "Návštěva": "Návšteva",
    "Návštěva byla označena jako zaplacená": "Návšteva bola označená ako zaplatená",
    "Návštěva byla úspěšně zaplacena": "Návšteva bola úspešne zaplatená",
    "Návštěva je zamknuta": "Návšteva je zamknutá",
    "Návštěva nenalezena": "Návšteva nenalezena",
    "Návštěva obsahuje nahrané formuláře": "Návšteva obsahuje nahrané formuláre",
    "Návštěva obsahuje nahrané fotografie": "Návšteva obsahuje nahrané fotografie",
    "Návštěva odemknuta": "Návšteva odemknutá",
    "Návštěva pacienta": "Návšteva klienta",
    "Návštěva smazána": "Návšteva zmazaná",
    "Návštěva úspěšně přidána": "Návšteva úspešne pridaná",
    "Návštěva zamknuta": "Návšteva zamknutá",
    "navsteva/:patientId/:visitId": "navsteva/:patientId/:visitId",
    "Návštěvu se nepodařilo uložit": "Návštevu sa nepodarilo uložiť",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Poznámku sa nepodarilo uložiť. Skúste to prosím znovu.",
    "navstevy": "navstevy",
    "Návštěvy": "Návštevy",
    "návštěvy pacientů": "návštevy klientov",
    "Návštěvy pacientů": "Návštevy klientov",
    "Návštěvy podle fyzioterapeutů": "Návštevy podľa terapeutov",
    "návštěvy vloží do správné karty.": "návštevy vloží do správnej karty.",
    "navstevy-pacienta": "navstevy-klienta",
    "Návštěvy:": "Návštevy:",
    "Název": "Názov",
    "Název cviku": "Názov cviku",
    "Název firmy": "Názov spoločnosti",
    "Název instituce": "Názov inštitúcie",
    "Název kategorie": "Názov kategórie",
    "Název kliniky": "Názov firmy",
    "Název místnosti": "Názov miestnosti",
    "Název permanentky": "Názov permanentky",
    "Název podkategorie": "Názov podkategórie",
    "Název pojišťovny": "Názov poisťovne",
    "Název pracoviště": "Názov pracoviska",
    "Název předplatného": "Názov predplatného",
    "Název šablony": "Názov šablóny",
    "Název služby": "Názov služby",
    "Název zboží": "Názov tovaru",
    "Ne": "Nie",
    "nebo": "alebo",
    "nebo přechodem na pokročilý tarif. ": "alebo prechodom na pokročilý tarif. ",
    "Nebyly nalezeny žádné recenze.": "Neboli nájdené žiadne recenzie.",
    "Neděle": "Nedeľa",
    "Nedorazil:": "Nedorazil:",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "Najmenej 8 znakov a aspoň 1 malé písmeno",
    "Nejsou dostupné žádné místnosti": "Nie sú dostupné žiadne miestnosti",
    "Nejsou dostupné žádné předplatné": "Nie sú dostupné žiadne predplatné",
    "Nejsou dostupné žádné transakce": "Nie sú dostupné žiadne transakcie",
    "Nejsou dostupní žádní uživatelé": "Nie sú dostupní žiadni používatelia",
    "Nejsou dostupní žádní žadatelé": "Nie sú dostupní žiadni žiadatelia",
    "Nejsou k dispozici žádná data": "Nie sú k dispozícii žiadne údaje",
    "Některé funkce aplikace Fyzion vám": "Nektoré funkcie aplikacie CortexApp vám",
    "Některé z povinných údajů chybí": "Niektoré z povinných údajov chýbajú",
    "Nelze odebrat zamčený výkon": "Nenájdený žiaden doklad",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "Nemožno presunúť voľno k inému terapeutovi.",
    "Nelze smazat - zboží je na skladě.": "Nemožno zmazať - tovar je na sklade.",
    "Nemají tel.": "Nemajú tel.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "Nemáte dostatočné oprávnenie pre túto akciu.",
    "Nemáte oprávnění na smazání cizí návštěvy": "Nemáte oprávnenie na zmazanie cudzej návštevy",
    "Nemáte oprávnění na smazání návštěvy": "Nemáte oprávnenie na zmazanie návštevy",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "Nemáte oprávnenie na úpravu iného terapeuta",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "Nemáte oprávnenie na úpravu iné pracovné doby",
    "Nemáte oprávnění na úpravu permanentky": "Nemáte oprávnenie na úpravu permanentky",
    "Nemáte oprávnění na úpravu služby": "Nemáte oprávnenie na úpravu služby",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "Nemáte oprávnenie na zaplatenie cudzej návštevy",
    "Nemáte oprávnění na zrušení cizí návštěvy": "Nemáte oprávnenie na zrušenie cudzej návštevy",
    "Nemáte oprávnění pro odemknutí výkonu": "Nemáte oprávnenie pre odomknutie výkonu",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "Nemáte oprávnenie prezerať anamnézu klienta.",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "Nemáte vytvorenú zmluvu s touto poisťovňou. Pre túto poisťovňu sa dávka nevytvorí.",
    "Nemáte žádné objednané návštěvy.": "Nemáte žiadne objednané návštevy.",
    "nemusí správně fungovat.": "nemusí správne fungovať.",
    "Nemůže být záporné": "Nemôže byť záporné",
    "Nenalezen žádný dodavatel": "Nenájdený žiaden dodávateľ",
    "Nenalezen žádný doklad": "Nenájdený žiaden doklad",
    "Nenalezen žádný pacient": "Nenájdený žiaden klient",
    "Nenalezen žádný výkon": "Nenájdený žiaden doklad",
    "Nenalezena žádná akce": "Nenájdená žiadna akcia",
    "Nenalezena žádná dávka": "Nenájdená žiadna dávka",
    "Nenalezena žádná návštěva": "Nenájdená žiadna návšteva",
    "Nenalezena žádná pracoviště": "Nenájdená žiadna pracoviská",
    "Nenalezena žádná šablona": "Nenájdená žiadna šablóna",
    "Nenalezena žádná stvrzenka": "Nenájdená žiadna potvrdenka",
    "Nenalezena žádná zpráva": "Nenašla sa žiadna správa",
    "Nenalezeno žádné další zboží": "Nenájdené žiadne ďalšie tovar",
    "Nenalezeny žádné další služby": "Nenájdené žiadne ďalšie služby",
    "Nenalezeny žádné položky": "Nenájdené žiadne položky",
    "Nenalezeny žádné zásoby": "Nenájdené žiadne zásoby",
    "Není dostupný žádný platný FT poukaz": "Nie sú dostupné žiadne predplatné",
    "Není dostupný žádný výkon": "Není dostupný výkon",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "Není možné zmeniť tarif, pretože máte v kartotéke viac klientov,",
    "Není nahrána žádná fotka": "Nie je nahraná žiadna fotka",
    "Není naplánována další návštěva": "Nie je naplánovaná ďalšia návšteva",
    "Neočekávaná chyba": "Neočakávaná chyba",
    "Neomezený počet pacientů": "Neobmedzený počet klientov",
    "Neopakuje se": "Neopakuje sa",
    "Neplátce DPH": "Neplatiteľ DPH",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Nepodarilo sa aktualizovať cviky v návšteve",
    "Nepodařilo se aktualizovat den se cvičením": "Nepodarilo sa aktualizovať deň s cvičením",
    "Nepodařilo se aktualizovat šablonu": "Nepodarilo sa aktualizovať šablónu",
    "Nepodařilo se načíst budoucí návštěvy.": "Nepodarilo sa načítať budúce návštevy.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Nepodarilo sa načítať celkové hodnoty naskladnených položiek",
    "Nepodařilo se načíst cviky": "Nepodarilo sa načítať cviky",
    "Nepodařilo se načíst data": "Nepodarilo sa načítať dáta",
    "Nepodařilo se načíst data ze systému": "Nepodarilo sa načítať dáta zo systému",
    "Nepodařilo se načíst dávku": "Nepodarilo sa načítať dávku",
    "Nepodařilo se načíst dávky": "Nepodarilo sa načítať dávky",
    "Nepodařilo se načíst diagnózy": "Nepodarilo sa načítať diagnózy",
    "Nepodařilo se načíst dodavatele": "Nepodarilo sa načítať dodávateľa",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Nepodarilo sa načítať dostupných terapeutov",
    "Nepodařilo se načíst FT poukazy": "Nepodarilo sa načítať FT poukazy",
    "Nepodařilo se načíst hromadnou návštěvu": "Nepodarilo sa načítať hromadnú návštevu",
    "Nepodařilo se načíst kategorie cviků": "Nepodarilo sa načítať kategórie cvikov",
    "Nepodařilo se načíst kategorii cviků": "Nepodarilo sa načítať kategóriu cvikov",
    "Nepodařilo se načíst místnost": "Nepodarilo sa načítať miestnosť",
    "Nepodařilo se načíst místnosti": "Nepodarilo sa načítať miestnosti",
    "Nepodařilo se načíst návštěvu pacienta": "Nepodarilo sa načítať návštevu klienta",
    "Nepodařilo se načíst návštěvy pacienta": "Nepodarilo sa načítať návštevy klienta",
    "Nepodařilo se načíst novinku": "Nepodarilo sa načítať novinku",
    "Nepodařilo se načíst novinky": "Nepodarilo sa načítať novinky",
    "Nepodařilo se načíst odbornosti": "Nepodarilo sa načítať odbornosti",
    "Nepodařilo se načíst ordinaci na této adrese": "Nepodarilo sa načítať pracovisko na tejto adrese",
    "Nepodařilo se načíst pacienty": "Nepodarilo sa načítať klientov",
    "Nepodařilo se načíst permanentku": "Nepodarilo sa načítať permanentku",
    "Nepodařilo se načíst permanentky pacienta": "Nepodarilo sa načítať permanentky klienta",
    "Nepodařilo se načíst platbu": "Nepodarilo sa načítať platbu",
    "Nepodařilo se načíst platby": "Nepodarilo sa načítať platby",
    "Nepodařilo se načíst platební údaje": "Nepodarilo sa načítať platobné údaje",
    "Nepodařilo se načíst pojišťovnu": "Nepodarilo sa načítať poisťovňu",
    "Nepodařilo se načíst pojišťovny": "Nepodarilo sa načítať poisťovne",
    "Nepodařilo se načíst položku": "Nepodarilo sa načítať položku",
    "Nepodařilo se načíst pracoviště": "Nepodarilo sa načítať pracovisko",
    "Nepodařilo se načíst předplatné": "Nepodarilo sa načítať predplatné",
    "Nepodařilo se načíst recenze": "Nepodarilo sa načítať recenzie",
    "Nepodařilo se načíst šablonu": "Nepodarilo sa načítať šablónu",
    "Nepodařilo se načíst šablony": "Nepodarilo sa načítať šablóny",
    "Nepodařilo se načíst seznam diagnóz": "Nepodarilo sa načítať zoznam diagnóz",
    "Nepodařilo se načíst seznam návštěv.": "Nepodarilo sa načítať zoznam návštev.",
    "Nepodařilo se načíst seznam uživatelů": "Nepodarilo sa načítať zoznam užívateľov",
    "Nepodařilo se načíst skupiny služeb": "Nepodarilo sa načítať skupiny služieb",
    "Nepodařilo se načíst služby": "Nepodarilo sa načítať služby",
    "Nepodařilo se načíst transakce": "Nepodarilo sa načítať transakcie",
    "Nepodařilo se načíst transakci": "Nepodarilo sa načítať transakciu",
    "Nepodařilo se načíst volné termíny": "Nepodarilo sa načítať voľné termíny",
    "Nepodařilo se načíst výkony": "Nepodarilo sa načítať výkony",
    "Nepodařilo se načíst žadatele": "Nepodarilo sa načítať žiadateľa",
    "Nepodařilo se načíst zásoby": "Nepodarilo sa načítať zásoby",
    "Nepodařilo se načíst zemi": "Nepodarilo sa načítať krajinu",
    "Nepodařilo se nahrát dávku do Purobota": "Nepodarilo sa nahrať dávku do aplikácie Purobot",
    "Nepodařilo se nahrát fotku FT poukazu": "Nepodarilo sa nahrávať fotku FT poukazu",
    "Nepodařilo se nahrát soubor": "Nepodarilo sa nahrať súbor",
    "Nepodařilo se odemknout výkon": "Nepodarilo sa odomknúť výkon",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Nepodarilo sa odoslať recenziu. Skúste to prosím znova.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Nepodarilo sa označiť faktúru ako zaplatenú",
    "Nepodařilo se přidat fakturaci": "Nepodarilo sa pridať fakturáciu",
    "Nepodařilo se přidat předplatné": "Nepodarilo sa pridať predplatné",
    "Nepodařilo se smazat cvik": "Nepodarilo sa zmazať cvik",
    "Nepodařilo se smazat platbu": "Nepodarilo sa zmazať platbu",
    "Nepodařilo se smazat pojišťovnu": "Nepodarilo sa zmazať poisťovňu",
    "Nepodařilo se smazat pracoviště": "Nepodarilo sa zmazať pracovisko",
    "Nepodařilo se smazat předplatné": "Nepodarilo sa zmazať predplatné",
    "Nepodařilo se smazat recenzi": "Nepodarilo sa zmazať recenziu",
    "Nepodařilo se smazat šablonu": "Nepodarilo sa zmazať platbu",
    "Nepodařilo se uložit pracoviště žadatele": "Nepodarilo sa uložiť pracovisko žiadateľa",
    "Nepodařilo se upravit cvik.": "Nepodarilo sa upraviť cvik.",
    "Nepodařilo se upravit dostupnost": "Nepodarilo sa upraviť dostupnosť",
    "Nepodařilo se upravit fakturaci": "Nepodarilo sa upraviť fakturáciu",
    "Nepodařilo se upravit místnost": "Nepodarilo sa upraviť miestnosť",
    "Nepodařilo se upravit platbu": "Nepodarilo sa upraviť platbu",
    "Nepodařilo se upravit předplatné": "Nepodarilo sa upraviť predplatné",
    "Nepodařilo se vygenerovat export": "Nepodarilo sa vygenerovať export",
    "Nepodařilo se vygenerovat fakturu": "Nepodarilo sa vygenerovať faktúru",
    "Nepodařilo se vygenerovat platební odkaz": "Nepodarilo sa vygenerovať platobný odkaz",
    "Nepodařilo se vygenerovat zprávu": "Nepodarilo sa vygenerovať správu",
    "Nepodařilo se vytvořit cvik.": "Nepodarilo sa vytvoriť cvik",
    "Nepodařilo se vytvořit dodavatele": "Nepodarilo sa vytvoriť dodávateľa",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Nepodarilo sa vytvoriť hromadnú návštevu",
    "Nepodařilo se vytvořit kategorii.": "Nepodarilo sa vytvoriť kategóriu",
    "Nepodařilo se vytvořit místnost": "Nepodarilo sa vytvoriť miestnosť",
    "Nepodařilo se vytvořit platbu": "Nepodarilo sa vytvoriť platbu",
    "Nepodařilo se vytvořit pracoviště žadatele": "Nepodarilo sa vytvoriť pracovisko žiadateľa",
    "Nepodařilo se vytvořit šablonu": "Nepodarilo sa vytvoriť šablonu",
    "Nepodařilo se vytvořit uživatele": "Nepodarilo sa vytvoriť užívateľa",
    "Nepodařilo se zaplatit návštěvu": "Nepodarilo sa zaplatiť návštevu",
    "Nepodařilo se získat cviky pacienta": "Nemožnosť získať cvičenia klienta",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Nepodarilo sa zmeniť nastavenia rezervácií klienta",
    "Nepodařilo se zrušit platbu": "Nepodarilo sa zrušiť platbu",
    "Nepodařilo se zrušit platbu za návštěvu": "Nepodarilo sa zrušiť platbu za návštevu",
    "Nepodporovaný typ prohlížeče": "Nepodporovaný typ prehliadača",
    "nepodporovaný typ prohlížeče.": "nepodporovaný typ prehliadača.",
    "Nepovinné": "Nepovinné",
    "Nepravidelné ordinační hodiny": "Nepravidelná pracovná doba",
    "Nepřišel": "Neprišiel",
    "Nesouhlasili": "Nesúhlasili",
    "Neuhrazeno": "Nezaplatené",
    "Neukládat": "Neukladať",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Neviete ako na to? Pozrite sa na náš návod, prihláste sa na webinár alebo kontaktujte podporu.",
    "Nevystaveno": "Nevystavené",
    "Nezaplaceno": "Nezaplatene",
    "nova": "nova",
    "Nová cena": "Nová cena",
    "Nová cena s DPH": "Nová cena s DPH",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nová cena sa použije pre návštevy od zvoleného dátumu. Dovtedy platí súčasná cena služby. Vypnutím naplánovanú zmenu zrušíte.",
    "Nová fakturace": "Nová fakturácia",
    "Nová místnost": "Nová miestnosť",
    "Nová návštěva": "Nová návšteva",
    "Nová operace": "Nová operácia",
    "Nová šablona": "Nová šablóna",
    "Nová skupinová návštěva": "Nová skupinová návšteva",
    "Nová událost": "Nová udalosť",
    "nova-navsteva": "nova-navsteva",
    "nova-opravna": "nova-opravna",
    "nova-skupinova-navsteva": "nova-skupinova-navsteva",
    "nove": "nove",
    "Nové heslo": "Nové heslo",
    "Nové pracoviště žadatele": "Nové pracovisko žiadateľa",
    "Nové předplatné": "Nové predplatné",
    "Novinky": "Novinky",
    "novy": "novy",
    "Nový pacient": "Nový klient",
    "Nový žadatel": "Nový žiadateľ",
    "novy-ft-poukaz": "novy-ft-poukaz",
    "Období": "Obdobie",
    "obecne": "obecne",
    "Obecné": "Všeobecné",
    "obecného nastavení firmy": "všeobecného nastavenia firmy",
    "obecném nastavení": "všeobecnom nastavení",
    "Objednat návštěvu": "Objednať návštevu",
    "Objednat se na": "Objednať sa na",
    "Objekt": "Objekt",
    "Obměna": "Obmena",
    "obnova-hesla": "obnova-hesla",
    "Obrázek byl smazán": "Obrázok bol zmazaný",
    "Obrázky": "Obrázky",
    "Obsah": "Obsah",
    "Ochrana osobních údajů": "Ochrana osobných údajov",
    "Od": "Od",
    "Odběratel/klient": "Odberateľ/klient",
    "Odběratel/Klient": "Odberateľ/Klient",
    "Odbornost": "Odbornost",
    "Odcvičeno a přejít na další cvik": "Odcvičené a prejsť na ďalší cvik",
    "Odebrat": "Odebrat",
    "Odebrat pacienta": "Odobrať klienta",
    "Odebrat položku": "Odebrat položku",
    "Odebrat výkon": "Odebrat výkon",
    "Odemknout": "Odomknúť",
    "Odemknout výkon": "Odomknúť výkon",
    "Odesílat email": "Odosielať email",
    "Odesílat připomínku e-mailem": "Odosielať pripomienku e-mailom",
    "Odesílat SMS": "Odosielať SMS",
    "Odesílat SMS předem": "Odosielať SMS vopred",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Odosielať upozornenie e-mailom o vytvorení, zmene, zrušení návštevy",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "Odoslali sme vám e-mail s instrukciami k resetnutiu hesla.",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Odoslanie dávok s prihlásením pomocou SMS kódu v súčasnosti nie je podporované.",
    "Odeslání dávky pojišťovně selhalo": "Odoslanie dávky poisťovni zlyhalo",
    "Odeslání emailu": "Odoslanie emailu",
    "Odeslání emailu 1 pacientovi": "Odoslanie emailu 1 klientovi",
    "Odeslání emailu pacientovi": "Odoslanie emailu klientovi",
    "Odeslání SMS": "Odoslanie SMS",
    "Odeslání SMS 1 pacientovi": "Odoslanie SMS 1 klientovi",
    "Odeslání SMS pacientovi": "Odoslanie SMS klientovi",
    "Odeslání zůstalo nedokončené": "Odoslanie zostalo nedokončené",
    "Odesláno": "Odoslané",
    "Odesláno na ": "Odoslané na",
    "Odeslat": "Odoslať",
    "Odeslat 1 stvrzenku": "Odoslať 1 potvrdenku",
    "Odeslat email": "Odoslať email",
    "Odeslat GDPR mailem": "Odoslať GDPR mailom",
    "Odeslat klientovi": "Odoslať klientovi",
    "Odeslat pacientovi": "Odoslať klientovi",
    "Odeslat potvrzení o platbě": "Odoslať potvrdenie o platbe",
    "Odeslat SMS": "Odoslať SMS",
    "Odeslat znovu emailem": "Odoslať znova emailom",
    "odešlete": "odešlite",
    "Odhlásit": "Odhlásiť",
    "Odkud jste se o nás dozvěděli?": "Odkiaľ ste sa o nás dozvedeli?",
    "Odstranit časový interval": "Odstrániť časový interval",
    "Ohodnoťte kvalitu naší služby": "Ohodnoťte kvalitu našej služby",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Obmedzuje počet rezervácií tejto služby na jeden deň. Vhodné pre časovo alebo fyzicky náročné služby.",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "Ospravedlňujeme sa, ale v aplikácii CortexApp došlo k neočakávanej chybe. Niekedy aj tie najlepšie svaly potrebujú chvíľku na oddych.",
    "Online platba": "Online platba",
    "Opakování": "Opakovanie",
    "Opakovat heslo": "Opakovať heslo",
    "Opakovat jednou za": "Opakovať jednou za",
    "Opravdu si přejete archivovat pacienta?": "Naozaj si prajete klienta odobrať?",
    "Opravdu si přejete formulář smazat?": "Naozaj si prajete formulár zmazať?",
    "Opravdu si přejete fotografii smazat?": "Naozaj si prajete fotografiu zmazať?",
    "Opravdu si přejete FT poukaz smazat?": "Naozaj si prajete FT poukaz zmazať?",
    "Opravdu si přejete obrázek smazat?": "Naozaj si prajete obrázok vymazať?",
    "Opravdu si přejete pacienta odebrat?": "Naozaj si prajete klienta odobrať?",
    "Opravdu si přejete permanentku smazat?": "Naozaj si prajete permanentku zmazať?",
    "Opravdu si přejete platbu zrušit?": "Naozaj si prajete platbu zrušiť?",
    "Opravdu si přejete pojišťovnu smazat?": "Naozaj si prajete poisťovňu zmazať?",
    "Opravdu si přejete pracoviště smazat?": "Naozaj si prajete pracovisko zmazať?",
    "Opravdu si přejete recenzi smazat?": "Naozaj si prajete recenziu zmazať?",
    "Opravdu si přejete rezervaci zrušit?": "Naozaj si prajete rezerváciu zrušiť?",
    "Opravdu si přejete šablonu smazat?": "Naozaj si prajete šablónu zmazať?",
    "Opravdu si přejete smazat cvik": "Naozaj si prajete zmazať cvik",
    "Opravdu si přejete smazat kategorii cviků?": "Naozaj si prajete zmazať kategóriu cvikov?",
    "Opravdu si přejete smazat kategorii služeb": "Naozaj si prajete zmazať kategóriu služieb",
    "Opravdu si přejete smazat platbu č.": "Naozaj si prajete zmazať platbu č.",
    "Opravdu si přejete smazat předplatné": "Naozaj si prajete zmazať predplatné?",
    "Opravdu si přejete smazat službu": "Naozaj si prajete zmazať službu",
    "Opravdu si přejete stornovat stvrzenku?": "Naozaj si prajete stornovať potvrdenku?",
    "Opravdu si přejete synchronizaci odebrat?": "Naozaj si prajete synchronizáciu odstrániť?",
    "Opravdu si přejete terapeuta deaktivovat?": "Naozaj si prajete terapeuta deaktivovať?",
    "Opravdu si přejete video smazat?": "Naozaj si prajete video vymazať?",
    "Opravdu si přejete volno smazat?": "Naozaj si prajete voľno vymazať?",
    "Opravná": "Opravná",
    "Opravná dávka": "Opravná dávka",
    "Opustit průvodce": "Opustiť sprievodcu",
    "Ordinace": "Pracovisko",
    "ordinační hodiny": "pracovná doba",
    "Osobní údaje": "Osobné údaje",
    "Ostatní diagnózy": "Ostatné diagnózy",
    "Ostatní služby": "Ostatné služby",
    "Otevírací doba": "Otvorené hodiny",
    "Otevřeno": "Otvoreno",
    "Otevřít návštěvu": "Otvoriť návštevu",
    "Otevřít v novém okně": "Otvoriť v novom okne",
    "Ověření": "Overenie",
    "Označit jako zaplacené": "Označiť ako zaplatené",
    "Pacient": "Klient",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Klient bol archivovaný. Ak chcete jeho kartu obnoviť, kontaktujte podporu",
    "Pacient byl úspěšně přidán": "Klient bol úspešne pridaný",
    "Pacient ještě nepotvrdil GDPR": "Klient ešte nepotvrdil GDPR",
    "Pacient již GDPR potvrdil": "Klient už GDPR potvrdil",
    "Pacient má platný FT poukaz do %{date}.": "Klient má platný FT poukaz do %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Klient nemá nastavenú ďalšiu návštevu",
    "Pacient odebrán": "Klient odobraný",
    "Pacient odhlášen z odběru novinek": "Klient odhlásený z odberu noviniek",
    "Pacient přídán": "Klient pridaný",
    "Pacient přihlášen k odběru novinek": "Klient prihlásený k odberu noviniek",
    "Pacient úspěšně archivován": "Klient úspešne archivovaný",
    "Pacient úspěšně odebrán z čekajících pacientů": "Klient úspešne odobraný z čakajúcich klientov",
    "Pacient úspěšně přidán do čekajících pacientů": "Klient úspešne pridaný do čakajúcich klientov",
    "Pacient úspěšně upraven": "Klient úspešne upravený",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "Klient tu zatiaľ nemá žiadnu návštevu a k nej vytvorené popisy.",
    "Pacienta se nepodařilo archivovat": "Klienta sa nepodarilo archivovať",
    "Pacienta se nepodařilo odebrat": "Klienta sa nepodarilo odobrať",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "Klienta sa nepodarilo pridať do čakajúcich klientov. Skúste prosím znovu.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "Klienta sa nepodarilo prihlásiť k odberu noviniek. Skúste to prosím znovu.",
    "Pacienti": "Klienti",
    "Pacienti, kteří přišli poprvé": "Klienti, ktorí prišli po prvýkrát",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "Klientovi pošleme potvrdenie o platbe na jeho email",
    "Pacientů na stránku": "Klientov na stránku",
    "pacientům": "klientom",
    "Paragon": "Paragon",
    "paragon č.": "paragon č.",
    "Paragony": "Paragony",
    "Parametry příští návštěvy upraveny": "Parametre ďalšej návštevy upravené",
    "Pátek": "Piatok",
    "Patička faktury": "Pätička faktúry",
    "Paušální": "Paušálny",
    "PDF": "PDF",
    "Permanentka aktualizována": "Permanentka aktualizovaná",
    "Permanentka byla označena jako zaplacená": "Permanentka bola označená ako zaplatená",
    "Permanentka úspěšně odebrána pacientovi.": "Permanentka úspešne odobraná klientovi.",
    "Permanentka úspěšně přidána pacientovi.": "Permanentka úspešne pridaná klientovi.",
    "Permanentka úspěšně vytvořena": "Permanentka úspešne vytvorená",
    "Permanentkou": "Permanentkou",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Permanentku sa nepodarilo klientovi odobrať. Skúste prosím znovu.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Permanentku sa nepodarilo klientovi pridať. Skúste prosím znovu.",
    "Permanentku se nepodařilo upravit.": "Permanentku sa nepodarilo upraviť.",
    "Permanentku se nepodařilo vytvořit": "Permanentku sa nepodarilo vytvoriť",
    "Permanentky": "Permanentky",
    "placený tarif": "platený tarif",
    "planovani": "planovanie",
    "Plánování": "Plánovanie",
    "planovani-mistnosti": "planovanie-miestnosti",
    "Platba": "Platba",
    "Platba byla smazána": "Platba bola zmazaná",
    "Platba byla zrušena": "Platba bola zrušená",
    "Platba pouze na místě při terapii": "Platba iba na mieste pri terapii",
    "Platba předplatným": "Platba predplatným",
    "Platba za návštěvu byla úspěšně zrušena": "Platba za návštevu bola úspešne zrušená",
    "platby": "platby",
    "Platby": "Platby",
    "Platby za pronájem aplikace": "Úhrady za CortexApp",
    "Plátce DPH": "Platiteľ DPH",
    "Plateb na stránku": "Úhrad na stránku",
    "Platební informace": "Platebné informácie",
    "Platná do:": "Platnosť do:",
    "Platnost (v měsících)": "Platnosť (v mesiacoch)",
    "Platnost do": "Platnosť do",
    "Platnost musí být větší nebo rovna 1.": "Platnosť musí byť väčšia alebo rovná 1.",
    "Platnost nové ceny od": "Platnosť novej ceny od",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Platnosť vášho odkazu vypršala. Požiadajte si o nastavenie nového hesla",
    "Po": "Po",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "Po rezervácii budete presmerovaní na platobnú bránu na úhradu ceny terapie.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po skončení návštevy sa klientovi automaticky odošle žiadosť o spätnú väzbu.",
    "Po sloučení se všechny minulé i budoucí": "Po zlúčení sa všetky minulé i budúce",
    "Po třech dnech": "Po troch dňoch",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "Po vložení kódu na váš web sa zobrazí okno s rezerváciou",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "Po vložení kódu na váš web sa zobrazí tlačidlo s rezerváciou",
    "pobočka": "pobočka",
    "Pobočka": "Pobočka",
    "Počet": "Počet",
    "Počet dní do konce:": "Počet dní do konca:",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Počet dní pred návštevou sa odošle pripomienka pri nezaplatenej rezervácii.",
    "Počet návštěv": "Počet návštev",
    "Počet návštěv musí být větší nebo rovno 1.": "Počet návštev musí byť väčší alebo rovný 1.",
    "Počet výkonů": "Počet výkonov",
    "Počet zbývajících vstupů:": "Zostávajúcich vstupov:",
    "Počty návštěv": "Počty návštev",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Podanie nebolo odoslané poisťovni. Po zmazaní môžete dávku upraviť a odoslať znova.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podpisovanie tohto podania zostalo nedokončené. Dávku podpíšete v aplikácii CortexApp Signer a CortexApp ju odošle zdravotnej poisťovni.",
    "Podepsat a odeslat": "Podpísať a odoslať",
    "Podívám se později": "Pozriem sa neskôr",
    "Podkategorie": "Podkategória",
    "Podmínky užití": "Podmienky používania",
    "Podpis/razítko firmy": "Podpis/pečiatka firmy",
    "Podpora": "Podpora",
    "podpora@fyzion.cz": "info@cortexapp.eu",
    "Podrobnosti": "Podrobnosti",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Podrobný popis služby, ktorý sa zobrazí klientom pri výbere služby v online rezerváciách.",
    "Pohlaví": "Pohlavie",
    "Pohlaví:": "Pohlavie:",
    "Pojištění EU a mezinárodní smlouvy": "Poistenie EÚ a medzinárodné zmluvy",
    "Pojišťovna": "Poisťovňa",
    "Pojišťovna byla smazána": "Poisťovňa bola zmazaná",
    "Pojišťovna přidána": "Poisťovňa pridaná",
    "Pojišťovna upravena": "Poisťovňa upravená",
    "Pojišťovna:": "Poisťovňa:",
    "Pojišťovnou": "Poisťovňou",
    "Pojišťovny": "Poistovne",
    "Pokladna": "Pokladna",
    "Pokračovat": "Pokračovať",
    "Pokročilá funkce": "Pokročilá funkcia",
    "pokročilý tarif.": "pokročilý tarif.",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "Ak je lekcia plne obsadená, klienti sa môžu zapísať ako náhradníci.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "Ak je zapnuté, klient musí poznámku vyplniť, aby mohol rezerváciu dokončiť.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "Ak má klient aktívnu permanentku, platba za návštevu sa z nej automaticky odpočíta.",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "Ak má klient trvalé bydlisko v ČR, zadajte jeho rodné číslo bez lomítka.",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "Ak pracujete ako FO, v zdravotníckej dokumentácii budeme uvádzať Vaše identifikačné údaje. Ak nie, v zdravotníckej dokumentácii budú údaje spoločnosti.",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "Ak si kedykoľvek v budúcnosti nebudete vedieť rady, môžete sa vrátiť k sprievodcovi aplikácie.",
    "Pole je povinné": "Pole je povinné",
    "Položka byla úspěšně smazána": "Položka bola úspešne zmazaná",
    "Položka byla úspěšně upravena": "Položka bola úspešne upravená",
    "Položka byla úspěšně vytvořena": "Položka bola úspešne vytvorená",
    "Položku se nepodařilo smazat": "Položku sa nepodarilo zmazať",
    "polozky": "polozky",
    "Položky": "Položky",
    "Pondělí": "Pondelok",
    "Popis": "Popis",
    "Popis cviku": "Popis cviku",
    "Popisy návštěv": "Popisy návštev",
    "Porovnat fotky": "Porovnat fotky",
    "Porovnat fotografie": "Porovnat fotografie",
    "Porovnat můžete maximálně 2 fotografie.": "Porovnať môžete maximálne 2 fotografie.",
    "Porovnat vybrané fotografie": "Porovnať vybrané fotografie",
    "porovnavac": "porovnavac",
    "Porovnávač": "Porovnávač",
    "Poslední fakturace": "Posledná fakturácia",
    "Poslední návštěva": "Posledná návšteva",
    "Poslední návštěva:": "Posledná návšteva:",
    "Potvrdit": "Potvrdiť",
    "Potvrdit nové heslo": "Potvrdiť nové heslo",
    "Potvrďte nové heslo": "Potvrďte nové heslo",
    "Potvrzení GDPR před návštěvou fyzioterapie": "Potvrdenie GDPR pred návštevou fyzioterapie",
    "Potvrzení o podstoupené péči": "Potvrdenie o podstupenej starostlivosti",
    "Potvrzení zrušení platby": "Potvrdenie zrušenia platby",
    "potvrzeni-pece/:patientId": "potvrdenie-pece/:patientId",
    "Potvrzeno": "Potvrdené",
    "Potvrzuji": "Potvrdzujem",
    "Potvrzuji, že pacient": "Potvrdzujem, že klient",
    "Používáte": "Používate",
    "Povolit online rezervace": "Povoliť online rezervácie",
    "Povolit rezervace": "Povoliť rezervácie",
    "Povolit rezervace na státní svátky": "Povoliť rezervácie na štátne sviatky",
    "Povolit skupinovou službu": "Povoliť skupinovú službu",
    "Povolit zobrazení detailu cizí návštěvy": "Povoliť zobrazenie detailu cudzej návštevy",
    "Povolit zrušení rezervace": "Povoliť zrušenie rezervácie",
    "Poznámka": "Poznámka",
    "Poznámka k návštěvě": "Poznámka k návšteve",
    "Poznámka úspěšně smazána": "Poznámka úspešne zmazaná",
    "Poznámka úspěšně uložena": "Poznámka úspešne uložená",
    "Poznámka:": "Poznámka:",
    "Poznámku se nepodařilo uložit": "Poznámku sa nepodarilo uložiť",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Poznámku sa nepodarilo uložiť. Skúste to prosím znovu.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Pozor, blížite sa k maximálnemu počtu klientov.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Pozor, blížite sa maximálnemu počtu klientov.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Pozor, chystáte sa zaplatiť za návštevu, ktorá ešte neprebehla.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Pozor! Snažíte sa vytvoriť návštevu, ktorá porušuje nastavenie u Terapeuta, Služby alebo Miestnosti alebo dochádza k konfliktu v kalendári.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Pozor! Upravujete globálne cvičenie vytvorené aplikáciou CortexApp. Po uložení tejto úpravy vznikne duplicitné cvičenie v databáze. Pôvodné cvičenie zostane zachované v nezmenenej podobe.",
    "pracoviste": "pracovisko",
    "Pracoviště": "Pracovisko",
    "Pracoviště bylo smazáno": "Pracovisko bolo zmazané",
    "Pracoviště pro pojišťovny": "Pracovisko pre poisťovne",
    "Pracoviště upraveno": "Pracovisko upravené",
    "Pracoviště vytvořeno": "Pracovisko vytvorené",
    "Pracoviště žadatele bylo úspěšně uloženo": "Pracovisko žiadateľa bolo úspešne uložené",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Pracovisko žiadateľa bolo úspešne vytvorené",
    "Pracovní dny": "Pracovné dni",
    "Pracovní doba": "Pracovná doba",
    "Pracovníci": "Pracovníci",
    "Pracuji jako fyzická osoba": "Pracujem ako fyzická osoba",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Pred návštevou pracoviska sa, prosím, oboznámte so zásadami GDPR. Pre zobrazenie textu GDPR a potvrdenie kliknite",
    "Před pokračováním vyplňte formulář": "Pred pokračovaním vyplňte formulár",
    "Před pokračováním zadejte rodné číslo": "Pred pokračovaním zadajte rodné číslo",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Pred registraciou musíte potvrdiť súhlas so Všeobecnými obchodnými podmienkami",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Vopred vám ďakujem a teším sa na vašu návštevu.",
    "Předmět": "Predmet",
    "Předmět emailu": "Predmet emailu",
    "předplacené (permice)": "predplatené (permanentka)",
    "predplatne": "predplatne",
    "Předplatné": "Predplatné",
    "Předplatné smazáno": "Predplatné zmazané",
    "Předplatné úspěšně přidáno": "Predplatné úspešne pridané",
    "Předplatné úspěšně upraveno": "Predplatné úspešne upravené",
    "Předplatných na stránku": "Predplatných na stránku",
    "Předplatným": "Predplatným",
    "Předvolba": "Predvoľba",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Predvyplnený kód zadaný o %{time}. Platí zvyčajne 30 minút.",
    "Preferovaná místnost": "Preferovaná miestnosť",
    "Přehled cviků": "Prehľad cvikov",
    "Přehled dávek": "Prehľad dávok",
    "Přehled položek": "Prehľad položiek",
    "Přehled pracovišť": "Prehľad pracovísk",
    "Přehled transakcí": "Prehľad transakcií",
    "Přejete si vystavit doklad?": "Prajete si vystaviť doklad?",
    "Přejete si vystavit fakturu na storno poplatek?": "Prajete si vystaviť faktúru na storno poplatok?",
    "Přejete si vystavit storno doklad?": "Prajete si vystaviť storno doklad?",
    "Přejít do aplikace": "Prejsť do aplikácie",
    "Přejít do profilu": "Prejsť do profilu",
    "Přejít na tarif": "Prejsť na tarif",
    "Premium registrace": "Premium registracia",
    "Přeskočit": "Preskočiť",
    "Přesun rezervace": "Presun rezervácie",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Presun rezervácií sa riadi všeobecným nastavením firmy.",
    "Přesunout rezervaci": "Presunúť rezerváciu",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Presuňte niektorých klientov do archívu a potom objednajte tarif znovu.",
    "Převodem": "Prevodom",
    "Převodem (QR kód)": "Prevodom (QR kód)",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Pridá po skončení rezervácie časový blok, počas ktorého nebude možné vytvárať ďalšie rezervácie (napr. čas na upratovanie alebo prestávku).",
    "Přidán na seznam": "Pridaný na zoznam",
    "Přidáním dalšího fyzioterapeuta bude do konce aktuálního účtovacího období účtován poměrný poplatek za nového uživatele dle platného ceníku. Od následujícího fakturačního období bude tento uživatel automaticky zahrnut do standardní fakturace.": "Pridaním ďalšieho terapeuta bude do konca aktuálneho účtovacieho obdobia účtovaný pomerný poplatok za nového užívateľa podľa platného cenníka. Od nasledujúceho fakturačného obdobia bude tento užívateľ automaticky zahrnutý do štandardnej fakturácie.",
    "Přidat": "Pridať",
    "Přidat 3 pacienty": "Pridať 3 klientov",
    "Přidat časový interval": "Pridať časový interval",
    "Přidat čekajícího": "Pridať čakajúceho",
    "Přidat cvik": "Pridať cvik",
    "Přidat dodavatele": "Pridať dodávateľa",
    "Přidat dokument": "Pridať dokument",
    "Přidat doplňkový text do e-mailů klientům": "Pridať doplnkový text do e-mailov klientom",
    "Přidat fotku": "Pridať fotku",
    "Přidat FT poukaz": "Pridať FT poukaz",
    "Přidat fyzioterapeuta": "Pridať terapeuta",
    "Přidat k návštěvě": "Pridať k návšteve",
    "Přidat kategorii": "Pridať kategóriu",
    "Přidat místnost": "Pridať miestnosť",
    "Přidat návštěvu": "Pridať návštevu",
    "Přidat nového čekajícího": "Pridať nového čakajúceho",
    "Přidat nového pacienta": "Pridať nového klienta",
    "Přidat pacientovi permanentku": "Pridať klientovi permanentku",
    "Přidat peníze": "Pridať peniaze",
    "Přidat permanentku": "Pridať permanentku",
    "Přidat platbu": "Pridať platbu",
    "Přidat podkategorii": "Pridať podkategóriu",
    "Přidat pojišťovnu": "Pridať poisťovňu",
    "Přidat položku": "Pridať položku",
    "Přidat poznámku": "Pridať poznámku",
    "Přidat pracoviště": "Pridať pracovisko",
    "Přidat předplatné": "Pridať predplatné",
    "Přidat skupinovou návštěvu": "Pridať skupinovú návštevu",
    "Přidat službu": "Pridať službu",
    "Přidat soubor": "Pridať súbor",
    "Přidat výkon": "Pridať výkon",
    "pridat-permanentku": "pridat-permanentku",
    "pridat-volno": "pridat-volno",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Pridajte vlastné informácie, ktoré klienti potrebujú vedieť pred návštevou – napríklad kde nájdu vchod, čo si majú vziať so sebou alebo aké sú storno podmienky. Informácie sa zobrazia pod detailom rezervácie v e-maile s potvrdením návštevy a v jej pripomienke.",
    "Přihlášení jako nesprávný typ uživatele": "Prihlásenie ako nesprávny typ používateľa",
    "Přihlásit se": "Prihlásiť sa",
    "Přihlašovací jméno": "Prihlasovacie meno",
    "Přihlašovací údaje": "Prihlasovacie údaje",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Prihlasovacie údaje k portálom poisťovní sa nepodarilo načítať",
    "Přihlašovací údaje se nepodařilo smazat": "Prihlasovacie údaje sa nepodarilo vymazať",
    "Přihlašovací údaje se nepodařilo uložit": "Prihlasovacie údaje sa nepodarilo uložiť",
    "Příjemce": "Príjemca",
    "Příjemce:": "Príjemca",
    "Přijmení": "Priezvisko",
    "Příjmení": "Priezvisko",
    "Příjmy": "Príjmy",
    "Příjmy (budoucí)": "Príjmy (budúce)",
    "Příjmy fyzioterapeutů": "Príjmy terapeuta",
    "Příjmy z nabízených služeb": "Príjmy z ponúkaných služieb",
    "Přiložený soubor se nepodařilo nahrát": "Priložený súbor sa nepodarilo nahrať",
    "Případně kontaktujte naši podporu na ": "Prípadne kontaktujte našu podporu na ",
    "Připojištění": "Pripoistenie",
    "Připravujeme": "Na požiadanie",
    "Přiřazené služby": "Pridelené služby",
    "Přišel/Přijde": "Prišiel/Príde",
    "Příští návštěva": "Nasledujúca návšteva",
    "Příští objednání": "Ďalšia objednávka",
    "Příští služba": "Ďalšia služba",
    "Přítomen": "Prítomný",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "Na dokončenie rezervácie je potrebné súhlasiť so zásadami spracovania osobných údajov.",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "Pre individuálne nastavenie textácie e-mailov vašim klientom kontaktujte našu technickú podporu na",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "Pro nastavenie časového úseku, kedy je možné túto službu rezervovať online, kontaktujte našu podporu na",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "Pro nastavenie otváracej doby miestnosti kontaktujte našu podporu na",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "Pro odoslanie potvrdenia o platbe zadajte email klienta",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Na overenie SMS kódom si najprv v profile uložte prihlasovacie údaje k portálu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Na overenie SMS kódom si najprv v profile uložte prihlasovacie údaje k portálu poisťovne.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "Pre správne fungovanie aplikácie je potrebné základné nastavenie. Nebojte sa, základné nastavenie aplikácie a prehliadnutie funkcií vám zaberie len pár minút!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "Pre tohto klienta ste zatiaľ nevytvorili žiaden FT poukaz",
    "Pro zobrazení platebního QR kódu vyplňte v": "Pro zobrazenie platobného QR kódu vyplňte v",
    "Proběhlé návštěvy": "Prebehnuté návštevy",
    "Probíhá synchronizace Vašeho kalendáře": "Prebieha synchronizácia Vášho kalendára",
    "Prodané permanentky": "Prodané permanentky",
    "Prodejní cena (s DPH)": "Prodejná cena (s DPH)",
    "Prodejní cena s DPH": "Prodejná cena s DPH",
    "Prodejní cena zboží za ks (s DPH)": "Predajná cena tovaru za ks (s DPH)",
    "Prodejní hodnota (s DPH)": "Prodejná hodnota (s DPH)",
    "Profil": "Profil",
    "Profilový obrázek byl úspěšně nahrán": "Profilový obrázok bol úspešne nahraný",
    "Profily": "Profily",
    "Proklik na skupinovou návštěvu": "Preklik na skupinovú návštevu",
    "Propojené aplikace": "Propojené aplikácie",
    "Propojeno": "Propojené",
    "Propojit": "Propojit",
    "Prosím": "Prosím",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "Povedieme vás, nastavíme základné parametre, pridáme prvých klientov.",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Priemerná nákupná cena tovaru na sklade za ks (s DPH)",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "Sprievodcu a nápovedu prípadne navštívte prostredníctvom odkazu v hornom menu. Tu nájdete všetko, čo vás zaujíma prehľadne na jednom mieste.",
    "PSČ": "PSČ",
    "Původní": "Pôvodný",
    "Původní dávka": "Pôvodná dávka",
    "RČ": "RČ",
    "RČ / Datum narození": "RČ / Dátum narodenia",
    "Recenze": "Recenzie",
    "Recenze byla smazána": "Recenzie bola zmazaná",
    "Recenze návštěv": "Recenzie od klientov",
    "recenzí": "recenzií",
    "Recepční": "Recepčná",
    "Registrace": "Registrácia",
    "Registrace proběhla úspěšně": "Registracia prebehla úspešne",
    "Registrace se nepovedla": "Registrácia sa nepodarila",
    "registrace-zdarma": "registracia-zdarma",
    "Registrace/Přihlášení": "Registrácia/Prihlásenie",
    "Registrovat se": "Registrovať sa",
    "Řekněte nám více (nepovinné)…": "Povedzte nám viac (nepovinné)…",
    "Resetování hesla": "Resetovanie hesla",
    "Resetovat": "Resetovať",
    "Resetovat heslo": "Resetovať heslo",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Rezarvace byla úspěšně změněna na": "Rezervácia bola úspešne zmenená na",
    "rezervace": "rezervacia",
    "Rezervace": "Rezervácia",
    "Rezervace byla úspěšně vytvořena.": "Rezervácia bola úspešne vytvorená.",
    "Rezervace byla zrušena": "Rezervácia bola zrušená",
    "Rezervace je potvrzena až po úspěšné online platbě.": "Rezervácia je potvrdená až po úspešnej online platbe.",
    "Rezervace nemohla být vytvořena": "Rezervácia nemohla byť vytvorená",
    "Rezervace pacienta jsou povoleny": "Rezervácie klienta sú povolené.",
    "Rezervace pacienta jsou zablokovány": "Rezervácie klienta sú zablokované.",
    "Rezervace úspěšně vytvořena": "Rezervácia úspešne vytvorená",
    "Rezervaci již nelze zrušit online": "Rezerváciu už nie je možné zrušiť online",
    "Rezervaci můžete zrušit do": "Rezerváciu môžete zrušiť do",
    "Rezervaci nelze zrušit online": "Rezerváciu nie je možné zrušiť online",
    "Rezervaci se nepodařilo zrušit": "Rezerváciu sa nepodarilo zrušiť",
    "Rezervovat": "Rezervovať",
    "Rezervujte si termín": "Rezervujte si termín",
    "Rezervujte si termín u": "Rezervujte si termín u",
    "Režim zobrazení": "Režim zobrazenia",
    "Roční": "Ročná",
    "Rodné číslo": "Rodné číslo",
    "Rodné číslo pacienta": "Rodné číslo klienta",
    "Rodné číslo:": "Rodné číslo:",
    "Rok": "Rok",
    "Roky": "Roky",
    "Role": "Rola",
    "Rozpis termínů fyzioterapie": "Rozpis termínov fyzioterapie",
    "Rozpracovaná návštěva uložena": "Rozpracovaná návšteva uložená",
    "Rozpracované podání bylo smazáno": "Rozpracované podanie bolo zmazané",
    "Rozpracované podání se nepodařilo smazat": "Rozpracované podanie sa nepodarilo zmazať",
    "Rozvrh místností": "Rozvrh miestností",
    "S nezaplacenými návštěvami": "S nezaplatenými návštevami",
    "Šablon na stránku": "Šablóna na stránku",
    "Šablona byla úspěšně aktualizována": "Šablóna bola úspešne aktualizovaná",
    "Šablona byla úspěšně smazána": "Šablóna bola úspešne zmazaná",
    "Šablona byla úspěšně vytvořena": "Šablóna bola úspešne vytvorená",
    "sablony": "sablony",
    "Šablony": "Šablóny",
    "Sazba DPH": "Sazba DPH",
    "Sdílejte": "Sdíľajte",
    "SDÍLEJTE NÁS": "SDIEĽAJTE NÁS",
    "sdílet": "sdíľať",
    "sdílet aplikaci": "sdíľať aplikáciu",
    "Sklad": "Sklad",
    "Skupinová návštěva": "Skupinová návšteva",
    "Skupinovka": "Skupinovka",
    "Skutečně si přejete změnit tarif?": "Skutočne si prajete zmeniť tarif?",
    "Sloučení karet": "Slúčenie kariet",
    "Sloučit karty": "Spoločniť karty",
    "Služba": "Služba",
    "Služba nenalezena": "Služba nenájdená",
    "Služba:": "Služba:",
    "sluzby": "sluzby",
    "Služby": "Služby",
    "Služby dle kategorií celkem za rok": "Služby podľa kategórií celkovo za rok",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Služby nebudú zmazané, kategórie im bude len odobraná.",
    "Služby:": "Služby:",
    "Smazání": "Vymazanie",
    "Smazáno": "Vymazané",
    "Smazat": "Vymazať",
    "Smazat cvik": "Zmazať cvik",
    "Smazat dodavatele": "Vymazať dodavateľa",
    "Smazat formulář": "Vymazať formulár",
    "Smazat fotku": "Vymazať fotku",
    "Smazat fotografii": "Vymazať fotografiu",
    "Smazat kategorii cviků": "Zmazať kategóriu cvikov",
    "Smazat kategorii služeb": "Vymazať kategóriu služieb",
    "Smazat návštěvu": "Vymazať návštevu",
    "Smazat obrázek": "Vymazať obrázok",
    "Smazat permanentku": "Vymazať permanentku",
    "Smazat podání": "Zmazať podanie",
    "Smazat pojišťovnu": "Vymazať poisťovňu",
    "Smazat položku": "Vymazať položku",
    "Smazat pouze toto volno": "Vymazať len túto návštevu",
    "Smazat pouze tuto návštěvu": "Vymazať len túto návštevu",
    "Smazat pracoviště": "Vymazať pracovisko",
    "Smazat předplatné": "Zmazať predplatné",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Vymazať prihlasovacie údaje k portálu %{portal}?",
    "Smazat recenzi": "Vymazať recenziu",
    "Smazat rozpracované podání": "Zmazať rozpracované podanie",
    "Smazat rozpracované podání?": "Zmazať rozpracované podanie?",
    "Smazat šablonu": "Vymazať šablónu",
    "Smazat službu": "Vymazať službu",
    "Smazat soubor": "Zmazať súbor",
    "Smazat stávající zápis": "Vymazať existujúci zápis",
    "Smazat toto a všechna budoucí volna": "Vymazať túto a všetky budúce návštevy",
    "Smazat tuto a všechny budoucí návštěvy": "Vymazať túto a všetky budúce návštevy",
    "Smazat video": "Zmazať video",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Zmaže rozpracované podanie, napr. aby ste mohli dávku upraviť a odoslať znova",
    "Smluvní pojištění": "Smluvné poistenie",
    "SMS byla úspěšně odeslána": "SMS bola úspešne odoslaná",
    "SMS byly úspěšně odeslána": "SMS boli úspešne odoslané",
    "SMS čekajícímu": "SMS čakajúcemu",
    "SMS kód": "SMS kód",
    "SMS kód se nepodařilo vyžádat": "SMS kód sa nepodarilo vyžiadať",
    "SMS se nepodařilo odeslat": "SMS sa nepodarilo odoslať",
    "Sobota": "Sobota",
    "Soubor se nepodařilo stáhnout": "Súbor sa nepodarilo stiahnuť",
    "Soubory úspěšně nahrány": "Súbory úspešne nahrané",
    "Současné heslo": "Súčasné heslo",
    "Souhlas s GDPR": "Súhlas s GDPR",
    "Souhlas s novinkami:": "Súhlas s novinkami:",
    "Souhlas udělen": "Súhlas udelený",
    "Souhlasil s novinkami": "Súhlasil s novinkami",
    "Souhlasili": "Súhlasili",
    "Souhlasím se": "Súhlasím so",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "Súhlasím so zasielaním noviniek a zaujímavých ponúk",
    "Splatnost": "Splatnost",
    "Splatnost faktury": "Splatnost faktúry",
    "Stačí": "Stačí",
    "Stáhnout": "Stiahnuť",
    "Stáhnout fakturu": "Stiahnuť faktúru",
    "Stáhnout soubory": "Stiahnuť súbory",
    "Stáhnout zálohovou fakturu": "Stiahnuť zálohovú faktúru",
    "Statistiky": "Štatistiky",
    "Status": "Status",
    "Stav": "Stav",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Stav bude zmenený v oboch prípadoch. Voľbou „Áno“ sa doklad vystaví spoločne so zmenou stavu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Stav bude zmenený v oboch prípadoch. Voľbou „Áno“ sa faktúra vystaví spoločne so zmenou stavu.",
    "Stav návštěvy byl změněn": "Stav návštevy bol zmenený",
    "Stav platby": "Stav platby",
    "Storno": "Storno",
    "stornovanou fakturu č.": "faktúru č.",
    "stornovaný paragon č.": "paragon č.",
    "Stornovat": "Stornovať",
    "stránka někam utekla...": "stránka niekam utiekla...",
    "Středa": "Streda",
    "Stvrzenek na stránku": "Zobrazenie na stránku",
    "svůj prohlížeč nebo si nainstalujte jiný.": "svoj prehliadač alebo si nainštalujte iný.",
    "Synchronizace kalendáře byla zrušena": "Synchronizacia kalendara bola zrusena",
    "Synchronizace s Google kalendářem": "Synchronizacia s Google kalendárom",
    "Synchronizace se nezdařila": "Synchronizacia sa nezdarila",
    "synchronizace-kalendare": "synchronizacia-kalendara",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Synchronizujte svoj CortexApp kalendár s kalendárom Google",
    "Tarif": "Tarify",
    "Tarify": "Tarify",
    "Tato funkce je dostupná pouze v placeném tarifu.": "Táto funkcia je dostupná len v platenom tarife.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "Táto funkcia je dostupná iba vo vyššom tarife.\n Tieto tarify ukrývajú veľa pokročilých funkcií,\nktoré vám uľahčia prácu.",
    "Tato karta se smaže.": "Táto karta sa vymaže.",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "Táto služba bude automaticky predvyplnená pri vytváraní novej návštevy.",
    "Telefon": "Telefón",
    "Telefonní číslo": "Telefónne číslo",
    "Telefonní číslo:": "Telefónne číslo:",
    "Tento měsíc": "Tento mesiac",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "Tento klient má nezaplatenú návštevu, ktorá nebola ospravedlnená.",
    "Tento rok": "Tento rok",
    "Tento týden": "Tento týždeň",
    "Text": "Text",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Text s inštrukciami pre klienta, čo má do poznámky uviesť (napr. Uveďte svoje zdravotné ťažkosti alebo obmedzenia).",
    "Těžší varianta": "Ťažšia varianta",
    "theme_company": "Cortexapp",
    "Tisk": "Tisk",
    "Tisk GDPR": "Tisk GDPR",
    "Tisk karty pacienta": "Tisk karty klienta",
    "Tisk návštěv": "Tlač návštev",
    "Tisk návštěvy": "Tlač návštevy",
    "Tisk rozpisu termínů návštěv": "Tlač rozpisu termínov návštev",
    "Toto okno můžete zavřít.": "Toto okno môžete zavrieť.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "Toto podanie už na autorizáciu nečaká, medzitým sa dokončilo.",
    "Toto pole je povinné": "Toto pole je povinné",
    "Trvání služby v minutách": "Trvanie služby v minútach",
    "týden": "týždeň",
    "Týdně": "Týždenne",
    "týdnů": "týždňov",
    "týdny": "týždne",
    "Týdny": "Týždne",
    "Typ dokladu": "Typ dokladu",
    "Typ permanentky": "Typ permanentky",
    "Typ platby": "Typ platby",
    "Typ připojištění": "Typ poistenia",
    "Typ připojištění:": "Typ poistenia:",
    "Typ šablony": "Typ šablón",
    "Typ transakce": "Typ transakcie",
    "Typ výkonu": "Typ výkonu",
    "Typ vyšetření": "Typ služby",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "Tieto informácie sú vaše súkromné kontaktné údaje. Zmenu verejných kontaktných údajov, ktoré vidia klienti, urobíte v ",
    "Tyto údaje vyplňte pouze v případě, že chcete dávky pojišťovnám odesílat s ověřením přihlašovacími údaji a SMS kódem. Pokud dávky podepisujete certifikátem ve Fyzion Signeru, vyplňovat je nemusíte. Účet na portálu musí mít zapnuté přihlášení pomocí SMS.": "Tieto údaje vyplňte iba v prípade, že chcete dávky poisťovniam odosielať s overením prihlasovacími údajmi a SMS kódom. Ak dávky podpisujete certifikátom v CortexApp Signeri, vyplňovať ich nemusíte. Účet na portáli musí mať zapnuté prihlásenie pomocou SMS.",
    "Účast pacienta": "Účasť klienta",
    "Údaje instituce": "Údaje o inštitúcii",
    "Údaje o pojištění": "Údaje o poistení",
    "Údaje pro platbu převodem": "Údaje pre platbu prevodom",
    "Údaje úspěšně změněny": "Údaje úspešne zmenené",
    "Úhloměr": "Úhlomer",
    "Uhrazeno": "Zaplatené",
    "Ulice a č. p.": "Ulica a súpisné číslo",
    "Ulice a č.p.": "Ulica a súpisné číslo",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Uložené heslo vám nikdy nezobrazíme. Ponechajte pole prázdne, ak ho nechcete meniť.",
    "Uložené šablony": "Uložené šablóny",
    "Uloženo": "Uložené",
    "uložit": "uložiť",
    "Uložit": "Uložiť",
    "Uložit a zamknout": "Uložiť a zamknúť",
    "Uložit jako PDF do karty pacienta": "Uložiť ako PDF do karty klienta",
    "Uložit rozpracované": "Uložiť rozpracované",
    "Uložit změny": "Uložiť zmeny",
    "Úprava": "Uprava",
    "Úprava příští návštěvy": "Úprava ďalšej návštevy",
    "upravit": "upraviť",
    "Upravit": "Upraviť",
    "Upravit cvik": "Upraviť cvik",
    "Upravit dodavatele": "Upraviť dodávateľa",
    "Upravit dostupnost": "Upraviť dostupnosť",
    "Upravit fakturaci": "Upraviť fakturaciu",
    "Upravit FT poukaz": "Upraviť FT poukaz",
    "Upravit fyzioterapeuta": "Upraviť terapeuta",
    "Upravit kategorii": "Upraviť kategóriu",
    "Upravit kategorii cviků": "Upraviť kategóriu cvikov",
    "Upravit kategorii služeb": "Upraviť kategóriu služieb",
    "Upravit místnost": "Upraviť miestnosť",
    "Upravit ordinační hodiny": "Upraviť pracovnú dobu",
    "Upravit pacientovu permanentku": "Upraviť klientovu permanentku",
    "Upravit permanentku": "Upraviť permanentku",
    "Upravit platbu č.": "Upraviť platbu č.",
    "Upravit podkategorii": "Upraviť podkategóriu",
    "Upravit pojišťovnu": "Upraviť poisťovňu",
    "Upravit položku": "Upraviť položku",
    "Upravit pracoviště": "Upraviť pracovisko",
    "Upravit pracoviště žadatele": "Upraviť pracovisko žiadateľa",
    "Upravit šablonu": "Upraviť šablónu",
    "Upravit službu": "Upraviť službu",
    "Upravit uživatele": "Upraviť užívateľa",
    "Upravit žadatele": "Upraviť žiadateľa",
    "upravit-ft-poukaz/:ticketId": "upravit-ft-poukaz/:ticketId",
    "upravit-permanentku/:ticketId": "upravit-permanentku/:ticketId",
    "upravit-volno": "upravit-volno",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Určuje maximálny počet klientov na skupinovú návštevu. Hodnota 0 sa rovná neobmedzenému počtu klientov.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "Určuje základný stav odosielania stvrdeniek. Toto nastavenie môžete ešte individuálne upravovať pred samotnou platbou za návštevu.",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Určuje, v akom časovom rozpätí (počet dní) musia byť všetky rezervácie v rámci jednej objednávky.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Určuje, či musí byť počas služby prítomný terapeut. Vypína sa napr. pri službách bez priamej obsluhy (vaňa, infrasauna a pod.).",
    "user.form.role.worker.tooltip": "Používateľ má prístup ku klientom a kalendáru, ale nie k nastaveniam vašej aplikácie.",
    "Úterý": "Utorok",
    "Už mám odcvičeno:": "Už mám odcvičené:",
    "Územní pracoviště VZP": "Uzemné pracovisko VZP",
    "Uživatel": "Užívateľ",
    "Uživatel byl deaktivován": "Užívateľ bol deaktivovaný",
    "Uživatel byl úspěšně přidán": "Užívateľ bol úspešne pridaný",
    "V historii cvičení nejsou žádné záznamy.": "V histórii cvičenia nie sú žiadne záznamy.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "V histórii rezervácií zatiaľ nie je žiadna absolvovaná návšteva.",
    "V měsících, ode dne zakoupení": "V mesiacoch, odo dňa zakúpenia",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "v najnovšej verzii Google Chrome, ktorú môžete zadarmo stiahnuť na",
    "V ordinaci hotově/kartou": "V pracovisku v hotovosti/kartou",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "V prípade, že je táto voľba zapnutá, klientom automaticky odchádzajú aj potvrdenky za zakúpené permanentky.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "V prípade, že prejdete na nejaký z pokročilých tarifov spolupráce, automaticky sa ruší limit na počet klientov v aplikácii.",
    "V případě, že se nemůžete dostavit, volejte na": "V prípade, že sa nemôžete dostaviť, volajte na",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "Počas tohto obdobia je počet návštev u každého terapeuta nulový.",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "V tomto okamihu nie je možné GDPR potvrdiť. Skúste to znovu neskôr.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "Vám navýšime limit kartotéky klientov v balíčku Freemium.",
    "Variabilní symbol": "Variabilný symbol",
    "Variabilní symbol:": "Variabilný symbol:",
    "vaše číslo účtu nebo IBAN.": "vaše číslo účtu alebo IBAN.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Vaše heslo bolo úspešne zmenené. Teraz sa môžete prihlásiť.",
    "Vaše kategorie služeb byla smazána": "Vaša kategória služieb bola zmazaná",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Vaša platba prebehla v poriadku. Veľmi ďakujeme, že využívate aplikáciu Cortex.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Vaša platba sa bohužiaľ nezdarila. Skúste platbu opakovať. Ak platba opäť neprebehne v poriadku, môžete skúsiť zaplatiť prevodom.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "Vaše rodné číslo potrebujeme na vytvorenie vašej karty klienta, alebo aby sme overili, že u nás už kartu máte. S rodným číslom nakladáme v súlade s vyhláškou o zdravotníckej dokumentácii.",
    "Vaše služba byla smazána": "Vaša služba bola zmazaná",
    "Vaše zpráva": "Vaša správa",
    "Vaši rezervaci už nelze zrušit online!": "Vašu rezerváciu už nie je možné zrušiť online!",
    "Včera": "Včera",
    "včetně prodeje zboží": "vrátane predaja tovaru",
    "Veřejné zdravotní pojištění": "Verejné zdravotné poistenie",
    "Více informací": "Viac informácií",
    "Vítáme vás v aplikaci Fyzion": "Vitáme vás v aplikaci CortexApp",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Vitajte na prihlasovacej stránke klientského portálu CortexApp.",
    "Vítejte v CortexApp": "Vítejte vo CortexApp",
    "Volno (Dovolená)": "Volno (Dovolenka)",
    "Volno odstraněno": "Volno odstránené",
    "Vrátit do průvodce?": "Vrátiť do sprievodcu?",
    "Vše": "Všetko",
    "Všechny": "Všetky",
    "Všechny doklady": "Všetky doklady",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "Všetky návštevy klienta zostanú vo vašom kalendári, ale už nebude možné vytvárať nové návštevy pre klienta ani sa vám nebude zobrazovať v zozname klientov.",
    "Všechny pracoviště": "Všetky pracoviská",
    "Všechny typy služeb": "Všetky typy služieb",
    "Všeobecné obchodní podmínky": "Všeobecné obchodné podmienky",
    "všeobecnými obchodními podmínkami": "všeobecnými obchodnými podmienkami",
    "Všeobecnými obchodními podmínkami": "Všeobecnými obchodnými podmienkami",
    "Všichni": "Všetci",
    "Všichni pacienti": "Všetci klienti",
    "Vyberte": "Vyberte",
    "Vyberte alespoň jednu službu": "Vyberte aspoň jednu službu",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Vyberte kategóriu služby podľa jej typu (napr. masáže, skupinové cvičenie). Kategória ovplyvňuje prehľadnosť a zobrazenie služieb v online rezerváciách.",
    "Vyberte obrázky": "Vyberte obrázky",
    "Vyberte pacienta": "Vyberte klienta",
    "Vyberte předplatné": "Vyberte predplatné",
    "Vyberte prosím alespoň 1 fotografii.": "Vyberte prosím aspoň 1 fotografiu.",
    "Vyberte šablonu": "Vyberte šablónu",
    "Vyberte soubor": "Vyberte súbor",
    "Vyberte termín": "Vyberte termín",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Vyberte typ výkonu z číselníka ÚZIS. Povinné pole slúžiace na štatistiky a vykazovanie.",
    "Vyberte video": "Vyberte video",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Vybrané dávky elektronicky podpíšete v aplikácii CortexApp Signer — jedným podpisom, v ktorom dávky najprv prejdete. CortexApp ich potom odošle zdravotnej poisťovni a o výsledku vás bude informovať e-mailom.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Vybrané dávky odošlite s overením jedným SMS kódom. Hromadne možno odoslať iba dávky poisťovní jedného portálu. O výsledku vás budeme informovať e-mailom.",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "Vybraný terapeut nevykonáva vybranú službu. Vyberte si inú službu alebo terapeuta.",
    "Vybrat": "Vybrať",
    "Vybrat barvu": "Vybrať farbu",
    "Vybrat diagnózu": "Vybrať diagnózu",
    "Vybrat dodavatele": "Vybrať dodávateľa",
    "Vybrat druh péče": "Vybrať druh starostlivosti",
    "Vybrat druh úhrady": "Vybrať druh úhrady",
    "Vybrat IČP": "Vybrať IČP",
    "Vybrat kategorii": "Vybrať kategóriu",
    "Vybrat kód": "Vybrať kód",
    "Vybrat období": "Vybrať obdobie",
    "Vybrat odbornost": "Vybrať odbornost",
    "Vybrat ostatní diagnózy": "Vybrať ostatné diagnózy",
    "Vybrat pacienta": "Vybrať klienta",
    "Vybrat podkategorii": "Vybrať podkategóriu",
    "Vybrat pracoviště": "Vybrať pracovisko",
    "Vybrat pracovníky": "Vybrať pracovníkov",
    "Vybrat správnou kartu": "Vybrať správnu kartu",
    "Vybrat vše": "Vybrať všetko",
    "Vybrat výkon": "Vybrať výkon",
    "Výchozí": "Východzie",
    "Výchozí šablona": "Východzia šablóna",
    "Vyčistit filtr": "Vyčistiť filter",
    "Vygenerovat fakturu": "Vygenerovať faktúru",
    "Vyhledat": "Vyhľadať",
    "Výkon": "Výkon",
    "Výkon je odemknutý": "Výkon je odomknutý",
    "Výkon je zamknutý": "Výkon je zamknutý",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "Výkon nie je možné upraviť, pretože je už priradený k návšteve.",
    "Výkonová": "Výkonová",
    "výkonů": "výkonov",
    "Výkonů na stránku": "Výkonov na stránku",
    "vykony": "vykony",
    "Výkony": "Výkony",
    "Vyplňte ve formátu +420 123 456 789": "Vyplňte vo formáte +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Vyplňte vo formáte DD.MM.RRRR",
    "Vyplňte ve formátu HH:mm": "Vyplnte v tvare HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Vyplňte, pokiaľ klient zmenil poisťovňu, aby sme mohli správne vytvoriť dávku.",
    "Výše max. úhrady": "Výška max. úhrady",
    "Výše max. úhrady:": "Výška max. úhrady:",
    "Výše paušálu:": "Výška paušálu:",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Výška storno poplatku účtovaného pri zrušení rezervácie.",
    "Vyšetřil:": "Vyšetril:",
    "výskytech": "výskytoch",
    "výskytu": "výskytu",
    "Vytváření rezervace": "Vytváranie rezervácie",
    "Vytvoření": "Vytvorenie",
    "Vytvořeno": "Vytvorene",
    "Vytvořit": "Vytvoriť",
    "Vytvořit 3 návštěvy": "Vytvoriť 3 návštevy",
    "Vytvořit dávku": "Vytvoriť dávku",
    "Vytvořit dávky": "Vytvoriť dávky",
    "Vytvořit faktury": "Vytvoriť faktúry",
    "Vytvořit novou kategorii": "Vytvoriť novú kategóriu",
    "Vytvořit novou podkategorii": "Vytvoriť novú podkategóriu",
    "Vytvořit novou rezervaci": "Vytvoriť novú rezerváciu",
    "Vytvořit novou službu": "Vytvoriť novú službu",
    "Vytvořit nový cvik": "Vytvoriť nový cvik",
    "Vytvořit opravnou dávku": "Vytvoriť opravnú dávku",
    "Vytvořit platbu": "Vytvoriť platbu",
    "Vytvořit rezervaci": "Vytvoriť rezervaciu",
    "Vytvořit zprávu": "Vytvoriť správu",
    "Využívat klientský portál": "Využívať klientský portál",
    "Vyžádat SMS kód": "Vyžiadať SMS kód",
    "Vyzkoušejte Fyzion Zdarma!": "Vyskúšajte CortexApp zadarmo!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Vyskúšajte CortexApp zadarmo a presvedčte sa sami, prečo ho používa viac ako 1000 terapeutov v Českej republike. Stačí vyplniť niekoľko údajov v nižšie uvedenom formulári a môžete začať. Neskôr môžete ľahko prejsť na vyšší tarif.",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Vždy uvádzajte meno klienta (i v prípade dieťaťa)",
    "Webinář": "Webinár",
    "z": "z",
    "z ceny aplikace": "z ceny aplikacie",
    "z toho v hotovosti": "z toho v hotovosti",
    "Začínáme": "Začíname",
    "Zadané telefonní číslo je neplatné.": "Zadané telefónne číslo je neplatné.",
    "zadatele": "zadatela",
    "Žadatelé": "Žiadatelia",
    "Žadatelé na stránku": "Žiadatelia na stránku",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Zadajte názov služby, ktorú ponúkate (napr. individuálna fyzioterapia, elektroliečba, detská fyzioterapia, zdravotné cvičenie). Názov sa zobrazuje v kalendári aj v online rezervačnom systéme.",
    "Zadejte nové heslo": "Zadajte nové heslo",
    "Zadejte platnou e-mailovou adresu": "Zadajte platnú e-mailovú adresu",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Zadajte prosím e-mail, na ktorý Vám zašleme informácie k obnoveniu hesla.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Zadajte SMS kód z portálu poisťovne. Platný kód, ktorý už máte, môžete použiť znova, nový si vyžiadajte len vtedy, keď žiadny nemáte.",
    "Zadejte validní tel. číslo": "Zadajte validné tel. číslo",
    "Žádná služba není k dispozici": "Žiadna služba nie je k dispozícii",
    "Žádné akce k zobrazení": "Žiadne akcie k zobrazeniu",
    "Žádné dávky k zobrazení": "Žiadne dávky k zobrazeniu",
    "Žádné doklady k zobrazení": "Žiadne doklady k zobrazeniu",
    "Žádné návštěvy k zobrazení": "Žiadne návštevy k zobrazeniu",
    "Žádné stvrzenky k zobrazení": "Žiadne potvrdenky k zobrazeniu",
    "Žádné výkony k zobrazení": "Žiadne dávky k zobrazeniu",
    "Žádné zpráva k zobrazení": "Žiadna správa na zobrazenie",
    "Žádný fyzioterapeut není dostupný": "Žiaden terapeut nie je dostupný",
    "Zahrnuté služby": "Zahrnuté služby",
    "Základní diagnóza": "Základná diagnóza",
    "Zákonný zástupce": "zákonný zástupca",
    "Zákonný zástupce:": "zákonný zástupca:",
    "Zákres": "Zákres",
    "Zaměstnanci": "Zamestnanci",
    "Zaměstnanec": "Používateľ",
    "Zamezit online rezervace:": "Zabrániť online rezervácii:",
    "Zamknutou návštěvu nelze měnit.": "Zamknutú návštevu nie je možné meniť.",
    "Zaplaceno": "Zaplatené",
    "zaplatit": "Zaplatiť",
    "Zaplatit": "Zaplatiť",
    "Zaplatit pomocí QR kódu": "Zaplatiť pomocou QR kódu",
    "Zaplatit QR kódem": "Zaplatiť QR kódom",
    "Zaplaťte pomocí QR kódu": "Zaplaťte pomocou QR kódu",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Zaplaťte predplatným, jestliže ho nejaká inštitúcia poskytuje",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Zapnutím povolíte zobrazovanie služby v online rezervačnom systéme. Bez zapnutia nebude možné službu rezervovať online.",
    "Zapomněli jste heslo?": "Zabudli ste heslo?",
    "Zapsáno": "Zapsané",
    "Zapsat výkon": "Zapsať výkon",
    "zásadami zpracování osobních údajů": "zásadami spracovania osobných údajov",
    "Zásob na stránku": "Zásob na stránku",
    "zasoby": "zasoby",
    "Zásoby": "Zásoby",
    "Zásoby na skladě": "Zásoby na sklade",
    "Zatím nebyla nahrána žádná videa.": "Zatiaľ neboli nahrané žiadne videá.",
    "Zatím nebyly nahrány žádné obrázky.": "Zatiaľ neboli nahrané žiadne obrázky.",
    "Zatím nebyly vytvořeny žádné permanentky": "Zatiaľ neboli vytvorené žiadne permanentky",
    "Zatím nejsou nahrána žádná videa.": "Zatiaľ nie sú nahrané žiadne videá.",
    "Zatím nejsou naplánovány žádné cviky.": "Zatiaľ nemáte naplánované žiadne cviky",
    "Zatím nejsou žádné recenze.": "Zatiaľ nie sú žiadne recenzie.",
    "Zatím nemáte naplánované žádné pacienty": "Zatiaľ nemáte naplánovaných žiadnych klientov",
    "Zatím zde nejsou žádné cviky": "Zatiaľ tu nie sú žiadne cviky",
    "Zatím zde nejsou žádné položky": "Zatiaľ tu nie sú žiadne položky",
    "Zatím zde nejsou žádné předplatné": "Zatiaľ tu nie sú žiadne platby",
    "Zatím zde nejsou žádné proběhlé návštěvy": "Zatiaľ tu nie sú žiadne prebehnuté návštevy",
    "Zatím zde nejsou žádné šablony": "Zatiaľ tu nie sú žiadne šablóny",
    "Zatím zde nejsou žádné služby": "Zatiaľ tu nie sú žiadne služby",
    "Zatím zde nejsou žádné zásoby": "Zatiaľ tu nie sú žiadne zásoby",
    "Zatím zde nejsou žádní dodavatelé": "Zatiaľ tu nie sú žiadny dodávatelia",
    "Zatím zde nejsou žádní pacienti": "Zatiaľ tu nie sú žiadni klienti",
    "Zavolat do ordinace": "Zavolat do ordinacie",
    "Zavřeno": "Zatvorené",
    "Zavřít": "Zavrieť",
    "Zavřít menu": "Zavrieť menu",
    "Zavřít platbu": "Zatvoriť platbu",
    "Zboží": "Tovar",
    "Zboží bylo úspěšně naskladněno": "Tovar bol úspešne naskladnený",
    "Zboží se nepodařilo naskladnit": "Tovar sa nepodarilo naskladniť",
    "Zbývající počet znaků": "Zbývajúci počet znakov",
    "Zbývajících vstupů": "Zostávajúcich vstupov",
    "Zdá se, že nám hledaná": "Zdá sa, že nám hľadaná",
    "Zdarma": "Zdarma",
    "ZDARMA": "ZDARMA",
    "ZDE": "ZDE",
    "Zdravotní pojišťovna": "Zdravotná poisťovňa",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zdravotná poisťovňa podanie odmietla, pretože certifikát, ktorým bola dávka podpísaná, nie je zavedený u vášho účtu na jej portáli. Podpíšte podanie certifikátom, ktorý máte na portáli zdravotnej poisťovne zavedený, a dávku odošlite znova.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zdravotná poisťovňa podanie odmietla, pretože SMS kód bol neplatný alebo mu vypršala platnosť. Vyžiadajte si nový kód a dávku odošlite znova.",
    "Žena": "Žena",
    "Ženy": "Ženy",
    "Ženy (budoucí)": "Ženy (ženy objednané)",
    "Zjistit více": "Zistiť viac",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Skontrolujte prosím zadanú adresu v prehliadači.",
    "Zkopírováno": "Zkopírované",
    "Zkopírovat": "Skopírovať",
    "Zkopírovat odkaz do schránky": "Zkopírovať odkaz do schránky",
    "Změna hesla": "Zmena hesla",
    "Změna tarifu není možná": "Zmena tarifu nie je možná",
    "Změnit": "Zmeniť",
    "Změnit heslo": "Zmeniť heslo",
    "Změnit stav na „%{status}“?": "Zmeniť stav na „%{status}“?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "Zmeniť typ platby alebo sumu môžete v editácii platieb.",
    "Zobrazit": "Zobrazit",
    "Zobrazit méně": "Zobrazit menej",
    "Zpět": "Späť",
    "Zpět do aplikace": "Návrat do aplikácie",
    "Zpět na cviky": "Späť na zoznam dávok",
    "Zpět na přihlášení": "Späť na prihlásenie",
    "Zpět na seznam dávek": "Späť na zoznam dávok",
    "Zpráva od terapeuta": "Správa od terapeuta",
    "Způsob platby": "Spôsob platby",
    "Způsob platby při rezervaci online": "Spôsob platby pri rezervácii online",
    "Zrušení rezervace": "Zrušenie rezervácie",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Zrušenie rezervácií sa riadi všeobecným nastavením firmy.",
    "Zrušení se storno poplatkem (před návštěvou)": "Zrušenie so storno poplatkom (pred návštevou)",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "Zrušením platby stornujete vytvorenú stvrdenku, vrátite vstup na permanentku alebo vrátite kredity na predplatné. Záleží na predchádzajúcom type platby.",
    "Zrušeno": "Zrušiť",
    "Zrušeno terapeutem": "Zrušené terapeutom",
    "Zrušit": "Zrušiť",
    "ZRUŠIT FILTR": "ZRUŠIŤ FILTR",
    "Zrušit návštěvu": "Pridať návštevu",
    "Zrušit platbu": "Zrušiť platbu",
    "Zrušit rezervaci": "Zrušiť rezerváciu",
    "Zůstat na stránce": "Zostať na stránke",
    "Zvolit": "Zvolit",
    "Zvolit fyzioterapeuta": "Zvoliť terapeuta",
    "Zvolit službu": "Zvoliť službu",
    "Zvolit typ služby": "Zvoliť typ služby",
    "Zvolte alespoň jeden výkon": "Zvoľte aspoň jeden výkon",
    "Zvolte alespoň jednu pojišťovnu": "Zvoľte aspoň jednu poisťovňu",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Zvoľte farbu, ktorou bude služba označená v kalendári a rezervačnom systéme.",
    "Zvolte čas": "Zvoľte čas",
    "Zvolte datum": "Zvoľte dátum"
  },
  "pl": {
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktywacja udostępni portal klienta. Po zaplanowaniu wizyty nowego klienta lub rezerwacji klient automatycznie otrzyma zaproszenie do portalu klienta.",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automatycznie wysyła klientowi informację o utworzeniu, zmianie lub odwołaniu wizyty.",
    "Bylo to užitečné?": "Czy to było pomocne?",
    "Částka nesmí být vyšší než cena návštěvy": "Kwota nie może być wyższa niż cena wizyty",
    "Čeká na autorizaci": "Oczekuje na autoryzację",
    "Čeká na platbu": "Oczekuje na płatność",
    "Certifikát": "Certyfikat",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Data obowiązywania przyszłej ceny nie może być w przeszłości.",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Paczkę podpiszesz elektronicznie w aplikacji CortexApp Signer, a CortexApp wyśle ją do zakładu ubezpieczeń zdrowotnych.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Paczkę można wysłać elektronicznie bezpośrednio do zakładu ubezpieczeń zdrowotnych, z podpisem certyfikatem lub z weryfikacją kodem SMS.",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Paczki zostały zakolejkowane do wysłania do zakładu ubezpieczeń. O wyniku poinformujemy Cię e-mailem.",
    "Děkujeme za zpětnou vazbu": "Dziękujemy za opinię",
    "Dokončit odeslání": "Dokończ wysyłanie",
    "Dokončit odeslání dávky": "Dokończ wysyłanie paczki",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokończyć wysyłanie paczki nr %{number} dla zakładu ubezpieczeń %{insurance}?",
    "Hromadné odeslání dávek pojišťovně selhalo": "Zbiorcza wysyłka paczek do zakładu ubezpieczeń nie powiodła się",
    "Karta klienta": "Karta klienta",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Strefa klienta jest wyłączona. Możesz ją włączyć w",
    "Nadpis bloku": "Nagłówek bloku",
    "Napište poznámku…": "Napisz notatkę…",
    "Naplánovat změnu ceny od zvoleného data": "Zaplanuj zmianę ceny od wybranej daty",
    "Nová cena": "Nowa cena",
    "Nová cena s DPH": "Nowa cena z VAT",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nowa cena będzie obowiązywać dla wizyt od wybranej daty. Do tego czasu obowiązuje obecna cena usługi. Wyłączenie anuluje zaplanowaną zmianę.",
    "obecného nastavení firmy": "ogólnych ustawień firmy",
    "obecném nastavení": "ustawieniach ogólnych",
    "Odesílat připomínku e-mailem": "Wysyłać przypomnienie e-mailem",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Wysyłać powiadomienie e-mailem o utworzeniu, zmianie lub odwołaniu wizyty",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Wysyłanie paczek z logowaniem za pomocą kodu SMS nie jest obecnie obsługiwane.",
    "Odeslání dávky pojišťovně selhalo": "Nie udało się wysłać paczki do zakładu ubezpieczeń",
    "Odeslání zůstalo nedokončené": "Wysyłanie zostało niedokończone",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Ogranicza liczbę rezerwacji tej usługi w ciągu jednego dnia.",
    "Otevřít návštěvu": "Otwórz wizytę",
    "Ověření": "Weryfikacja",
    "Platba pouze na místě při terapii": "Płatność wyłącznie na miejscu",
    "Platnost nové ceny od": "Nowa cena obowiązuje od",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po zakończeniu wizyty klientowi automatycznie zostanie wysłana prośba o opinię.",
    "Po sloučení se všechny minulé i budoucí": "Po scaleniu wszystkie przeszłe i przyszłe",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Liczba dni przed wizytą, kiedy wysyłane jest przypomnienie o nieopłaconej rezerwacji.",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Zgłoszenie nie zostało wysłane do zakładu ubezpieczeń. Po usunięciu możesz edytować paczkę i wysłać ją ponownie.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podpisywanie tego zgłoszenia zostało niedokończone. Paczkę podpiszesz w aplikacji CortexApp Signer, a CortexApp wyśle ją do zakładu ubezpieczeń zdrowotnych.",
    "Podepsat a odeslat": "Podpisz i wyślij",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Szczegółowy opis usługi wyświetlany klientom podczas wyboru usługi w rezerwacjach online.",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "Jeśli termin jest w pełni obsadzony, klienci mogą zapisać się na listę rezerwową.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "Jeśli włączone, klient musi uzupełnić notatkę, aby móc dokończyć rezerwację.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "Jeśli klient posiada aktywny karnet, płatność zostanie z niego automatycznie odliczona.",
    "Povolit skupinovou službu": "Włącz usługę grupową",
    "Poznámku se nepodařilo uložit": "Nie udało się zapisać notatki",
    "Předplatné Fyzion": "Předplatné Cortex",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Wstępnie wypełniono kod wpisany o %{time}. Zwykle jest ważny 30 minut.",
    "Přejete si vystavit doklad?": "Czy chcesz wystawić dokument?",
    "Přejete si vystavit fakturu na storno poplatek?": "Czy chcesz wystawić fakturę za opłatę za anulowanie?",
    "Přejete si vystavit storno doklad?": "Czy chcesz wystawić dokument storno?",
    "Přejít do profilu": "Przejdź do profilu",
    "Přesun rezervace": "Zmiana terminu rezerwacji",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Zmiana terminu rezerwacji odbywa się zgodnie z ogólnymi ustawieniami firmy.",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Dodaje po zakończeniu wizyty blok czasowy, w którym nie można tworzyć kolejnych rezerwacji.",
    "Přidat doplňkový text do e-mailů klientům": "Dodaj dodatkowy tekst do e-maili dla klientów",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Dodaj własne informacje, które klienci powinni znać przed wizytą – na przykład gdzie znajdą wejście, co mają ze sobą zabrać lub jakie są warunki anulowania. Informacje pojawią się pod szczegółami rezerwacji w e-mailu z potwierdzeniem wizyty oraz w jej przypomnieniu.",
    "Přihlašovací jméno": "Login",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Nie udało się wczytać danych logowania do portali zakładów ubezpieczeń",
    "Přihlašovací údaje se nepodařilo smazat": "Nie udało się usunąć danych logowania",
    "Přihlašovací údaje se nepodařilo uložit": "Nie udało się zapisać danych logowania",
    "Přítomen": "Obecny",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Aby weryfikować kodem SMS, najpierw zapisz w profilu dane logowania do portalu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Aby weryfikować kodem SMS, najpierw zapisz w profilu dane logowania do portalu zakładu ubezpieczeń.",
    "Řekněte nám více (nepovinné)…": "Powiedz nam więcej (opcjonalnie)…",
    "Rezervace je potvrzena až po úspěšné online platbě.": "Rezerwacja zostaje potwierdzona dopiero po pomyślnej płatności online.",
    "Rozpracované podání bylo smazáno": "Niedokończone zgłoszenie zostało usunięte",
    "Rozpracované podání se nepodařilo smazat": "Nie udało się usunąć niedokończonego zgłoszenia",
    "Smazáno": "Usunięto",
    "Smazat podání": "Usuń zgłoszenie",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Usunąć dane logowania do portalu %{portal}?",
    "Smazat rozpracované podání": "Usuń niedokończone zgłoszenie",
    "Smazat rozpracované podání?": "Usunąć niedokończone zgłoszenie?",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Usuwa niedokończone zgłoszenie, np. abyś mógł edytować paczkę i wysłać ją ponownie",
    "SMS kód": "Kod SMS",
    "SMS kód se nepodařilo vyžádat": "Nie udało się zażądać kodu SMS",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Status zostanie zmieniony w obu przypadkach. Wybór „Tak” spowoduje wystawienie dokumentu wraz ze zmianą statusu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Status zostanie zmieniony w obu przypadkach. Wybór „Tak” spowoduje wystawienie faktury wraz ze zmianą statusu.",
    "Stav návštěvy byl změněn": "Status wizyty został zmieniony",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "Usługa będzie automatycznie wybierana przy tworzeniu nowej wizyty.",
    "Text": "Tekst",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Tekst z instrukcjami dla klienta, co powinien wpisać w notatce (np. dolegliwości zdrowotne lub ograniczenia).",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "To zgłoszenie nie oczekuje już na autoryzację, w międzyczasie zostało zakończone.",
    "Tyto údaje vyplňte pouze v případě, že chcete dávky pojišťovnám odesílat s ověřením přihlašovacími údaji a SMS kódem. Pokud dávky podepisujete certifikátem ve Fyzion Signeru, vyplňovat je nemusíte. Účet na portálu musí mít zapnuté přihlášení pomocí SMS.": "Wypełnij te dane tylko wtedy, gdy chcesz wysyłać paczki do zakładów ubezpieczeń z weryfikacją danymi logowania i kodem SMS. Jeśli podpisujesz paczki certyfikatem w CortexApp Signer, nie musisz ich wypełniać. Konto na portalu musi mieć włączone logowanie przez SMS.",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Zapisanego hasła nigdy Ci nie pokażemy. Pozostaw pole puste, jeśli nie chcesz go zmieniać.",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Określa przedział czasowy (liczbę dni), w którym muszą się mieścić wszystkie rezerwacje w jednym zamówieniu.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Określa, czy podczas usługi musi być obecny terapeuta.",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Wybierz kategorię usługi na podstawie jej rodzaju (np. masaże, ćwiczenia grupowe). Kategoria wpływa na przejrzystość i wyświetlanie usług w systemie rezerwacji online.",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Rodzaj świadczenia wybrany z katalogu ÚZIS. Pole obowiązkowe do raportowania.",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Wybrane paczki podpiszesz elektronicznie w aplikacji CortexApp Signer — jednym podpisem, w którym najpierw przejrzysz paczki. CortexApp następnie wyśle je do zakładu ubezpieczeń zdrowotnych i poinformuje Cię o wyniku e-mailem.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Wybrane paczki wyślij z weryfikacją jednym kodem SMS. Zbiorczo można wysłać tylko paczki zakładów ubezpieczeń jednego portalu. O wyniku poinformujemy Cię e-mailem.",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Wysokość opłaty pobieranej przy anulowaniu rezerwacji.",
    "Vyšetřil:": "Zbadał:",
    "Vytváření rezervace": "Tworzenie rezerwacji",
    "Využívat klientský portál": "Korzystaj z portalu klienta",
    "Vyžádat SMS kód": "Poproś o kod SMS",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Wprowadź nazwę oferowanej usługi (np. fizjoterapia indywidualna, elektroterapia, fizjoterapia dziecięca, ćwiczenia prozdrowotne). Nazwa będzie wyświetlana w kalendarzu i systemie rezerwacji online.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Wpisz kod SMS z portalu zakładu ubezpieczeń. Ważny kod, który już masz, możesz wykorzystać ponownie, nowy zamów tylko wtedy, gdy żadnego nie masz.",
    "Zamknutou návštěvu nelze měnit.": "Zablokowanej wizyty nie można zmieniać.",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Umożliwia wyświetlanie usługi w systemie rezerwacji online. Bez aktywacji nie będzie można zarezerwować usługi online.",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zakład ubezpieczeń zdrowotnych odrzucił zgłoszenie, ponieważ certyfikat, którym podpisano paczkę, nie jest zarejestrowany na Twoim koncie na jego portalu. Podpisz zgłoszenie certyfikatem zarejestrowanym na portalu zakładu ubezpieczeń zdrowotnych i wyślij paczkę ponownie.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zakład ubezpieczeń zdrowotnych odrzucił zgłoszenie, ponieważ kod SMS był nieprawidłowy lub wygasł. Zamów nowy kod i wyślij paczkę ponownie.",
    "Změnit stav na „%{status}“?": "Zmienić status na „%{status}”?",
    "Způsob platby při rezervaci online": "Sposób płatności przy rezerwacji online",
    "Zrušení rezervace": "Anulowanie rezerwacji",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Anulowanie rezerwacji odbywa się zgodnie z ogólnymi ustawieniami firmy.",
    "Zrušení se storno poplatkem (před návštěvou)": "Anulowanie z opłatą manipulacyjną (przed wizytą)",
    "Zrušeno terapeutem": "Odwołane przez terapeutę",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Kolor oznaczający usługę w kalendarzu i systemie rezerwacji."
  },
  "cs": {
    " pacientů. Přidáním tohoto pacienta tuto kapacitu překročíte.": " klientů. Přidáním tohoto klienta tuto kapacitu překročíte.",
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/pridat-pojistovnu",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/upravit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/upravit",
    ":patientId/popisy-navstev": ":patientId/popisy-navstev",
    ":serviceGroupId/upravit": ":serviceGroupId/upravit",
    ":serviceId/upravit": ":serviceId/upravit",
    ":stockItemId/upravit": ":stockItemId/upravit",
    ":supplierId/upravit": ":supplierId/upravit",
    ":userId/ordinacni-hodiny": ":userId/ordinacni-hodiny",
    ":userId/upravit": ":userId/upravit",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte",
    "(Přišli poprvé)": "(Přišli poprvé)",
    "/akce": "/akce",
    "/cekajici-pacienti": "/cekajici-klienti",
    "/cviky": "/cviky",
    "/domu": "/domu",
    "/historie-akci": "/historie-akci",
    "/historie-zprav": "/historie-zprav",
    "/kalendar": "/kalendar",
    "/moje-navstevy": "/moje-navstevy",
    "/moje-profily": "/moje-profily",
    "/moje-udaje": "/moje-udaje",
    "/nastaveni": "/nastaveni",
    "/novinky": "/novinky",
    "/ordinace": "/pracoviste",
    "/pacienti": "/klienti",
    "/pacienti/novy": "/klienti/novy",
    "/platba": "/platba",
    "/pojistovny": "/pojistovny",
    "/profil": "/profil",
    "/pruvodce/": "/pruvodce/",
    "/rozcestnik-pruvodce/": "/rozcestnik-pruvodce/",
    "/rozsireni-kartoteky-zdarma": "/rozsireni-kartoteky-zdarma",
    "/sklad": "/sklad",
    "/skupinove-navstevy/": "/skupinove-navstevy/",
    "/statistiky": "/statistiky",
    "/tisk": "/tisk",
    "%": "%",
    "• IČO": "• IČO",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů terapie.",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.",
    "1. čvrtletí": "1. čvrtletí",
    "2. čtvrtletí": "2. čtvrtletí",
    "3 - Úraz způsobený jinou osobou": "3 - Úraz způsobený jinou osobou",
    "3. čtvrtletí": "3. čtvrtletí",
    "4 - Alkohol a omamné látky": "4 - Alkohol a omamné látky",
    "4. čvrtletí": "4. čvrtletí",
    "5 - Pracovní úraz": "5 - Pracovní úraz",
    "6 - Sociální důvody hospitalizace": "6 - Sociální důvody hospitalizace",
    "60 pacientů": "60 klientů",
    "7 - Porušení léčebného režimu": "7 - Porušení léčebného režimu",
    "8 - Výměna komponent systému ASR_TM": "8 - Výměna komponent systému ASR_TM",
    "9 - Nemoc z povolání": "9 - Nemoc z povolání",
    "A ROZŠIŘTE SI KARTOTÉKU": "A ROZŠIŘTE SI KARTOTÉKU",
    "a zaplatit": "a zaplatit",
    "a získejte neomezenou kapacitu kartotéky.": "a získejte neomezenou kapacitu kartotéky.",
    "absolvoval tyto návštěvy": "absolvoval tyto návštěvy",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu",
    "Adresa": "Adresa",
    "Adresa sídla": "Adresa sídla",
    "Adresa:": "Adresa:",
    "Adresát": "Adresát",
    "Akce": "Akce",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.",
    "Aktivní tarif": "Aktivní tarif",
    "aktualizujte": "aktualizujte",
    "anamneza": "anamneza",
    "Anamnéza": "Anamnéza",
    "Anamnéza zatím nebyla vyplněna.": "Anamnéza zatím nebyla vyplněna.",
    "Anamnéza:": "Anamnéza:",
    "Anamnézu se nepodařilo načíst": "Anamnézu se nepodařilo načíst",
    "Anamnézu se nepodařilo uložit": "Anamnézu se nepodařilo uložit",
    "Anamnézy": "Anamnézy",
    "Ano": "Ano",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "aplikaci CortexApp na sociálních sítích nebo kdekoliv na webu.",
    "Aplikovat změny na toto a všechna budoucí volna": "Aplikovat změny na toto a všechna budoucí volna",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Aplikovat změny na tuto a všechny budoucí návštěvy",
    "Aplikovat změny pouze na toto volno": "Aplikovat změny pouze na toto volno",
    "Aplikovat změny pouze na tuto návštěvu": "Aplikovat změny pouze na tuto návštěvu",
    "Archivace": "Archivace",
    "Archivovat": "Archivovat",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Balíček zdarma je v základním nastavení limitován počtem klientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na",
    "Bankovní údaje": "Bankovní údaje",
    "Barva": "Barva",
    "Barva místnosti v kalendáři": "Barva místnosti v kalendáři",
    "Barva v kalendáři": "Barva v kalendáři",
    "Beru na vědomí": "Beru na vědomí",
    "bezchybně a rychle": "bezchybně a rychle",
    "bezhotovostně": "bezhotovostně",
    "Bezplatná registrace": "Bezplatná registrace",
    "Bezplatná verze aplikace umožňuje evidovat až %{count} pacientů. Pokud chcete přidávat další pacienty, aktivujte si": "Bezplatná verze aplikace umožňuje evidovat až %{count} klientů. Pokud chcete přidávat další klienty, aktivujte si",
    "Bodů": "Bodů",
    "Body": "Body",
    "Budoucí návštěvy": "Budoucí návštěvy",
    "Čas": "Čas",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Čas byl úspěšně vybrán. Vyberte ještě",
    "Čas do je povinný": "Čas do je povinný",
    "Čas od je povinný": "Čas od je povinný",
    "Čas:": "Čas:",
    "Částka": "Částka",
    "Částka bude vypočítána jako celková cena všech položek.": "Částka bude vypočítána jako celková cena všech položek.",
    "Částka k úhradě": "Částka k úhradě",
    "Částka nesmí být vyšší než cena návštěvy": "Částka nesmí být vyšší než cena návštěvy",
    "Čeká na autorizaci": "Čeká na autorizaci",
    "Čeká na platbu": "Čeká na platbu",
    "Čeká na zaplacení": "Čeká na zaplacení",
    "Čekající": "Čekající",
    "Čekající pacienti": "Čekající klienti",
    "Čekající:": "Čekající:",
    "Celkem": "Celkem",
    "Celkem k úhradě": "Celkem k úhradě",
    "Celkem návštěv:": "Celkem návštěv:",
    "Celý den": "Celý den",
    "Cena": "Cena",
    "Cena nemůže být nižší než 0": "Cena nemůže být nižší než 0",
    "Cena nesmí být záporná": "Cena nesmí být záporná",
    "Cena permanentky": "Cena permanentky",
    "Cena s DPH": "Cena s DPH",
    "Cena za MJ": "Cena za MJ",
    "Cena:": "Cena:",
    "Certifikát": "Certifikát",
    "Červená": "Červená",
    "Cestovní zdravotní pojištění": "Cestovní zdravotní pojištění",
    "Četl/a jsem a souhlasím se": "Četl/a jsem a souhlasím se",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.",
    "Charakter": "Charakter",
    "Charakter dávky": "Charakter dávky",
    "Chcete pokračovat v zadání návštěvy:": "Chcete pokračovat v zadání návštěvy:",
    "Chci naplánovat": "Chci naplánovat",
    "chyba": "chyba",
    "Čísla dokladů v dávce od": "Čísla dokladů v dávce od",
    "Čísla faktur": "Čísla faktur",
    "Číslo": "Číslo",
    "Číslo dávky": "Číslo dávky",
    "Číslo dokladu": "Číslo dokladu",
    "Číslo pojištěnce": "Číslo pojištěnce",
    "Číslo pojištěnce nemusí být správné": "Číslo pojištěnce nemusí být správné",
    "Číslo pojištěnce:": "Číslo pojištěnce:",
    "Číslo pojišťenec": "Číslo pojišťenec",
    "Číslo účtu": "Číslo účtu",
    "Číslovat dávky od": "Číslovat dávky od",
    "Číslovat faktury od": "Číslovat faktury od",
    "client photo": "client photo",
    "Co je nového?": "Co je nového?",
    "Čtvrtek": "Čtvrtek",
    "Čtvrtletí": "Čtvrtletí",
    "Čtvrtletní": "Čtvrtletní",
    "cvik": "cvik",
    "Cvik": "Cvik",
    "cviků": "cviků",
    "cviky": "cviky",
    "Cviky": "Cviky",
    "Cviky na vybraný den": "Cviky na vybraný den",
    "Další akce": "Další akce",
    "Další krok postupu": "Další krok postupu",
    "Další položka": "Další položka",
    "Další výkon": "Další výkon",
    "Data se načítají...": "Data se načítají...",
    "Datum": "Datum",
    "Datum a čas": "Datum a čas",
    "Datum inventury": "Datum inventury",
    "Datum je povinné": "Datum je povinné",
    "Datum narození": "Datum narození",
    "Datum narození:": "Datum narození:",
    "Datum naskladnění": "Datum naskladnění",
    "Datum návštěvy": "Datum návštěvy",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Datum platnosti budoucí ceny nemůže být v minulosti.",
    "Datum splatnosti:": "Datum splatnosti:",
    "Datum transakce": "Datum transakce",
    "Datum vystavení": "Datum vystavení",
    "Datum začátku cvičení": "Datum začátku cvičení",
    "Datum zaplacení": "Datum zaplacení",
    "Datum zdanitelného plnění": "Datum zdanitelného plnění",
    "Datum změny pojištění:": "Datum změny pojištění:",
    "Datum změny pojišťovny": "Datum změny pojišťovny",
    "Datum:": "Datum:",
    "Dávek na stránku": "Dávek na stránku",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Dávku elektronicky podepíšete v aplikaci CortexApp Signer a CortexApp ji odešle zdravotní pojišťovně.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.",
    "Dávku se nepodařilo vytvořit": "Dávku se nepodařilo vytvořit",
    "davky": "davky",
    "Dávky": "Dávky",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.",
    "Dávky vytvořeny": "Dávky vytvořeny",
    "DD.MM.RRRR": "DD.MM.RRRR",
    "Deaktivovat": "Deaktivovat",
    "Deaktivovat terapeuta": "Deaktivovat terapeuta",
    "dekujeme": "dekujeme",
    "Děkujeme za vaší recenzi!": "Děkujeme za vaší recenzi!",
    "Děkujeme!": "Děkujeme!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.",
    "Délka (min.)": "Délka (min.)",
    "den": "den",
    "Den": "Den",
    "Denně": "Denně",
    "detail": "detail",
    "Detail následující návštěvy": "Detail následující návštěvy",
    "Detail návštěvy": "Detail návštěvy",
    "Detail poslední návštěvy": "Detail poslední návštěvy",
    "Detail rezervace": "Detail rezervace",
    "Detail vybraného profilu": "Detail vybraného profilu",
    "Diagnóza": "Diagnóza",
    "DIČ": "DIČ",
    "dne": "dne",
    "Dne": "Dne",
    "Dnes": "Dnes",
    "dní": "dní",
    "dnů": "dnů",
    "dny": "dny",
    "Dny": "Dny",
    "Do": "Do",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "Do karty klienta nebyly zatím nahrány žádné formuláře.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "Do karty klienta nebyly zatím nahrány žádné fotografie.",
    "Do průvodce": "Do průvodce",
    "Doba splatnosti": "Doba splatnosti",
    "Doba trvání": "Doba trvání",
    "Doba trvání pro pacienty": "Doba trvání pro klienty",
    "Doba trvání:": "Doba trvání:",
    "Dobrý den": "Dobrý den",
    "Dodavatel": "Dodavatel",
    "Dodavatel byl úspěšně smazán": "Dodavatel byl úspěšně smazán",
    "Dodavatel byl úspěšně upraven": "Dodavatel byl úspěšně upraven",
    "Dodavatel byl úspěšně vytvořen": "Dodavatel byl úspěšně vytvořen",
    "dodavatele": "dodavatele",
    "Dodavatelé": "Dodavatelé",
    "Dodavatele se nepodařilo smazat": "Dodavatele se nepodařilo smazat",
    "Dodavatele se nepodařilo upravit": "Dodavatele se nepodařilo upravit",
    "Doklady": "Doklady",
    "Dokončeno": "Dokončeno",
    "Dokončit odeslání": "Dokončit odeslání",
    "Dokončit odeslání dávky": "Dokončit odeslání dávky",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "Dokument byl úspěšně nahrán a odeslán",
    "Dokumenty": "Dokumenty",
    "Doplňková služba": "Doplňková služba",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "Dosáhli jste maximálního počtu klientů v kartotéce. ",
    "Dosažení maximálního počtu pacientů": "Dosažení maximálního počtu klientů",
    "Dotazník": "Dotazník",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)",
    "Dotazník pro pacienta": "Dotazník pro klienta",
    "DPH": "DPH",
    "DPH%": "DPH%",
    "Druh péče": "Druh péče",
    "Druh péče:": "Druh péče:",
    "Druh úhrady": "Druh úhrady",
    "Druh úhrady:": "Druh úhrady:",
    "Duplikovat": "Duplikovat",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "E-mail se nepodařilo odeslat.",
    "E-mail úspěšně odeslán": "E-mail úspěšně odeslán",
    "E-mailová adresa": "E-mailová adresa",
    "E-mailová adresa:": "E-mailová adresa:",
    "Editace údajů pacienta": "Editace údajů klienta",
    "Email": "Email",
    "Email byl úspěšně poslán": "Email byl úspěšně poslán",
    "Email odeslán": "E-mail odeslán",
    "Export bude vygenerován a zaslán na e-mail": "Export bude vygenerován a zaslán na e-mail",
    "Exportovat": "Exportovat",
    "Exportovat data": "Exportovat data",
    "Exportovat PDF": "Exportovat PDF",
    "Exportovat platby": "Exportovat platby",
    "Exportovat výkony": "Exportovat výkony",
    "Faktura": "Faktura",
    "Faktura bude vygenerována a zaslána na e-mail": "Faktura bude vygenerována a zaslána na e-mail",
    "Faktura byla označena jako zaplacená": "Faktura byla označena jako zaplacená",
    "Fakturace": "Fakturace",
    "Fakturace byla označena jako zaplacená": "Fakturace byla označena jako zaplacená",
    "Fakturace úspěšně přidána": "Fakturace úspěšně přidána",
    "Fakturace úspěšně upravena": "Fakturace úspěšně upravena",
    "Fakturace za období": "Fakturace za období",
    "Fakturace za období:": "Fakturace za období:",
    "Fakturační údaje": "Fakturační údaje",
    "fakturacni-udaje": "fakturacni-udaje",
    "fakturu č.": "fakturu č.",
    "faktury": "faktury",
    "Faktury": "Faktury",
    "Filtrovat": "Filtrovat",
    "Filtrovat pacienty": "Filtrovat klienty",
    "Filtrujte cviky podle jména": "Filtrujte cviky podle jména",
    "finance": "finance",
    "Finance": "Finance",
    "flag": "flag",
    "Formulář úspěšně nahrán": "Formulář úspěšně nahrán",
    "Formuláře se nepodařilo načíst": "Formuláře se nepodařilo načíst",
    "Fotka FT poukazu": "Fotka FT poukazu",
    "Fotka FT poukazu byla úspěšně nahrána": "Fotka FT poukazu byla úspěšně nahrána",
    "Fotku obrazovky s Vaším sdílením": "Fotku obrazovky s Vaším sdílením",
    "Fotogalerie": "Fotogalerie",
    "fotografie": "fotografie",
    "Fotografie se nepodařilo načíst.": "Fotografie se nepodařilo načíst.",
    "Fotografie smazána": "Fotografie smazána",
    "Fotografie úspěšně nahrána": "Fotografie úspěšně nahrána",
    "Fotografie ze dne": "Fotografie ze dne",
    "Fotografie:": "Fotografie:",
    "FT poukaz": "FT poukaz",
    "FT poukaz byl úspěšně vytvořen": "FT poukaz byl úspěšně vytvořen",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě klienta.",
    "FT poukaz úspěšně smazán": "FT poukaz úspěšně smazán",
    "FT poukaz úspěšně upraven": "FT poukaz úspěšně upraven",
    "FT poukazy": "FT poukaz",
    "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.": "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.",
    "Fyzion funguje": "CortexApp funguje",
    "Fyzion premium function": "CortexApp premium function",
    "fyzion-faktura.pdf": "cortexapp-faktura.pdf",
    "fyzion-zalohova-faktura.pdf": "cortexapp-zalohova-faktura.pdf",
    "Fyzioterapeut": "Terapeut",
    "Fyzioterapeut a místnost": "Terapeut a místnost",
    "Fyzioterapeut je povinný": "Terapeut je povinný",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Terapeut nemá vyplněné ordinační hodiny",
    "Fyzioterapeut:": "Terapeut:",
    "fyzioterapeuti": "terapeuti",
    "Fyzioterapeuti": "Terapeuti",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Terapeuti úspěšně resetováni podle diagnózy",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR souhlas",
    "GDPR úspěšně potvrzeno.": "GDPR úspěšně potvrzeno.",
    "GDPR:": "GDPR:",
    "Google kalendář": "Google kalendář",
    "Hesla se neshodují": "Hesla se neshodují",
    "Heslo": "Heslo",
    "Heslo bylo úspěšně změněno": "Heslo bylo úspěšně změněno",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.",
    "Historie akcí": "Historie akcí",
    "Historie cvičení": "Historie cvičení",
    "Historie emailů a SMS": "Historie emailů a SMS",
    "Historie návštěv": "Historie návštev",
    "Historie rezervací": "Historie rezervací",
    "Hledanému výrazu neodpovídá žádná diagnóza": "Hledanému výrazu neodpovídá žádná diagnóza",
    "Hledanému výrazu neodpovídá žádné pracoviště": "Hledanému výrazu neodpovídá žádné pracoviště",
    "Hledanému výrazu neodpovídá žádný pacient": "Hledanému výrazu neodpovídá žádný klient",
    "Hledanému výrazu neodpovídá žádný poukaz": "Hledanému výrazu neodpovídá žádný doklad",
    "Hledanému výrazu neodpovídá žádný výkon": "Hledanému výrazu neodpovídá žádný výkon",
    "Hodnota bodu": "Hodnota bodu",
    "Hodnota bodu:": "Hodnota bodu:",
    "Hotově": "Hotově",
    "Hotovo": "Hotovo",
    "Hromadné odeslání dávek pojišťovně selhalo": "Hromadné odeslání dávek pojišťovně selhalo",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://www.cortexapp.eu/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://www.cortexapp.eu/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://cortexapp.eu/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/",
    "https://fyzion.cz/cs/webinar/": "https://cortexapp.eu/cs/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://cortexapp.eu/navod-pojistovny",
    "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/": "https://cortexapp.eu/documents/67/2025-9-23_N%C3%A1vod_CortexApp_v%C4%8Detn%C4%9B_Comgate_finfin.pdf",
    "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/": "https://cortexapp.eu/documents/67/2025-9-23_N%C3%A1vod_CortexApp_v%C4%8Detn%C4%9B_Comgate_finfin.pdf",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://www.cortexapp.eu/cs/navod-cortexapp",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IBAN": "IBAN",
    "IČ": "IČ",
    "IČO": "IČO",
    "IČP": "IČP",
    "IČP žadatele": "IČP žadatele",
    "IČZ": "IČZ",
    "Identifikační údaje pacienta:": "Identifikační údaje klienta:",
    "Identifikační údaje poskytovatele:": "Identifikační údaje poskytovatele:",
    "Ignorovat automatické přepsání": "Ignorovat automatické přepsání",
    "info@fyzion.cz": "info@cortexapp.eu",
    "Informace o návštěvách": "Informace o návštěvách",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Informace o Vaší rezervaci jsme Vám poslali na e-mail",
    "inventura": "inventura",
    "Inventura": "Inventura",
    "Inventura zboží": "Inventura zboží",
    "Inventura zboží úspěšně provedena": "Inventura zboží úspěšně provedena",
    "Inventuru zboží se nepodařilo uložit": "Inventuru zboží se nepodařilo uložit",
    "Jak chcete pokračovat?": "Jak chcete pokračovat?",
    "Jak chcete provedené změny aplikovat?": "Jak chcete provedené změny aplikovat?",
    "Jak na propojení s PURObotem?": "Jak na propojení s PURObotem?",
    "Jak na to": "Jak na to",
    "Jak navýšit limit kartotéky pacientů?": "Jak navýšit limit kartotéky klientů?",
    "Jak si přejete aplikovat tuto šablonu?": "Jak si přejete aplikovat tuto šablonu?",
    "Jaké služby poskytuje?": "Jaké služby poskytuje?",
    "Jakýkoliv": "Jakýkoliv",
    "Jde o duplicitní kartu?": "Jde o duplicitní kartu?",
    "Jdeme na to teď!": "Jdeme na to teď!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "Je-li funkce zapnuta a klient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "Je-li tato funkce vypnuta, terapeut vidí návštěvy ostatních terapeutů, ale nemůže se prokliknout do jejich detailu",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce",
    "Jméno": "Jméno",
    "Jméno pojištěnce": "Jméno pojištěnce",
    "Jméno:": "Jméno:",
    "Jméno/název": "Jméno/název",
    "Jméno/Název": "Jméno/Název",
    "Jsou předepsané výkony": "Jsou předepsané výkony",
    "K návštěvě existuje více než jedna platba": "K návštěvě existuje více než jedna platba",
    "K platbě": "K platbě",
    "K poukazu zatím není zapsaný žádný výkon": "K poukazu zatím není zapsaný žádný výkon",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "K této cvičební poloze nejsou k dispozici žádné další informace.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "K této návštěvě nebyl zatím přidán žádný popis.",
    "K této recenzi nebyl přidán žádný text.": "K této recenzi nebyl přidán žádný text.",
    "K vytvoření stvrzenky je potřeba návštěva": "K vytvoření stvrzenky je potřeba návštěva",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "K vytvoření stvrzenky je potřeba klient a návštěva",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Smazat",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Smazat dávku a fakturu?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Smazat dávku?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Opravdu si přejete smazat dávku č. %{batchNumber} a fakturu č. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Opravdu si přejete smazat dávku č. %{batchNumber}?",
    "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification": "Opravná dávka vytvořena",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Dávku se nepodařilo smazat",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Opravná dávka vytvořena",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Vytvořit opravnou dávku",
    "k_batches.k_batch.delete_failed.notification": "Smazat dávku",
    "k_batches.k_batch.delete_k_batch_btn.label": "Smazat dávku",
    "k_batches.k_batch.delete_successful.notification": "Smazat dávku",
    "Kalendář": "Kalendář",
    "Kalendář byl úspěšně synchronizován": "Kalendář byl úspěšně synchronizován",
    "Kalendář je již synchronizovaný": "Kalendář je již synchronizovaný",
    "Kapacita": "Kapacita",
    "Karta klienta": "Karta klienta",
    "Karta pacienta": "Karta klienta",
    "karta-pacienta": "karta-klienta",
    "karta/:patientId": "karta/:patientId",
    "Kartou": "Kartou",
    "Kartou online": "Kartou online",
    "Karty byly sloučeny": "Karty byly sloučeny",
    "Karty se nepodařilo sloučit": "Karty se nepodařilo sloučit",
    "kategorie": "kategorie",
    "Kategorie": "Kategorie",
    "Kdokoliv dostupný": "Kdokoliv dostupný",
    "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.": "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Klientská sekce je vypnutá. Zapnout ji můžete v",
    "Kód": "Kód",
    "Kód ": "Kód ",
    "Kód a název pojišťovny": "Kód a název pojišťovny",
    "Kód a název zboží": "Kód a název zboží",
    "Kód a název zboží, počet": "Kód a název zboží, počet",
    "kód banky": "kód banky",
    "Kód banky": "Kód banky",
    "Kód náhrady": "Kód náhrady",
    "Kód pojišťovny": "Kód pojišťovny",
    "Kód zboží": "Kód zboží",
    "Konec": "Konec",
    "Kontakt na pacienta": "Kontakt na klienta",
    "Kontaktní osoba": "Kontaktní osoba",
    "Kontaktní údaje": "Kontaktní údaje",
    "kontaktni-udaje": "kontaktni-udaje",
    "Kontaktovat": "Kontaktovat",
    "Kontaktujte nás": "Kontaktujte nás",
    "Kontaktujte naši podporu": "Kontaktujte naši podporu",
    "Kredit": "Kredit",
    "krok cviku": "krok cviku",
    "ks": "ks",
    "ks x": "ks x",
    "label": "label",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Limit dluhu předplatného bude překročen.",
    "Limit dlužné částky": "Limit dlužné částky",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "Limit klientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ",
    "Logo": "Logo",
    "Logo aplikace Fyzion": "Logo aplikace CortexApp",
    "Logo firmy": "Logo firmy",
    "mailto:info@fyzion.cz": "mailto:info@cortexapp.eu",
    "Mají tel.": "Mají tel.",
    "Mastercard ikona": "Mastercard ikona",
    "Máte již vlastní IČO?": "Máte již vlastní IČO?",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "máte naplánovanou návštěvu v ordinaci terapie",
    "Máte objednány tyto návštěvy": "Máte objednány tyto návštěvy",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "Máte zde neuložené změny, chcete je před odchodem uložit?",
    "Max. 9 výkonů": "Max. 9 výkonů",
    "Maximální kapacita návštěvy je ": "Maximální kapacita návštěvy je ",
    "Maximální úhrada": "Maximální úhrada",
    "měsíc": "měsíc",
    "Měsíc": "Měsíc",
    "měsíce": "měsíce",
    "Měsíce": "Měsíce",
    "Měsíčně": "Měsíčně",
    "Měsíční": "Měsíční",
    "měsíců": "měsíců",
    "Město": "Město",
    "mezi vaše kolegy nebo přechodem na ": "mezi vaše kolegy nebo přechodem na ",
    "mezi Vaše kolegy, nebo přechodem na ": "mezi Vaše kolegy, nebo přechodem na ",
    "min": "min",
    "min.": "min.",
    "Min. 1 výkon": "Min. 1 výkon",
    "min/terapie": "min/terapie",
    "Minulý měsíc": "Minulý měsíc",
    "Minulý rok": "Minulý rok",
    "Minulý týden": "Minulý týden",
    "minut": "minut",
    "Místnost": "Místnost",
    "Místnost byla úspěšně upravena": "Místnost byla úspěšně upravena",
    "Místnost byla úspěšně vytvořena": "Místnost byla úspěšně vytvořena",
    "mistnosti": "mistnosti",
    "Místnosti": "Místnosti",
    "MJ": "MJ",
    "Množství": "Množství",
    "Modrá": "Modrá",
    "Moje profily": "Moje profily",
    "Moje údaje": "Moje údaje",
    "Momentálně využívá": "Momentálně využívá",
    "Možnost dluhu": "Možnost dluhu",
    "Mřížka": "Mřížka",
    "Musí být alespoň 1": "Musí být alespoň 1",
    "Musí být menší než 1000.": "Musí být menší než 1000.",
    "Musí být větší než 0.": "Musí být větší než 0.",
    "Muž": "Muž",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro klienty.",
    "Muži": "Muži",
    "Muži (budoucí)": "Muži (objednaní)",
    "na info@fyzion.cz.": "na info@cortexapp.eu.",
    "Nabízené permanentky": "Nabízené permanentky",
    "Nabízené služby": "Nabízené služby",
    "Načíst další": "Načíst další",
    "Načíst údaje z ARES": "Načíst údaje z ARES",
    "Nadcházející návštěva": "Nadcházející návštěva",
    "Nadpis bloku": "Nadpis bloku",
    "Nahrané dokumenty zde není možné vidět.": "Nahrané dokumenty zde není možné vidět.",
    "Nahrání obrázku se nezdařilo": "Nahrání obrázku se nezdařilo",
    "Nahrát dávku do Purobota": "Nahrát dávku do Purobota",
    "Nahrát fotku": "Nahrát fotku",
    "Nahrát soubor": "Nahrát soubor",
    "Nahrát soubor typu jpeg nebo png": "Nahrát soubor typu jpeg nebo png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Nahrávání souborů, prosím nezavírejte stránku...",
    "Nákupní (s DPH)": "Nákupní (s DPH)",
    "Nákupní cena a počet": "Nákupní cena a počet",
    "Nákupní cena s DPH": "Nákupní cena s DPH",
    "Nákupní hodnota (s DPH)": "Nákupní hodnota (s DPH)",
    "Napište nám na email:": "Napište nám na email:",
    "Napište poznámku…": "Napište poznámku…",
    "Naplánovat změnu ceny od zvoleného data": "Naplánovat změnu ceny od zvoleného data",
    "např. číslo dávky, dokladu, pojištěnce": "např. číslo dávky, dokladu, pojištěnce",
    "Např. kód, název zboží": "Např. kód, název zboží",
    "např. název, IČP, telefonní číslo": "např. název, IČP, telefonní číslo",
    "např. název, instituce, IČO": "např. klient",
    "např. RČ pacienta, e-mail": "např. jméno, e-mail",
    "Např. RČ pacienta, e-mailová adresa": "Např. RČ klienta, e-mailová adresa",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "naší aplikaci či facebookovou skupinu CortexApp na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět klientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@cortexapp.eu a uveďte, o jakého terapeuta se jedná.",
    "naskladneni": "naskladneni",
    "Naskladnění": "Naskladnění",
    "Naskladnění zboží": "Naskladnění zboží",
    "Následující návštěva:": "Následující návštěva:",
    "Nasmlouvané výkony": "Nasmlouvané výkony",
    "nastaveni": "nastaveni",
    "Nastavení": "Nastavení",
    "Nastavení - Fakturační údaje": "Nastavení - Fakturační údaje",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "NASTAVENÍ - KONTAKTNÍ ÚDAJE.",
    "Nastavení nového hesla": "Nastavení nového hesla",
    "Nastavení předplatného": "Nastavení předplatného",
    "Nastavení uloženo": "Nastavení uloženo",
    "Nastavit": "Nastavit sms",
    "Návod": "Návod",
    "Návrat do aplikace": "Návrat do aplikace",
    "Návštěv na stránku": "Návštěv na stránku",
    "návštěva": "návštěva",
    "Návštěva": "Návštěva",
    "Návštěva byla označena jako zaplacená": "Návštěva byla označena jako zaplacená",
    "Návštěva byla úspěšně zaplacena": "Návštěva byla úspěšně zaplacena",
    "Návštěva je zamknuta": "Návštěva je zamknuta",
    "Návštěva nemůže mít datum po konci platnosti FT poukazu": "Návštěva nemůže mít datum po konci platnosti FT poukazu",
    "Návštěva nenalezena": "Návštěva nenalezena",
    "Návštěva obsahuje nahrané formuláře": "Návštěva obsahuje nahrané formuláře",
    "Návštěva obsahuje nahrané fotografie": "Návštěva obsahuje nahrané fotografie",
    "Návštěva odemknuta": "Návštěva odemknuta",
    "Návštěva pacienta": "Návštěva klienta",
    "Návštěva smazána": "Návštěva smazána",
    "Návštěva úspěšně přidána": "Návštěva úspěšně přidána",
    "Návštěva zamknuta": "Návštěva zamknuta",
    "navsteva/:patientId/:visitId": "navsteva/:patientId/:visitId",
    "Návštěvu se nepodařilo uložit": "Návštěvu se nepodařilo uložit",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.",
    "navstevy": "navstevy",
    "Návštěvy": "Návštěvy",
    "návštěvy pacientů": "návštěvy klientů",
    "Návštěvy pacientů": "Návštěvy klientů",
    "Návštěvy podle fyzioterapeutů": "Návštěvy podle terapeutů",
    "návštěvy vloží do správné karty.": "návštěvy vloží do správné karty.",
    "navstevy-pacienta": "navstevy-klienta",
    "Návštěvy:": "Návštěvy:",
    "Název": "Název",
    "Název cviku": "Název cviku",
    "Název firmy": "Název firmy",
    "Název instituce": "Odběratel/klient",
    "Název kategorie": "Název kategorie",
    "Název kliniky": "Název firmy",
    "Název místnosti": "Název místnosti",
    "Název permanentky": "Název permanentky",
    "Název podkategorie": "Název podkategorie",
    "Název pojišťovny": "Název pojišťovny",
    "Název pracoviště": "Název pracoviště",
    "Název předplatného": "Název předplatného",
    "Název šablony": "Název šablony",
    "Název služby": "Název služby",
    "Název zboží": "Název zboží",
    "Ne": "Ne",
    "nebo": "nebo",
    "nebo přechodem na pokročilý tarif. ": "nebo přechodem na pokročilý tarif. ",
    "Nebyly nalezeny žádné recenze.": "Nebyly nalezeny žádné recenze.",
    "Něco se pokazilo": "Něco se pokazilo",
    "Neděle": "Neděle",
    "Nedorazil:": "Nedorazil:",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "Nejméně 8 znaků a alespoň 1 malé písmeno",
    "Nejsou dostupné žádné místnosti": "Nejsou dostupné žádné místnosti",
    "Nejsou dostupné žádné předplatné": "Nejsou dostupné žádné předplatné",
    "Nejsou dostupné žádné transakce": "Nejsou dostupné žádné transakce",
    "Nejsou dostupní žádní uživatelé": "Nejsou dostupní žádní uživatelé",
    "Nejsou dostupní žádní žadatelé": "Nejsou dostupní žádní žadatelé",
    "Nejsou k dispozici žádná data": "Nejsou k dispozici žádná data",
    "Některé funkce aplikace Fyzion vám": "Některé funkce aplikace CortexApp vám",
    "Některé z povinných údajů chybí": "Některé z povinných údajů chybí",
    "Nelze odebrat zamčený výkon": "Nelze odebrat zamčený výkon",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "Nelze přesunout volno k jinému terapeutovi.",
    "Nelze smazat - zboží je na skladě.": "Nelze smazat - zboží je na skladě.",
    "Nemají tel.": "Nemají tel.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "Nemáte dostatečné oprávnění pro tuto akci.",
    "Nemáte oprávnění na smazání cizí návštěvy": "Nemáte oprávnění na smazání cizí návštěvy",
    "Nemáte oprávnění na smazání návštěvy": "Nemáte oprávnění na smazání návštěvy",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "Nemáte oprávnění na úpravu jiného terapeuta",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "Nemáte oprávnění na úpravu jiných ordinačních hodin",
    "Nemáte oprávnění na úpravu permanentky": "Nemáte oprávnění na úpravu permanentky",
    "Nemáte oprávnění na úpravu služby": "Nemáte oprávnění na úpravu služby",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "Nemáte oprávnění na zaplacení cizí návštěvy",
    "Nemáte oprávnění na zrušení cizí návštěvy": "Nemáte oprávnění na zrušení cizí návštěvy",
    "Nemáte oprávnění pro odemknutí výkonu": "Nemáte oprávnění pro odemknutí výkonu",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "Nemáte oprávnění prohlížet anamnézu klienta",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.",
    "Nemáte žádné objednané návštěvy.": "Nemáte žádné objednané návštěvy.",
    "nemusí správně fungovat.": "nemusí správně fungovat.",
    "Nemůže být záporné": "Nemůže být záporné",
    "Nenalezen žádný dodavatel": "Nenalezen žádný dodavatel",
    "Nenalezen žádný doklad": "Nenalezen žádný doklad",
    "Nenalezen žádný pacient": "Nenalezen žádný klient",
    "Nenalezen žádný výkon": "Nenalezen žádný výkon",
    "Nenalezena shoda se jménem žádného cviku.": "Nenalezena shoda se jménem žádného cviku.",
    "Nenalezena žádná akce": "Nenalezena žádná akce",
    "Nenalezena žádná dávka": "Nenalezena žádná dávka",
    "Nenalezena žádná návštěva": "Nenalezena žádná návštěva",
    "Nenalezena žádná pracoviště": "Nenalezena žádná pracoviště",
    "Nenalezena žádná šablona": "Nenalezena žádná šablona",
    "Nenalezena žádná stvrzenka": "Nenalezena žádná stvrzenka",
    "Nenalezena žádná zpráva": "Nenalezena žádná zpráva",
    "Nenalezeno žádné další zboží": "Nenalezeno žádné další zboží",
    "Nenalezeny žádné další služby": "Nenalezeny žádné další služby",
    "Nenalezeny žádné položky": "Nenalezeny žádné položky",
    "Nenalezeny žádné zásoby": "Nenalezeny žádné zásoby",
    "Není dostupný žádný platný FT poukaz": "Není dostupný žádný platný FT poukaz",
    "Není dostupný žádný výkon": "Není dostupný žádný výkon",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "Není možné změnit tarif, protože máte v kartotéce více klientů,",
    "Není nahrána žádná fotka": "Není nahrána žádná fotka",
    "Není naplánována další návštěva": "Není naplánována další návštěva",
    "Neočekávaná chyba": "Neočekávaná chyba",
    "Neomezený počet pacientů": "Neomezený počet klientů",
    "Neopakuje se": "Neopakuje se",
    "Neplátce DPH": "Neplátce DPH",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Nepodařilo se aktualizovat cviky v návštěvě",
    "Nepodařilo se aktualizovat den se cvičením": "Nepodařilo se aktualizovat den se cvičením",
    "Nepodařilo se aktualizovat šablonu": "Nepodařilo se aktualizovat šablonu",
    "Nepodařilo se načíst budoucí návštěvy.": "Nepodařilo se načíst budoucí návštěvy.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Nepodařilo se načíst celkové hodnoty naskladněných položek",
    "Nepodařilo se načíst cviky": "Nepodařilo se načíst cviky",
    "Nepodařilo se načíst data": "Nepodařilo se načíst data",
    "Nepodařilo se načíst data ze systému": "Nepodařilo se načíst data ze systému",
    "Nepodařilo se načíst dávku": "Nepodařilo se načíst dávku",
    "Nepodařilo se načíst dávky": "Nepodařilo se načíst dávky",
    "Nepodařilo se načíst diagnózy": "Nepodařilo se načíst diagnózy",
    "Nepodařilo se načíst dodavatele": "Nepodařilo se načíst dodavatele",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Nepodařilo se načíst dostupné terapeuty",
    "Nepodařilo se načíst FT poukazy": "Nepodařilo se načíst FT poukazy",
    "Nepodařilo se načíst hromadnou návštěvu": "Nepodařilo se načíst hromadnou návštěvu",
    "Nepodařilo se načíst kategorie cviků": "Nepodařilo se načíst kategorie cviků",
    "Nepodařilo se načíst kategorii cviků": "Nepodařilo se načíst kategorii cviků",
    "Nepodařilo se načíst místnost": "Nepodařilo se načíst místnost",
    "Nepodařilo se načíst místnosti": "Nepodařilo se načíst místnosti",
    "Nepodařilo se načíst návštěvu pacienta": "Nepodařilo se načíst návštěvu klienta",
    "Nepodařilo se načíst návštěvy pacienta": "Nepodařilo se načíst návštěvy klienta",
    "Nepodařilo se načíst novinku": "Nepodařilo se načíst novinku",
    "Nepodařilo se načíst novinky": "Nepodařilo se načíst novinky",
    "Nepodařilo se načíst odbornosti": "Nepodařilo se načíst odbornosti",
    "Nepodařilo se načíst ordinaci na této adrese": "Nepodařilo se načíst ordinaci na této adrese",
    "Nepodařilo se načíst pacienty": "Nepodařilo se načíst klienty",
    "Nepodařilo se načíst permanentku": "Nepodařilo se načíst permanentku",
    "Nepodařilo se načíst permanentky pacienta": "Nepodařilo se načíst permanentky klienta",
    "Nepodařilo se načíst platbu": "Nepodařilo se načíst platbu",
    "Nepodařilo se načíst platby": "Nepodařilo se načíst platby",
    "Nepodařilo se načíst platební údaje": "Nepodařilo se načíst platební údaje",
    "Nepodařilo se načíst pojišťovnu": "Nepodařilo se načíst pojišťovnu",
    "Nepodařilo se načíst pojišťovny": "Nepodařilo se načíst pojišťovny",
    "Nepodařilo se načíst položku": "Nepodařilo se načíst položku",
    "Nepodařilo se načíst pracoviště": "Nepodařilo se načíst pracoviště",
    "Nepodařilo se načíst předplatné": "Nepodařilo se načíst předplatné",
    "Nepodařilo se načíst recenze": "Nepodařilo se načíst recenze",
    "Nepodařilo se načíst šablonu": "Nepodařilo se načíst šablonu",
    "Nepodařilo se načíst šablony": "Nepodařilo se načíst šablony",
    "Nepodařilo se načíst seznam diagnóz": "Nepodařilo se načíst seznam diagnóz",
    "Nepodařilo se načíst seznam návštěv.": "Nepodařilo se načíst seznam návštěv.",
    "Nepodařilo se načíst seznam uživatelů": "Nepodařilo se načíst seznam uživatelů",
    "Nepodařilo se načíst skupiny služeb": "Nepodařilo se načíst skupiny služeb",
    "Nepodařilo se načíst služby": "Nepodařilo se načíst služby",
    "Nepodařilo se načíst transakce": "Nepodařilo se načíst transakce",
    "Nepodařilo se načíst transakci": "Nepodařilo se načíst transakci",
    "Nepodařilo se načíst volné termíny": "Nepodařilo se načíst volné termíny",
    "Nepodařilo se načíst výkony": "Nepodařilo se načíst výkony",
    "Nepodařilo se načíst žadatele": "Nepodařilo se načíst žadatele",
    "Nepodařilo se načíst zásoby": "Nepodařilo se načíst zásoby",
    "Nepodařilo se načíst zemi": "Nepodařilo se načíst zemi",
    "Nepodařilo se nahrát dávku do Purobota": "Nepodařilo se nahrát dávku do Purobota",
    "Nepodařilo se nahrát fotku FT poukazu": "Nepodařilo se nahrát fotku FT poukazu",
    "Nepodařilo se nahrát soubor": "Nepodařilo se nahrát soubor",
    "Nepodařilo se odemknout výkon": "Nepodařilo se odemknout výkon",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Nepodařilo se označit fakturu jako zaplacenou",
    "Nepodařilo se přidat fakturaci": "Nepodařilo se přidat fakturaci",
    "Nepodařilo se přidat předplatné": "Nepodařilo se přidat předplatné",
    "Nepodařilo se smazat cvik": "Nepodařilo se smazat cvik",
    "Nepodařilo se smazat platbu": "Nepodařilo se smazat platbu",
    "Nepodařilo se smazat pojišťovnu": "Nepodařilo se smazat pojišťovnu",
    "Nepodařilo se smazat pracoviště": "Nepodařilo se smazat pracoviště",
    "Nepodařilo se smazat předplatné": "Nepodařilo se smazat předplatné",
    "Nepodařilo se smazat recenzi": "Nepodařilo se smazat recenzi",
    "Nepodařilo se smazat šablonu": "Nepodařilo se smazat šablonu",
    "Nepodařilo se uložit pracoviště žadatele": "Nepodařilo se uložit pracoviště žadatele",
    "Nepodařilo se upravit cvik.": "Nepodařilo se upravit cvik.",
    "Nepodařilo se upravit dostupnost": "Nepodařilo se upravit dostupnost",
    "Nepodařilo se upravit fakturaci": "Nepodařilo se upravit fakturaci",
    "Nepodařilo se upravit místnost": "Nepodařilo se upravit místnost",
    "Nepodařilo se upravit platbu": "Nepodařilo se upravit platbu",
    "Nepodařilo se upravit předplatné": "Nepodařilo se upravit předplatné",
    "Nepodařilo se vygenerovat export": "Nepodařilo se vygenerovat export",
    "Nepodařilo se vygenerovat fakturu": "Nepodařilo se vygenerovat fakturu",
    "Nepodařilo se vygenerovat platební odkaz": "Nepodařilo se vygenerovat platební odkaz",
    "Nepodařilo se vygenerovat zprávu": "Nepodařilo se vygenerovat zprávu",
    "Nepodařilo se vytvořit cvik.": "Nepodařilo se vytvořit cvik.",
    "Nepodařilo se vytvořit dodavatele": "Nepodařilo se vytvořit dodavatele",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Nepodařilo se vytvořit hromadnou návštěvu",
    "Nepodařilo se vytvořit kategorii.": "Nepodařilo se vytvořit kategorii.",
    "Nepodařilo se vytvořit místnost": "Nepodařilo se vytvořit místnost",
    "Nepodařilo se vytvořit platbu": "Nepodařilo se vytvořit platbu",
    "Nepodařilo se vytvořit pracoviště žadatele": "Nepodařilo se vytvořit pracoviště žadatele",
    "Nepodařilo se vytvořit šablonu": "Nepodařilo se vytvořit šablonu",
    "Nepodařilo se vytvořit uživatele": "Nepodařilo se vytvořit uživatele",
    "Nepodařilo se zaplatit návštěvu": "Nepodařilo se zaplatit návštěvu",
    "Nepodařilo se získat cviky pacienta": "Nepodařilo se získat cviky klienta",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Nepodařilo se změnit nastavení rezervací klienta",
    "Nepodařilo se zrušit platbu": "Nepodařilo se zrušit platbu",
    "Nepodařilo se zrušit platbu za návštěvu": "Nepodařilo se zrušit platbu za návštěvu",
    "Nepodporovaný typ prohlížeče": "Nepodporovaný typ prohlížeče",
    "nepodporovaný typ prohlížeče.": "nepodporovaný typ prohlížeče.",
    "Nepovinné": "Nepovinné",
    "Nepravidelné ordinační hodiny": "Nepravidelná pracovní doba",
    "Nepřišel": "Nepřišel",
    "Nesouhlasili": "Nesouhlasili",
    "Neuhrazeno": "Neuhrazeno",
    "Neukládat": "Neukládat",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.",
    "Nevystaveno": "Nevystaveno",
    "Nezaplaceno": "Nezaplaceno",
    "nova": "nova",
    "Nová cena": "Nová cena",
    "Nová cena s DPH": "Nová cena s DPH",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.",
    "Nová fakturace": "Nová fakturace",
    "Nová místnost": "Nová místnost",
    "Nová návštěva": "Nová návštěva",
    "Nová operace": "Nová operace",
    "Nová šablona": "Nová šablona",
    "Nová skupinová návštěva": "Nová skupinová návštěva",
    "Nová událost": "Nová událost",
    "nova-navsteva": "nova-navsteva",
    "nova-opravna": "nova-opravna",
    "nova-skupinova-navsteva": "nova-skupinova-navsteva",
    "nove": "nove",
    "Nové heslo": "Nové heslo",
    "Nové pracoviště žadatele": "Nové pracoviště žadatele",
    "Nové předplatné": "Nové předplatné",
    "Novinky": "Novinky",
    "novy": "novy",
    "Nový pacient": "Nový klient",
    "Nový žadatel": "Nový žadatel",
    "novy-ft-poukaz": "novy-ft-poukaz",
    "O nás": "O nás",
    "Období": "Období",
    "obecne": "obecne",
    "Obecné": "Obecné",
    "obecném nastavení": "obecném nastavení",
    "Objednat návštěvu": "Objednat návštěvu",
    "Objednat se na": "Objednat se na",
    "Objekt": "Objekt",
    "Obměna": "Obměna",
    "obnova-hesla": "obnova-hesla",
    "Obnovit tabulku": "Obnovit tabulku",
    "Obrázek byl smazán": "Obrázek byl smazán",
    "Obrázky": "Obrázky",
    "Obsah": "Obsah",
    "Ochrana osobních údajů": "Ochrana osobních údajů",
    "Od": "Od",
    "Odběratel/klient": "Odběratel/klient",
    "Odběratel/Klient": "Odběratel/Klient",
    "Odbornost": "Odbornost",
    "Odcvičeno a přejít na další cvik": "Odcvičeno a přejít na další cvik",
    "Odebrat": "Odebrat",
    "Odebrat pacienta": "Odebrat klienta",
    "Odebrat položku": "Odebrat položku",
    "Odebrat výkon": "Odebrat výkon",
    "Odemknout": "Odemknout",
    "Odemknout výkon": "Odemknout výkon",
    "Odesílat email": "Odesílat email",
    "Odesílat připomínku e-mailem": "Odesílat připomínku e-mailem",
    "Odesílat SMS": "Odesílat SMS",
    "Odesílat SMS předem": "Odesílat SMS předem",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.",
    "Odeslání dávky pojišťovně selhalo": "Odeslání dávky pojišťovně selhalo",
    "Odeslání emailu": "Odeslání emailu",
    "Odeslání emailu 1 pacientovi": "Odeslání emailu 1 klientovi",
    "Odeslání emailu pacientovi": "Odeslání emailu klientovi",
    "Odeslání SMS": "Odeslání SMS",
    "Odeslání SMS 1 pacientovi": "Odeslání SMS 1 klientovi",
    "Odeslání SMS pacientovi": "Odeslání SMS klientovi",
    "Odeslání zůstalo nedokončené": "Odeslání zůstalo nedokončené",
    "Odesláno": "Odesláno",
    "Odesláno na ": "Odesláno na ",
    "Odeslat": "Odeslat",
    "Odeslat %{count} dávku pojišťovně?": [
      "Odeslat %{count} dávku pojišťovně?",
      "Odeslat %{count} dávky pojišťovně?",
      "Odeslat %{count} dávek pojišťovně?"
    ],
    "Odeslat 1 stvrzenku": "Odeslat 1 stvrzenku",
    "Odeslat email": "Odeslat email",
    "Odeslat GDPR mailem": "Odeslat GDPR mailem",
    "Odeslat klientovi": "Odeslat klientovi",
    "Odeslat pacientovi": "Odeslat klientovi",
    "Odeslat potvrzení o platbě": "Odeslat potvrzení o platbě",
    "Odeslat SMS": "Odeslat SMS",
    "Odeslat znovu emailem": "Odeslat znovu emailem",
    "odešlete": "odešlete",
    "Odhlásit": "Odhlásit",
    "Odkaz na rezervaci byl zkopírován do schránky": "Odkaz na rezervaci byl zkopírován do schránky",
    "Odkud jste se o nás dozvěděli?": "Odkud jste se o nás dozvěděli?",
    "Odstranit časový interval": "Odstranit časový interval",
    "Ohodnoťte kvalitu naší služby": "Ohodnoťte kvalitu naší služby",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "Omlouváme se, ale v aplikaci došlo k nečekané chybě. Pravidelně provádíme aktualizace, abychom zlepšovali funkčnost a přidávali nové možnosti. Během nich může dojít k krátkým výpadkům. Věříme, že se budou objevovat čím dál méně.\nPokud problém přetrvává, napište nám prosím na info@cortexapp.eu. Děkujeme za pochopení.",
    "Online platba": "Online platba",
    "Opakování": "Opakování",
    "Opakovat heslo": "Opakovat heslo",
    "Opakovat jednou za": "Opakovat jednou za",
    "Opravdu si přejete archivovat pacienta?": "Opravdu si přejete archivovat klienta?",
    "Opravdu si přejete formulář smazat?": "Opravdu si přejete formulář smazat?",
    "Opravdu si přejete fotografii smazat?": "Opravdu si přejete fotografii smazat?",
    "Opravdu si přejete FT poukaz smazat?": "Opravdu si přejete FT poukaz smazat?",
    "Opravdu si přejete obrázek smazat?": "Opravdu si přejete obrázek smazat?",
    "Opravdu si přejete pacienta odebrat?": "Opravdu si přejete klienta odebrat?",
    "Opravdu si přejete permanentku smazat?": "Opravdu si přejete permanentku smazat?",
    "Opravdu si přejete platbu zrušit?": "Opravdu si přejete platbu zrušit?",
    "Opravdu si přejete pojišťovnu smazat?": "Opravdu si přejete pojišťovnu smazat?",
    "Opravdu si přejete pracoviště smazat?": "Opravdu si přejete pracoviště smazat?",
    "Opravdu si přejete recenzi smazat?": "Opravdu si přejete recenzi smazat?",
    "Opravdu si přejete rezervaci zrušit?": "Opravdu si přejete rezervaci zrušit?",
    "Opravdu si přejete šablonu smazat?": "Opravdu si přejete šablonu smazat?",
    "Opravdu si přejete smazat cvik": "Opravdu si přejete smazat cvik",
    "Opravdu si přejete smazat kategorii cviků?": "Opravdu si přejete smazat kategorii cviků?",
    "Opravdu si přejete smazat kategorii služeb": "Opravdu si přejete smazat kategorii služeb",
    "Opravdu si přejete smazat platbu č.": "Opravdu si přejete smazat platbu č.",
    "Opravdu si přejete smazat předplatné": "Opravdu si přejete smazat předplatné",
    "Opravdu si přejete smazat službu": "Opravdu si přejete smazat službu",
    "Opravdu si přejete stornovat stvrzenku?": "Opravdu si přejete stornovat stvrzenku?",
    "Opravdu si přejete synchronizaci odebrat?": "Opravdu si přejete synchronizaci odebrat?",
    "Opravdu si přejete terapeuta deaktivovat?": "Opravdu si přejete terapeuta deaktivovat?",
    "Opravdu si přejete video smazat?": "Opravdu si přejete video smazat?",
    "Opravdu si přejete volno smazat?": "Opravdu si přejete volno smazat?",
    "Opravná": "Opravná",
    "Opravná dávka": "Opravná dávka",
    "Opustit průvodce": "Opustit průvodce",
    "Ordinace": "Pracoviště",
    "ordinační hodiny": "pracovní doba",
    "Osobní údaje": "Osobní údaje",
    "Ostatní diagnózy": "Ostatní diagnózy",
    "Ostatní služby": "Ostatní služby",
    "Otevírací doba": "Otevírací doba",
    "Otevřeno": "Otevřeno",
    "Otevřít návštěvu": "Otevřít návštěvu",
    "Otevřít v novém okně": "Otevřít v novém okně",
    "Ověření": "Ověření",
    "Označeno:": "Označeno:",
    "Označit jako zaplacené": "Označit jako zaplacené",
    "Pacient": "Klient",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Klient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu",
    "Pacient byl úspěšně přidán": "Klient byl úspěšně přidán",
    "Pacient ještě nepotvrdil GDPR": "Klient ještě nepotvrdil GDPR",
    "Pacient již GDPR potvrdil": "Klient již GDPR potvrdil",
    "Pacient má platný FT poukaz do %{date}.": "Klient má platný FT poukaz do %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Klient nemá nastavenou příští návštěvu",
    "Pacient odebrán": "Klient odebrán",
    "Pacient odhlášen z odběru novinek": "Klient odhlášen z odběru novinek",
    "Pacient přídán": "Klient přídán",
    "Pacient přihlášen k odběru novinek": "Klient přihlášen k odběru novinek",
    "Pacient úspěšně archivován": "Klient úspěšně archivován",
    "Pacient úspěšně odebrán z čekajících pacientů": "Klient úspěšně odebrán z čekajících klientů",
    "Pacient úspěšně přidán do čekajících pacientů": "Klient úspěšně přidán do čekajících klientů",
    "Pacient úspěšně upraven": "Klient úspěšně upraven",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "Klient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.",
    "Pacienta se nepodařilo archivovat": "Klienta se nepodařilo archivovat",
    "Pacienta se nepodařilo odebrat": "Klienta se nepodařilo odebrat",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "Klienta se nepodařilo přidat do čekajících klientů. Zkuste prosím znovu.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "Klienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.",
    "Pacienti": "Klienti",
    "Pacienti, kteří přišli poprvé": "Klienti, kteří přišli poprvé",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "Klientovi pošleme potvrzení o platbě na jeho email",
    "Pacientů na stránku": "Klientů na stránku",
    "pacientům": "klientům",
    "Paragon": "Paragon",
    "paragon č.": "paragon č.",
    "Paragony": "Paragony",
    "Parametry příští návštěvy upraveny": "Parametry příští návštěvy upraveny",
    "Pátek": "Pátek",
    "Patička faktury": "Patička faktury",
    "Paušální": "Paušální",
    "PDF": "PDF",
    "Permanentka aktualizována": "Permanentka aktualizována",
    "Permanentka byla označena jako zaplacená": "Permanentka byla označena jako zaplacená",
    "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.": "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.",
    "Permanentka úspěšně odebrána pacientovi.": "Permanentka úspěšně odebrána klientovi.",
    "Permanentka úspěšně přidána pacientovi.": "Permanentka úspěšně přidána klientovi.",
    "Permanentka úspěšně vytvořena": "Permanentka úspěšně vytvořena",
    "Permanentkou": "Permanentkou",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Permanentku se nepodařilo klientovi odebrat. Zkuste prosím znovu.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Permanentku se nepodařilo klientovi přidat. Zkuste prosím znovu.",
    "Permanentku se nepodařilo upravit.": "Permanentku se nepodařilo upravit.",
    "Permanentku se nepodařilo vytvořit": "Permanentku se nepodařilo vytvořit",
    "Permanentky": "Permanentky",
    "placený tarif": "placený tarif",
    "planovani": "planovani",
    "Plánování": "Plánování",
    "planovani-mistnosti": "planovani-mistnosti",
    "Platba": "Platba",
    "Platba byla smazána": "Platba byla smazána",
    "Platba byla zrušena": "Platba byla zrušena",
    "Platba předplatným": "Platba předplatným",
    "Platba za návštěvu byla úspěšně zrušena": "Platba za návštěvu byla úspěšně zrušena",
    "platby": "platby",
    "Platby": "Platby",
    "Platby za pronájem aplikace": "Platby za CortexApp",
    "Plátce DPH": "Plátce DPH",
    "Plateb na stránku": "Plateb na stránku",
    "Platební brána Fyzion": "Platební brána Webpay",
    "Platební informace": "Platební informace",
    "Platná do:": "Platná do:",
    "Platnost (v měsících)": "Platnost (v měsících)",
    "Platnost do": "Platnost do",
    "Platnost musí být větší nebo rovna 1.": "Platnost musí být větší nebo rovna 1.",
    "Platnost nové ceny od": "Platnost nové ceny od",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla",
    "Po": "Po",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.",
    "Po sloučení se všechny minulé i budoucí": "Po sloučení se všechny minulé i budoucí",
    "Po třech dnech": "Po třech dnech",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "Po vložení kódu na váš web se zobrazí okno s rezervací",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "Po vložení kódu na váš web se zobrazí tlačítko s rezervací",
    "pobočka": "pobočka",
    "Pobočka": "Pobočka",
    "pobocky": "pobocky",
    "Pobočky": "Pobočky",
    "Počet": "Počet",
    "Počet dní do konce:": "Počet dní do konce:",
    "Počet návštěv": "Počet návštěv",
    "Počet návštěv musí být větší nebo rovno 1.": "Počet návštěv musí být větší nebo rovno 1.",
    "Počet povolených rezervací je naplněn.": "Počet povolených rezervací je naplněn.",
    "Počet výkonů": "Počet výkonů",
    "Počet zbývajících vstupů:": "Počet zbývajících vstupů:",
    "Počty návštěv": "Počty návštěv",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci CortexApp Signer a CortexApp ji odešle zdravotní pojišťovně.",
    "Podepsat a odeslat": "Podepsat a odeslat",
    "Podívám se později": "Podívám se později",
    "Podkategorie": "Podkategorie",
    "Podmínky užití": "Podmínky užití",
    "Podpis/razítko firmy": "Podpis/razítko firmy",
    "Podpora": "Podpora",
    "podpora@fyzion.cz": "info@cortexapp.eu",
    "Podrobnosti": "Podrobnosti",
    "Pohlaví": "Pohlaví",
    "Pohlaví:": "Pohlaví:",
    "Pojištění EU a mezinárodní smlouvy": "Pojištění EU a mezinárodní smlouvy",
    "Pojišťovna": "Pojišťovna",
    "Pojišťovna byla smazána": "Pojišťovna byla smazána",
    "Pojišťovna přidána": "Pojišťovna přidána",
    "Pojišťovna upravena": "Pojišťovna upravena",
    "Pojišťovna:": "Pojišťovna:",
    "Pojišťovnou": "Pojišťovnou",
    "Pojišťovny": "Pojišťovny",
    "Pokladna": "Pokladna",
    "Pokračovat": "Pokračovat",
    "Pokročilá funkce": "Pokročilá funkce",
    "pokročilý tarif.": "pokročilý tarif.",
    "Pokud": "Pokud",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "Pokud má klient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.",
    "Pokud problém přetrvává, napište nám na": "Pokud problém přetrvává, napište nám na",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.",
    "Pole je povinné": "Pole je povinné",
    "Položka byla úspěšně smazána": "Položka byla úspěšně smazána",
    "Položka byla úspěšně upravena": "Položka byla úspěšně upravena",
    "Položka byla úspěšně vytvořena": "Položka byla úspěšně vytvořena",
    "Položku se nepodařilo smazat": "Položku se nepodařilo smazat",
    "polozky": "polozky",
    "Položky": "Položky",
    "Pondělí": "Pondělí",
    "Popis": "Popis",
    "Popis cviku": "Popis cviku",
    "Popisy návštěv": "Popisy návštěv",
    "Porovnat fotky": "Porovnat fotky",
    "Porovnat fotografie": "Porovnat fotografie",
    "Porovnat můžete maximálně 2 fotografie.": "Porovnat můžete maximálně 2 fotografie.",
    "Porovnat vybrané fotografie": "Porovnat vybrané fotografie",
    "porovnavac": "porovnavac",
    "Porovnávač": "Porovnávač",
    "Poslední fakturace": "Poslední fakturace",
    "Poslední návštěva": "Poslední návštěva",
    "Poslední návštěva:": "Poslední návštěva:",
    "Potvrdit": "Potvrdit",
    "Potvrdit nové heslo": "Potvrdit nové heslo",
    "Potvrďte nové heslo": "Potvrďte nové heslo",
    "Potvrzení GDPR před návštěvou fyzioterapie": "Potvrzení GDPR před návštěvou terapie",
    "Potvrzení o podstoupené péči": "Potvrzení o podstoupené péči",
    "Potvrzení zrušení platby": "Potvrzení zrušení platby",
    "potvrzeni-pece/:patientId": "potvrzeni-pece/:patientId",
    "Potvrzeno": "Potvrzeno",
    "Potvrzuji": "Potvrzuji",
    "Potvrzuji, že pacient": "Potvrzuji, že klient",
    "Používáte": "Používáte",
    "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce": "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce",
    "Povolit online rezervace": "Povolit online rezervace",
    "Povolit rezervace": "Povolit rezervace",
    "Povolit rezervace na státní svátky": "Povolit rezervace na státní svátky",
    "Povolit zobrazení detailu cizí návštěvy": "Povolit zobrazení Karty Klientů ostatních uživatelů",
    "Povolit zrušení rezervace": "Povolit zrušení rezervace",
    "Poznámka": "Poznámka",
    "Poznámka k návštěvě": "Poznámka k návštěvě",
    "Poznámka úspěšně smazána": "Poznámka úspěšně smazána",
    "Poznámka úspěšně uložena": "Poznámka úspěšně uložena",
    "Poznámka:": "Poznámka:",
    "Poznámku se nepodařilo uložit": "Poznámku se nepodařilo uložit",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Pozor, blížíte se k maximálnímu počtu klientů.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Pozor, blížíte se maximálnímu počtu klientů.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Terapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Pozor! Upravujete globální cvik vytvořený aplikací CortexApp. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.",
    "pracoviste": "pracoviste",
    "Pracoviště": "Pracoviště",
    "Pracoviště bylo smazáno": "Pracoviště bylo smazáno",
    "Pracoviště pro pojišťovny": "Pracoviště pro pojišťovny",
    "Pracoviště upraveno": "Pracoviště upraveno",
    "Pracoviště vytvořeno": "Pracoviště vytvořeno",
    "Pracoviště žadatele bylo úspěšně uloženo": "Pracoviště žadatele bylo úspěšně uloženo",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Pracoviště žadatele bylo úspěšně vytvořeno",
    "Pracovní dny": "Pracovní dny",
    "Pracovní doba": "Pracovní doba",
    "Pracovníci": "Pracovníci",
    "Pracuji jako fyzická osoba": "Pracuji jako fyzická osoba",
    "Pravidelné terapie": "Pravidelné terapie",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Před návštěvou poradny se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte",
    "Před pokračováním vyplňte formulář": "Před pokračováním vyplňte formulář",
    "Před pokračováním zadejte rodné číslo": "Před pokračováním zadejte rodné číslo",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Předem děkuji a budu se těšit na Vaši návštěvu.",
    "Předmět": "Předmět",
    "Předmět emailu": "Předmět emailu",
    "předplacené (permice)": "předplacené (permice)",
    "predplatne": "predplatne",
    "Předplatné": "Předplatné",
    "Předplatné Fyzion": "Předplatné Cortex",
    "Předplatné smazáno": "Předplatné smazáno",
    "Předplatné úspěšně přidáno": "Předplatné úspěšně přidáno",
    "Předplatné úspěšně upraveno": "Předplatné úspěšně upraveno",
    "Předplatných na stránku": "Předplatných na stránku",
    "Předplatným": "Předplatným",
    "Předvolba": "Předvolba",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.",
    "Preferovaná místnost": "Preferovaná místnost",
    "Přehled cviků": "Přehled cviků",
    "Přehled dávek": "Přehled dávek",
    "Přehled položek": "Přehled položek",
    "Přehled pracovišť": "Přehled pracovišť",
    "Přehled transakcí": "Přehled transakcí",
    "Přejete si vystavit doklad?": "Přejete si vystavit doklad?",
    "Přejete si vystavit fakturu na storno poplatek?": "Přejete si vystavit fakturu na storno poplatek?",
    "Přejete si vystavit storno doklad?": "Přejete si vystavit storno doklad?",
    "Přejít do aplikace": "Návrat do aplikace",
    "Přejít do profilu": "Přejít do profilu",
    "Přejít na tarif": "Přejít na tarif",
    "Premium registrace": "Premium registrace",
    "Přeskočit": "Přeskočit",
    "Přesunout rezervaci": "Přesunout rezervaci",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Přesuňte některé klienty do archivu a pak objednejte tarif znovu.",
    "Převodem": "Převodem",
    "Převodem (QR kód)": "Převodem (QR kód)",
    "Přidán na seznam": "Přidán na seznam",
    "Přidáním dalšího fyzioterapeuta bude do konce aktuálního účtovacího období účtován poměrný poplatek za nového uživatele dle platného ceníku. Od následujícího fakturačního období bude tento uživatel automaticky zahrnut do standardní fakturace.": "Přidáním dalšího terapeuta bude do konce aktuálního účtovacího období účtován poměrný poplatek za nového uživatele dle platného ceníku. Od následujícího fakturačního období bude tento uživatel automaticky zahrnut do standardní fakturace.",
    "Přidat": "Přidat",
    "Přidat 3 pacienty": "Přidat 3 klienty",
    "Přidat časový interval": "Přidat časový interval",
    "Přidat čekajícího": "Přidat čekajícího",
    "Přidat cvik": "Přidat cvik",
    "Přidat dodavatele": "Přidat dodavatele",
    "Přidat dokument": "Přidat dokument",
    "Přidat doplňkový text do e-mailů klientům": "Přidat doplňkový text do e-mailů klientům",
    "Přidat fotku": "Přidat fotku",
    "Přidat FT poukaz": "Přidat FT poukaz",
    "Přidat fyzioterapeuta": "Přidat terapeuta",
    "Přidat k návštěvě": "Přidat k návštěvě",
    "Přidat kategorii": "Přidat kategorii",
    "Přidat místnost": "Přidat místnost",
    "Přidat návštěvu": "Přidat návštěvu",
    "Přidat nového čekajícího": "Přidat nového čekajícího klienta",
    "Přidat nového pacienta": "Přidat nového klienta",
    "Přidat pacientovi permanentku": "Přidat klientovi permanentku",
    "Přidat peníze": "Přidat peníze",
    "Přidat permanentku": "Přidat permanentku",
    "Přidat platbu": "Přidat platbu",
    "Přidat podkategorii": "Přidat podkategorii",
    "Přidat pojišťovnu": "Přidat pojišťovnu",
    "Přidat položku": "Přidat položku",
    "Přidat poznámku": "Přidat poznámku",
    "Přidat pracoviště": "Přidat pracoviště",
    "Přidat předplatné": "Přidat předplatné",
    "Přidat skupinovou návštěvu": "Přidat skupinovou návštěvu",
    "Přidat službu": "Přidat službu",
    "Přidat soubor": "Přidat soubor",
    "Přidat výkon": "Přidat výkon",
    "pridat-permanentku": "pridat-permanentku",
    "pridat-volno": "pridat-volno",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.",
    "Přihlášení jako nesprávný typ uživatele": "Přihlášení jako nesprávný typ uživatele",
    "Přihlásit se": "Přihlásit se",
    "Přihlašovací jméno": "Přihlašovací jméno",
    "Přihlašovací údaje": "Přihlašovací údaje",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst",
    "Přihlašovací údaje se nepodařilo smazat": "Přihlašovací údaje se nepodařilo smazat",
    "Přihlašovací údaje se nepodařilo uložit": "Přihlašovací údaje se nepodařilo uložit",
    "Příjemce": "Příjemce",
    "Příjemce:": "Příjemce:",
    "Přijmení": "Přijmení",
    "Příjmení": "Příjmení",
    "Příjmy": "Příjmy",
    "Příjmy (budoucí)": "Příjmy (budoucí)",
    "Příjmy fyzioterapeutů": "Příjmy terapeutů",
    "Příjmy z nabízených služeb": "Příjmy z nabízených služeb",
    "Přiložený soubor se nepodařilo nahrát": "Přiložený soubor se nepodařilo nahrát",
    "Případně kontaktujte naši podporu na ": "Případně kontaktujte naši podporu na ",
    "Připojištění": "Připojištění",
    "Připravujeme": "Na vyžádání",
    "Přiřazené služby": "Přiřazené služby",
    "Přišel/Přijde": "Přišel/Přijde",
    "Příští návštěva": "Příští návštěva",
    "Příští objednání": "Příští objednání",
    "Příští služba": "Příští služba",
    "Přítomen": "Přítomen",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "Pro odeslání potvrzení o platbě zadejte email klienta",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "Pro tohoto klienta jste zatím nevytvořili žádný FT poukaz",
    "Pro zobrazení platebního QR kódu vyplňte v": "Pro zobrazení platebního QR kódu vyplňte v",
    "Proběhlé návštěvy": "Proběhlé návštěvy",
    "Probíhá synchronizace Vašeho kalendáře": "Probíhá synchronizace Vašeho kalendáře",
    "Prodané permanentky": "Prodané permanentky",
    "Prodejní cena (s DPH)": "Prodejní cena (s DPH)",
    "Prodejní cena s DPH": "Prodejní cena s DPH",
    "Prodejní cena zboží za ks (s DPH)": "Prodejní cena zboží za ks (s DPH)",
    "Prodejní hodnota (s DPH)": "Prodejní hodnota (s DPH)",
    "Profil": "Profil",
    "Profilový obrázek byl úspěšně nahrán": "Profilový obrázek byl úspěšně nahrán",
    "Profily": "Profily",
    "Proklik na skupinovou návštěvu": "Proklik na skupinovou návštěvu",
    "Propojené aplikace": "Propojené aplikace",
    "Propojeno": "Propojeno",
    "Propojit": "Propojit",
    "Prosím": "Prosím",
    "Prosíme o její úhradu co nejdříve.": "Prosíme o její úhradu co nejdříve.",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "Provedeme vás, nastavíme základní parametry, přidáme první klienty.",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Průměrná nákupní cena zboží na skladě za ks (s DPH)",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v dolním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.",
    "PSČ": "PSČ",
    "Purobot API klíč": "Purobot API klíč",
    "Původní": "Původní",
    "Původní dávka": "Původní dávka",
    "qr": "qr",
    "RČ": "RČ",
    "RČ / Datum narození": "RČ / Datum narození",
    "Recenze": "Recenze",
    "Recenze byla smazána": "Recenze byla smazána",
    "Recenze návštěv": "Recenze od klientů",
    "recenzí": "recenzí",
    "Recepční": "Recepční",
    "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů": "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů",
    "Registrace": "Registrace",
    "Registrace proběhla úspěšně": "Registrace proběhla úspěšně",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!",
    "Registrace se nepovedla": "Registrace se nepovedla",
    "registrace-zdarma": "registrace-zdarma",
    "Registrace/Přihlášení": "Registrace/Přihlášení",
    "Registrovat se": "Registrovat se",
    "Resetování hesla": "Resetování hesla",
    "Resetovat": "Resetovat",
    "Resetovat fyzioterapeuty dle diagnózy": "Resetovat terapeuty dle diagnózy",
    "Resetovat heslo": "Resetovat heslo",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Řešíte jiný problém?": "Řešíte jiný problém?",
    "Rezarvace byla úspěšně změněna na": "Rezarvace byla úspěšně změněna na",
    "rezervace": "rezervace",
    "Rezervace": "Rezervace",
    "Rezervace byla úspěšně vytvořena.": "Rezervace byla úspěšně vytvořena.",
    "Rezervace byla zrušena": "Rezervace byla zrušena",
    "Rezervace nemohla být vytvořena": "Rezervace nemohla být vytvořena",
    "Rezervace pacienta jsou povoleny": "Rezervace klienta jsou povoleny",
    "Rezervace pacienta jsou zablokovány": "Rezervace klienta jsou zablokovány",
    "Rezervace úspěšně vytvořena": "Rezervace úspěšně vytvořena",
    "Rezervaci již nelze zrušit online": "Rezervaci již nelze zrušit online",
    "Rezervaci můžete zrušit do": "Rezervaci můžete zrušit do",
    "Rezervaci nelze zrušit online": "Rezervaci nelze zrušit online",
    "Rezervaci se nepodařilo zrušit": "Rezervaci se nepodařilo zrušit",
    "Rezervovat": "Rezervovat",
    "Rezervujte si termín": "Rezervujte si termín",
    "Rezervujte si termín u": "Rezervujte si termín u",
    "Režim zobrazení": "Režim zobrazení",
    "Roční": "Roční",
    "Rodné číslo": "Rodné číslo",
    "Rodné číslo pacienta": "Rodné číslo",
    "Rodné číslo:": "Rodné číslo:",
    "Rok": "Rok",
    "Roky": "Roky",
    "Role": "Role",
    "Rozpis termínů fyzioterapie": "Rozpis termínů terapie",
    "Rozpracovaná návštěva uložena": "Rozpracovaná návštěva uložena",
    "Rozpracované podání bylo smazáno": "Rozpracované podání bylo smazáno",
    "Rozpracované podání se nepodařilo smazat": "Rozpracované podání se nepodařilo smazat",
    "Rozvrh místností": "Rozvrh místností",
    "s GDPR, klikněte níže na tlačítko": "s GDPR, klikněte níže na tlačítko",
    "S jakým problémem k nám přicházíte?": "S jakým problémem k nám přicházíte?",
    "S nezaplacenými návštěvami": "S nezaplacenými návštěvami",
    "Šablon na stránku": "Šablon na stránku",
    "Šablona byla úspěšně aktualizována": "Šablona byla úspěšně aktualizována",
    "Šablona byla úspěšně smazána": "Šablona byla úspěšně smazána",
    "Šablona byla úspěšně vytvořena": "Šablona byla úspěšně vytvořena",
    "sablony": "sablony",
    "Šablony": "Šablony",
    "Sada cviků byla odeslána klientovi": "Sada cviků byla odeslána klientovi",
    "Sazba DPH": "Sazba DPH",
    "Sdílejte": "Sdílejte",
    "SDÍLEJTE NÁS": "SDÍLEJTE NÁS",
    "sdílet": "sdílet",
    "sdílet aplikaci": "sdílet aplikaci",
    "Sklad": "Sklad",
    "Skrýt": "Skrýt",
    "Skupinová návštěva": "Skupinová návštěva",
    "Skupinovka": "Skupinovka",
    "Skutečně si přejete změnit tarif?": "Skutečně si přejete změnit tarif?",
    "Sloučení karet": "Sloučení karet",
    "Sloučit karty": "Sloučit karty",
    "Služba": "Služba",
    "Služba nenalezena": "Služba nenalezena",
    "Služba:": "Služba:",
    "sluzby": "sluzby",
    "Služby": "Služby",
    "Služby dle kategorií celkem za rok": "Služby dle kategorií celkem za rok",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Služby nebudou smazány, kategorie jim bude pouze odebrána.",
    "Služby:": "Služby:",
    "Smazání": "Smazání",
    "Smazání obrázku se nezdařilo": "Smazání obrázku se nezdařilo",
    "Smazáno": "Smazáno",
    "Smazat": "Smazat",
    "Smazat cvik": "Smazat cvik",
    "Smazat dodavatele": "Smazat dodavatele",
    "Smazat formulář": "Smazat formulář",
    "Smazat fotku": "Smazat fotku",
    "Smazat fotografii": "Smazat fotografii",
    "Smazat kategorii cviků": "Smazat kategorii cviků",
    "Smazat kategorii služeb": "Smazat kategorii služeb",
    "Smazat návštěvu": "Smazat návštěvu",
    "Smazat obrázek": "Smazat obrázek",
    "Smazat permanentku": "Smazat permanentku",
    "Smazat podání": "Smazat podání",
    "Smazat pojišťovnu": "Smazat pojišťovnu",
    "Smazat položku": "Smazat položku",
    "Smazat pouze toto volno": "Smazat pouze toto volno",
    "Smazat pouze tuto návštěvu": "Smazat pouze tuto návštěvu",
    "Smazat pracoviště": "Smazat pracoviště",
    "Smazat předplatné": "Smazat předplatné",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Smazat přihlašovací údaje k portálu %{portal}?",
    "Smazat recenzi": "Smazat recenzi",
    "Smazat rozpracované podání": "Smazat rozpracované podání",
    "Smazat rozpracované podání?": "Smazat rozpracované podání?",
    "Smazat šablonu": "Smazat šablonu",
    "Smazat službu": "Smazat službu",
    "Smazat soubor": "Smazat soubor",
    "Smazat stávající zápis": "Smazat stávající zápis",
    "Smazat toto a všechna budoucí volna": "Smazat toto a všechna budoucí volna",
    "Smazat tuto a všechny budoucí návštěvy": "Smazat tuto a všechny budoucí návštěvy",
    "Smazat video": "Smazat video",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu",
    "Smluvní pojištění": "Smluvní pojištění",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS byla úspěšně odeslána",
    "SMS byly úspěšně odeslána": "SMS byly úspěšně odeslána",
    "SMS čekajícímu": "SMS čekajícímu",
    "SMS kód": "SMS kód",
    "SMS kód se nepodařilo vyžádat": "SMS kód se nepodařilo vyžádat",
    "SMS se nepodařilo odeslat": "SMS se nepodařilo odeslat",
    "Sobota": "Sobota",
    "Soubor se nepodařilo stáhnout": "Soubor se nepodařilo stáhnout",
    "Soubory úspěšně nahrány": "Fotografie úspěšně nahrána",
    "Současné heslo": "Současné heslo",
    "Souhlas s GDPR": "Souhlas s GDPR",
    "Souhlas s novinkami:": "Souhlas s novinkami:",
    "Souhlas udělen": "Souhlas udělen",
    "Souhlasil s novinkami": "Souhlasil s novinkami",
    "Souhlasili": "Souhlasili",
    "Souhlasím s vytvořením karty pacienta v souladu s": "Souhlasím s vytvořením karty klienta v souladu s",
    "Souhlasím se": "Souhlasím se",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "Souhlasím se zasíláním novinek a zajímavých nabídek",
    "Splatnost": "Splatnost",
    "Splatnost faktury": "Splatnost faktury",
    "Spočítat": "Spočítat",
    "Stačí": "Stačí",
    "Stáhnout": "Stáhnout",
    "Stáhnout fakturu": "Stáhnout fakturu",
    "Stáhnout soubory": "Stáhnout soubory",
    "Stáhnout zálohovou fakturu": "Stáhnout zálohovou fakturu",
    "STATISTICS": "STATISTICS",
    "Statistiky": "Statistiky",
    "Status": "Status",
    "Stav": "Stav",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.",
    "Stav návštěvy byl změněn": "Stav návštěvy byl změněn",
    "Stav platby": "Stav platby",
    "Storno": "Storno",
    "stornovanou fakturu č.": "stornovanou fakturu č.",
    "stornovaný paragon č.": "stornovaný paragon č.",
    "Stornovat": "Stornovat",
    "stránka někam utekla...": "stránka někam utekla...",
    "Středa": "Středa",
    "Stvrzenek na stránku": "Stvrzenek na stránku",
    "svůj prohlížeč nebo si nainstalujte jiný.": "svůj prohlížeč nebo si nainstalujte jiný.",
    "Synchronizace kalendáře byla zrušena": "Synchronizace kalendáře byla zrušena",
    "Synchronizace s Google kalendářem": "Synchronizace s Google kalendářem",
    "Synchronizace se nezdařila": "Synchronizace se nezdařila",
    "synchronizace-kalendare": "synchronizace-kalendare",
    "Synchronizovat události z Google kalendáře do Fyzionu": "Synchronizovat události z Google kalendáře do CortexApp kalendáře",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Synchronizujte svůj CortexApp kalendář s kalendářem Google",
    "Tarif": "Tarif",
    "Tarify": "Tarify",
    "Tato funkce je dostupná pouze v placeném tarifu.": "Tato funkce je dostupná pouze v placeném tarifu.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "Tato funkce je dostupná pouze ve vyšších tarifech. Tyoy tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.",
    "Tato karta se smaže.": "Tato karta se smaže.",
    "Tato přihlašovací stránka je určena pouze terapeutům.": "Tato přihlašovací stránka je určena pouze terapeutům.",
    "Tel.:": "Tel.:",
    "Telefon": "Telefon",
    "Telefonní číslo": "Telefonní číslo",
    "Telefonní číslo:": "Telefonní číslo:",
    "Tento měsíc": "Tento měsíc",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "Tento klient má nezaplacenou návštěvu, která nebyla omluvená.",
    "Tento rok": "Tento rok",
    "Tento týden": "Tento týden",
    "Termín můžete přesunout do": "Termín můžete přesunout do",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.",
    "Text": "Text",
    "Těžší varianta": "Těžší varianta",
    "theme_company": "Cortexapp",
    "Tisk": "Tisk",
    "Tisk GDPR": "Tisk GDPR",
    "Tisk karty pacienta": "Tisk karty klienta",
    "Tisk návštěv": "Tisk návštěv",
    "Tisk návštěvy": "Tisk návštěvy",
    "Tisk rozpisu termínů návštěv": "Tisk rozpisu termínů návštěv",
    "Toto okno můžete zavřít.": "Toto okno můžete zavřít.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "Toto podání už na autorizaci nečeká, mezitím se dokončilo.",
    "Toto pole je povinné": "Toto pole je povinné",
    "Trvání služby v minutách": "Trvání služby v minutách",
    "týden": "týden",
    "Týdně": "Týdně",
    "týdnů": "týdnů",
    "týdny": "týdny",
    "Týdny": "Týdny",
    "Typ dokladu": "Typ dokladu",
    "Typ permanentky": "Typ permanentky",
    "Typ platby": "Typ platby",
    "Typ připojištění": "Typ připojištění",
    "Typ připojištění:": "Typ připojištění:",
    "Typ šablony": "Typ šablony",
    "Typ transakce": "Typ transakce",
    "Typ výkonu": "Typ výkonu",
    "Typ vyšetření": "Služba",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí klienti, uděláte v ",
    "Tyto údaje vyplňte pouze v případě, že chcete dávky pojišťovnám odesílat s ověřením přihlašovacími údaji a SMS kódem. Pokud dávky podepisujete certifikátem ve Fyzion Signeru, vyplňovat je nemusíte. Účet na portálu musí mít zapnuté přihlášení pomocí SMS.": "Tyto údaje vyplňte pouze v případě, že chcete dávky pojišťovnám odesílat s ověřením přihlašovacími údaji a SMS kódem. Pokud dávky podepisujete certifikátem v CortexApp Signeru, vyplňovat je nemusíte. Účet na portálu musí mít zapnuté přihlášení pomocí SMS.",
    "Účast pacienta": "Účast klienta",
    "Údaje instituce": "Fakturační údaje",
    "Údaje o pojištění": "Údaje o pojištění",
    "Údaje pro platbu převodem": "Údaje pro platbu převodem",
    "Údaje úspěšně změněny": "Údaje úspěšně změněny",
    "Úhloměr": "Úhloměr",
    "Uhradit": "Uhradit",
    "Uhrazeno": "Uhrazeno",
    "Ukázat cvik": "Ukázat cvik",
    "Ulice": "Ulice",
    "Ulice a č. p.": "Ulice a č. p.",
    "Ulice a č.p.": "Ulice a č.p.",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.",
    "Uložené šablony": "Uložené šablony",
    "Uloženo": "Uloženo",
    "uložit": "uložit",
    "Uložit": "Uložit",
    "Uložit a zamknout": "Uložit a zamknout",
    "Uložit jako PDF do karty pacienta": "Uložit jako PDF do karty klienta",
    "Uložit rozpracované": "Uložit rozpracované",
    "Uložit změny": "Uložit změny",
    "Úprava": "Úprava",
    "Úprava příští návštěvy": "Úprava příští návštěvy",
    "upravit": "upravit",
    "Upravit": "Upravit",
    "Upravit cvik": "Upravit cvik",
    "Upravit dodavatele": "Upravit dodavatele",
    "Upravit dostupnost": "Upravit dostupnost",
    "Upravit fakturaci": "Upravit fakturaci",
    "Upravit FT poukaz": "Upravit FT poukaz",
    "Upravit fyzioterapeuta": "Upravit terapeuta",
    "Upravit kategorii": "Upravit kategorii",
    "Upravit kategorii cviků": "Upravit kategorii cviků",
    "Upravit kategorii služeb": "Upravit kategorii služeb",
    "Upravit místnost": "Upravit místnost",
    "Upravit ordinační hodiny": "Upravit ordinační hodiny",
    "Upravit pacientovu permanentku": "Upravit klientovu permanentku",
    "Upravit permanentku": "Upravit permanentku",
    "Upravit platbu č.": "Upravit platbu č.",
    "Upravit podkategorii": "Upravit podkategorii",
    "Upravit pojišťovnu": "Upravit pojišťovnu",
    "Upravit položku": "Upravit položku",
    "Upravit pracoviště": "Upravit pracoviště",
    "Upravit pracoviště žadatele": "Upravit pracoviště žadatele",
    "Upravit šablonu": "Upravit šablonu",
    "Upravit službu": "Upravit službu",
    "Upravit uživatele": "Upravit uživatele",
    "Upravit žadatele": "Upravit žadatele",
    "upravit-ft-poukaz/:ticketId": "upravit-ft-poukaz/:ticketId",
    "upravit-permanentku/:ticketId": "upravit-permanentku/:ticketId",
    "upravit-volno": "upravit-volno",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Určuje maximální počet klientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu klientů.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.",
    "user.form.role.worker.tooltip": "Uživatel má přístup ke klientům, kalendáři, ale ne k nastavení vaší aplikace",
    "Úspěšně nahrána dávka do Purobota": "Úspěšně nahrána dávka do Purobota",
    "Úterý": "Úterý",
    "Už mám odcvičeno:": "Už mám odcvičeno:",
    "Územní pracoviště VZP": "Územní pracoviště VZP",
    "Uživatel": "Uživatel",
    "Uživatel byl deaktivován": "Uživatel byl deaktivován",
    "Uživatel byl úspěšně přidán": "Uživatel byl úspěšně přidán",
    "V historii cvičení nejsou žádné záznamy.": "V historii cvičení nejsou žádné záznamy.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "V historii rezervací zatím není žádná absolvovaná návštěva.",
    "V měsících, ode dne zakoupení": "V měsících, ode dne zakoupení",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na",
    "V ordinaci hotově/kartou": "V ordinaci hotově/kartou",
    "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.": "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "V případě, že je tato volba zapnuta, klientům automaticky odchází i stvrzenky za zakoupené permanentky.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet klientů v aplikaci.",
    "V případě, že se nemůžete dostavit, volejte na": "V případě, že se nemůžete dostavit, volejte na",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "V tomto období se počet návštěv u každého z terapeutů rovná nule",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "Vám navýšíme limit kartotéky klientů v balíčku Freemium.",
    "Variabilní symbol": "Variabilní symbol",
    "Variabilní symbol:": "Variabilní symbol:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Váš prohlížeč nepodporuje datový formát tohoto videa.",
    "vaše číslo účtu nebo IBAN.": "vaše číslo účtu nebo IBAN.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.",
    "Vaše kategorie služeb byla smazána": "Vaše kategorie služeb byla smazána",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Cortex.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "Vaše rodné číslo potřebujeme k vytvoření vaší karty klienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.",
    "Vaše služba byla smazána": "Vaše služba byla smazána",
    "Vaše zpráva": "Vaše zpráva",
    "Vaši rezervaci už nelze zrušit online!": "Vaši rezervaci už nelze zrušit online!",
    "Včera": "Včera",
    "včetně prodeje zboží": "včetně prodeje zboží",
    "Veřejné zdravotní pojištění": "Veřejné zdravotní pojištění",
    "Více informací": "Více informací",
    "Video": "Video",
    "Video a obrázky cviku": "Video a obrázky cviku",
    "Visa ikona": "Visa ikona",
    "Vítáme vás v aplikaci Fyzion": "Vítáme vás v CortexApp",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Vítejte na přihlašovací stránce klientského portálu CortexApp.",
    "Vítejte v CortexApp": "Vítejte v CortexApp",
    "Vložit pod stávající zápis": "Vložit pod stávající zápis",
    "Volno (Dovolená)": "Volno (Dovolená)",
    "Volno odstraněno": "Volno odstraněno",
    "Vrátit do průvodce?": "Vrátit do průvodce?",
    "Vše": "Vše",
    "Všechny": "Všechny",
    "Všechny doklady": "Všechny doklady",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy klientovi ani se Vám nebude klient nabízet v seznamu klientů.",
    "Všechny pracoviště": "Všechny pracoviště",
    "Všechny typy služeb": "Všechny typy služeb",
    "Všeobecné obchodní podmínky": "Všeobecné obchodní podmínky",
    "všeobecnými obchodními podmínkami": "všeobecnými obchodními podmínkami",
    "Všeobecnými obchodními podmínkami": "Všeobecnými obchodními podmínkami",
    "Všichni": "Všichni",
    "Všichni pacienti": "Všichni klienti",
    "Vyberte": "Vyberte",
    "Vyberte alespoň jednu službu": "Vyberte alespoň jednu službu",
    "Vyberte obrázky": "Vyberte obrázky",
    "Vyberte pacienta": "Vyberte klienta",
    "Vyberte předplatné": "Vyberte předplatné",
    "Vyberte prosím alespoň 1 fotografii.": "Vyberte prosím alespoň 1 fotografii.",
    "Vyberte šablonu": "Vyberte šablonu",
    "Vyberte soubor": "Vyberte soubor",
    "Vyberte termín": "Vyberte termín",
    "Vyberte video": "Vyberte video",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Vybrané dávky elektronicky podepíšete v aplikaci CortexApp Signer — jedním podpisem, v němž dávky nejprve projdete. CortexApp je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.",
    "Vybrané termíny": "Vybrané termíny",
    "Vybráno cviků": "Vybráno cviků",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.",
    "Vybrat": "Vybrat",
    "Vybrat barvu": "Vybrat barvu",
    "Vybrat diagnózu": "Vybrat diagnózu",
    "Vybrat dodavatele": "Vybrat dodavatele",
    "Vybrat druh péče": "Vybrat druh péče",
    "Vybrat druh úhrady": "Vybrat druh úhrady",
    "Vybrat IČP": "Vybrat IČP",
    "Vybrat kategorii": "Vybrat kategorii",
    "Vybrat kód": "Vybrat kód",
    "Vybrat období": "Vybrat období",
    "Vybrat odbornost": "Vybrat odbornost",
    "Vybrat ostatní diagnózy": "Vybrat ostatní diagnózy",
    "Vybrat pacienta": "Vybrat klienta",
    "Vybrat podkategorii": "Vybrat podkategorii",
    "Vybrat pracoviště": "Vybrat pracoviště",
    "Vybrat pracovníky": "Vybrat pracovníky",
    "Vybrat správnou kartu": "Vybrat správnou kartu",
    "Vybrat vše": "Vybrat vše",
    "Vybrat výkon": "Vybrat výkon",
    "Výchozí": "Výchozí",
    "Výchozí šablona": "Výchozí šablona",
    "Vyčistit filtr": "Vyčistit filtr",
    "Vygenerovat fakturu": "Vygenerovat fakturu",
    "Vyhledat": "Vyhledat",
    "Výkon": "Výkon",
    "Výkon je odemknutý": "Výkon je odemknutý",
    "Výkon je zamknutý": "Výkon je zamknutý",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "Výkon nelze upravit, protože je již přiřazen k návštěvě.",
    "Výkonová": "Výkonová",
    "výkonů": "výkonů",
    "Výkonů na stránku": "Výkonů na stránku",
    "vykony": "vykony",
    "Výkony": "Výkony",
    "Výkony nezapsané na návštěvě budou smazány.": "Výkony nezapsané na návštěvě budou smazány.",
    "Vyplňte ve formátu +420 123 456 789": "Vyplňte ve formátu +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Vyplňte ve formátu DD.MM.RRRR",
    "Vyplňte ve formátu HH:mm": "Vyplňte ve formátu HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Vyplňte, pokud klient změnil pojišťovnu, abychom mohli správně vytvořit dávku.",
    "Výše kreditu:": "Výše kreditu:",
    "Výše max. úhrady": "Výše max. úhrady",
    "Výše max. úhrady:": "Výše max. úhrady:",
    "Výše paušálu:": "Výše paušálu:",
    "Vyšetřil:": "Vyšetřil:",
    "výskytech": "výskytech",
    "výskytu": "výskytu",
    "vytisknout": "vytisknout",
    "Vytvoření": "Vytvoření",
    "Vytvořeno": "Vytvořeno",
    "Vytvořit": "Vytvořit",
    "Vytvořit 3 návštěvy": "Vytvořit 3 návštěvy",
    "Vytvořit dávku": "Vytvořit dávku",
    "Vytvořit dávky": "Vytvořit dávky",
    "Vytvořit faktury": "Vytvořit faktury",
    "Vytvořit novou kategorii": "Vytvořit novou kategorii",
    "Vytvořit novou podkategorii": "Vytvořit novou podkategorii",
    "Vytvořit novou rezervaci": "Vytvořit novou rezervaci",
    "Vytvořit novou službu": "Vytvořit novou službu",
    "Vytvořit nový cvik": "Vytvořit nový cvik",
    "Vytvořit opravnou dávku": "Vytvořit opravnou dávku",
    "Vytvořit platbu": "Vytvořit platbu",
    "Vytvořit rezervaci": "Vytvořit rezervaci",
    "Vytvořit zprávu": "Vytvořit zprávu",
    "Využívat klientský portál": "Využívat klientský portál",
    "Vyžádat SMS kód": "Vyžádat SMS kód",
    "Vyzkoušejte Fyzion Zdarma!": "Vyzkoušejte CortexApp Zdarma!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Vyzkoušejte CortexApp zdarma a objevte, jak vám může usnadnit práci. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Kdykoliv později můžete jednoduše přejít na vyšší tarif.",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Vždy uvádějte jméno klienta (i v případě dítěte)",
    "Webinář": "Webinář",
    "white-mark": "white-mark",
    "x": "x",
    "z": "z",
    "z ceny aplikace": "z ceny aplikace",
    "z toho v hotovosti": "z toho v hotovosti",
    "Začínáme": "Začínáme",
    "Zadané telefonní číslo je neplatné.": "Zadané telefonní číslo je neplatné.",
    "zadatele": "zadatele",
    "Žadatelé": "Žadatelé",
    "Žadatelé na stránku": "Žadatelé na stránku",
    "Zadejte nové heslo": "Zadejte nové heslo",
    "Zadejte platnou e-mailovou adresu": "Zadejte platnou e-mailovou adresu",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.",
    "Zadejte validní tel. číslo": "Zadejte validní tel. číslo",
    "Žádná služba není k dispozici": "Žádná služba není k dispozici",
    "Žádné akce k zobrazení": "Žádné akce k zobrazení",
    "Žádné dávky k zobrazení": "Žádné dávky k zobrazení",
    "Žádné doklady k zobrazení": "Žádné doklady k zobrazení",
    "Žádné návštěvy k zobrazení": "Žádné návštěvy k zobrazení",
    "Žádné stvrzenky k zobrazení": "Žádné stvrzenky k zobrazení",
    "Žádné výkony k zobrazení": "Žádné výkony k zobrazení",
    "Žádné výsledky": "Žádné výsledky",
    "Žádné zpráva k zobrazení": "Žádné zpráva k zobrazení",
    "Žádný fyzioterapeut není dostupný": "Žádný terapeut není dostupný",
    "Zahrnuté služby": "Zahrnuté služby",
    "Základní diagnóza": "Základní diagnóza",
    "Zákonný zástupce": "Zákonný zástupce",
    "Zákonný zástupce:": "Zákonný zástupce:",
    "Zákres": "Zákres",
    "Zaměstnanci": "Zaměstnanci",
    "Zaměstnanec": "Uživatel",
    "Zamezit online rezervace:": "Zamezit online rezervace:",
    "Zamknutou návštěvu nelze měnit.": "Zamknutou návštěvu nelze měnit.",
    "Zaplaceno": "Zaplaceno",
    "zaplatit": "zaplatit",
    "Zaplatit": "Zaplatit",
    "Zaplatit pomocí QR kódu": "Zaplatit pomocí QR kódu",
    "Zaplatit QR kódem": "Zaplatit QR kódem",
    "Zaplaťte pomocí QR kódu": "Zaplaťte pomocí QR kódu",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Zaplaťte předplatným, jestliže ho některá instituce poskytuje",
    "Zapomněli jste heslo?": "Zapomněli jste heslo?",
    "Zapsáno": "Zapsáno",
    "Zapsat výkon": "Zapsat výkon",
    "zásadami zpracování osobních údajů": "zásadami zpracování osobních údajů",
    "Zásob na stránku": "Zásob na stránku",
    "zasoby": "zasoby",
    "Zásoby": "Zásoby",
    "Zásoby na skladě": "Zásoby na skladě",
    "Zatím nebyla nahrána žádná videa.": "Zatím nebyla nahrána žádná videa.",
    "Zatím nebyly nahrány žádné obrázky.": "Zatím nebyly nahrány žádné obrázky.",
    "Zatím nebyly vytvořeny žádné permanentky": "Zatím nebyly vytvořeny žádné permanentky",
    "Zatím nejsou nahrána žádná videa.": "Zatím nejsou nahrána žádná videa.",
    "Zatím nejsou naplánovány žádné cviky.": "Zatím nejsou naplánovány žádné cviky.",
    "Zatím nejsou žádné recenze.": "Zatím nejsou žádné recenze.",
    "Zatím nemáte naplánované žádné pacienty": "Zatím nemáte naplánované žádné klienty",
    "Zatím zde nejsou žádné cviky": "Zatím zde nejsou žádné cviky",
    "Zatím zde nejsou žádné položky": "Zatím zde nejsou žádné položky",
    "Zatím zde nejsou žádné předplatné": "Zatím zde nejsou žádné platby",
    "Zatím zde nejsou žádné proběhlé návštěvy": "Zatím zde nejsou žádné proběhlé návštěvy",
    "Zatím zde nejsou žádné šablony": "Zatím zde nejsou žádné šablony",
    "Zatím zde nejsou žádné služby": "Zatím zde nejsou žádné služby",
    "Zatím zde nejsou žádné zásoby": "Zatím zde nejsou žádné zásoby",
    "Zatím zde nejsou žádní dodavatelé": "Zatím zde nejsou žádní dodavatelé",
    "Zatím zde nejsou žádní pacienti": "Zatím zde nejsou žádní klienti",
    "Zavolat do ordinace": "Zavolat na pracoviště",
    "Zavolejte nám na telefon:": "Zavolejte nám na telefon:",
    "Zavřeno": "Zavřeno",
    "Zavřít": "Zavřít",
    "Zavřít menu": "Zavřít menu",
    "Zavřít platbu": "Zavřít platbu",
    "Zboží": "Zboží",
    "Zboží bylo úspěšně naskladněno": "Zboží bylo úspěšně naskladněno",
    "Zboží se nepodařilo naskladnit": "Zboží se nepodařilo naskladnit",
    "Zbývající počet znaků": "Zbývající počet znaků",
    "Zbývajících vstupů": "Zbývajících vstupů",
    "Zdá se, že nám hledaná": "Zdá se, že nám hledaná",
    "Zdarma": "Zdarma",
    "ZDARMA": "ZDARMA",
    "ZDE": "ZDE",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.",
    "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného pacienta nahráli": "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného klienta nahráli",
    "Zdravotní pojišťovna": "Zdravotní pojišťovna",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.",
    "Zelená": "Zelená",
    "Země": "Země",
    "Žena": "Žena",
    "Ženy": "Ženy",
    "Ženy (budoucí)": "Ženy (objednané)",
    "Zjistit více": "Zjistit více",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Zkontrolujte prosím zadanou adresu v prohlížeči.",
    "Zkopírováno": "Zkopírováno",
    "Zkopírovat": "Zkopírovat",
    "Zkopírovat odkaz do schránky": "Zkopírovat odkaz do schránky",
    "Zkopírovat odkaz na rezervaci této služby": "Zkopírovat odkaz na rezervaci této služby",
    "Žlutá": "Žlutá",
    "Změna hesla": "Změna hesla",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři",
    "Změna tarifu není možná": "Změna tarifu není možná",
    "Změnit": "Změnit",
    "Změnit heslo": "Změnit heslo",
    "Změnit stav na „%{status}“?": "Změnit stav na „%{status}“?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "Změnit typ platby nebo částku můžete v editaci plateb.",
    "Zobrazit": "Zobrazit",
    "Zobrazit méně": "Zobrazit méně",
    "zpět": "zpět",
    "Zpět": "Zpět",
    "Zpět do aplikace": "Zpět do aplikace",
    "Zpět na cviky": "Zpět na cviky",
    "Zpět na přihlášení": "Zpět na přihlášení",
    "Zpět na seznam dávek": "Zpět na seznam dávek",
    "Zpráva od terapeuta": "Zpráva od terapeuta",
    "Způsob platby": "Způsob platby",
    "Zrušená fakturace": "Zrušená fakturace",
    "Zrušená návštěva klienta": "Zrušená návštěva klienta",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.",
    "Zrušeno": "Zrušeno",
    "Zrušeno terapeutem": "Zrušeno terapeutem",
    "Zrušit": "Zrušit",
    "ZRUŠIT FILTR": "ZRUŠIT FILTR",
    "Zrušit návštěvu": "Zrušit návštěvu",
    "Zrušit platbu": "Zrušit platbu",
    "Zrušit rezervaci": "Zrušit rezervaci",
    "Zůstat na stránce": "Zůstat na stránce",
    "Zvolit": "Zvolit",
    "Zvolit fyzioterapeuta": "Zvolit terapeuta",
    "Zvolit službu": "Zvolit službu",
    "Zvolit typ služby": "Zvolit typ služby",
    "Zvolte alespoň jeden výkon": "Zvolte alespoň jeden výkon",
    "Zvolte alespoň jednu pojišťovnu": "Zvolte alespoň jednu pojišťovnu",
    "Zvolte čas": "Zvolte čas",
    "Zvolte datum": "Zvolte datum"
  }
}
